"use strict";
(self["webpackChunkapp_bedrock_rdk"] = self["webpackChunkapp_bedrock_rdk"] || []).push([[996],{

/***/ 19917:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var AdapterConstants = __webpack_require__(76917);
var Chrono = __webpack_require__(92747);
var AdapterAdsMixin = {
    /** Override to return current ad position */ getPosition: function getPosition() {
        return null;
    },
    /** Override to return the given ad structure (list with number of pre, mid, and post breaks) */ getGivenBreaks: function getGivenBreaks() {
        return null;
    },
    /** Override to return the ad structure requested (list with number of pre, mid, and post breaks) */ getExpectedBreaks: function getExpectedBreaks() {
        return null;
    },
    /** Override to return the structure of ads requested */ getExpectedPattern: function getExpectedPattern() {
        return null;
    },
    /** Override to return a list of playheads of ad breaks begin time */ getBreaksTime: function getBreaksTime() {
        return null;
    },
    /** Override to return the number of ads given for the break */ getGivenAds: function getGivenAds() {
        return null;
    },
    /** Override to return the number of ads requested for the break */ getExpectedAds: function getExpectedAds() {
        return null;
    },
    /** Override to return if the ad is being shown in the screen or not
   * The standard definition is: more than 50% of the pixels of the ad are on the screen
   */ getIsVisible: function getIsVisible() {
        return true;
    },
    /** Override to return a boolean showing if the audio is enabled when the ad begins */ getAudioEnabled: function getAudioEnabled() {
        return null;
    },
    /** Override to return if the ad is skippable */ getIsSkippable: function getIsSkippable() {
        return null;
    },
    /** Override to return a boolean showing if the player is in fullscreen mode when the ad begins */ getIsFullscreen: function getIsFullscreen() {
        return null;
    },
    /** Override to return the ad campaign */ getCampaign: function getCampaign() {
        return null;
    },
    /** Override to return the ad creative id */ getCreativeId: function getCreativeId() {
        return null;
    },
    /** Override to return the ad provider name */ getProvider: function getProvider() {
        return null;
    },
    /** Override to return the ad insertion type
   * Use constants:
   * youbora.Constants.AdInsertionType.ClientSide
   * youbora.Constants.AdInsertionType.ServerSide
  */ getAdInsertionType: function getAdInsertionType() {
        return null;
    },
    /**
 * Emits related event and set flags if current status is valid.
 * ie: won't sent start if isStarted is already true.
 *
 * @param {Object} [params] Object of key:value params to add to the request.
 */ fireClick: function fireClick(params) {
        if (typeof params === "string") {
            params = {
                url: params
            };
        }
        this.emit(AdapterConstants.Event.CLICK, {
            params: params
        });
    },
    /**
   * Emits related event and set flags if current status is valid.
   * ie: won't sent start if isStarted is already true.
   *
   * @param {Object} [params] Object of key:value params to add to the request.
   */ fireQuartile: function fireQuartile(quartile) {
        if (this.flags.isStarted && typeof quartile === "number" && quartile > this.flags.lastQuartileSent && quartile < 4) {
            this.flags.lastQuartileSent++;
            this.emit(AdapterConstants.Event.QUARTILE, {
                params: {
                    quartile: quartile
                }
            });
        }
    },
    /**
  * Starts a new chrono for viewedMax and restarts viewedAcum
  */ startChronoView: function startChronoView() {
        if (this.getIsVisible() && !this.plugin.backgroundDetector.isInBackground) {
            var max = this.chronos.viewedMax;
            if (max.length === 0 || max[max.length - 1].stopTime !== 0) {
                max.push(new Chrono());
                max[max.length - 1].start();
            }
        }
    },
    /**
  * Stops a new chrono for viewedMax and restarts viewedAcum
  */ stopChronoView: function stopChronoView() {
        var max = this.chronos.viewedMax;
        if (max[0] && max.length > 0 && max[max.length - 1].stopTime === 0) {
            max[max.length - 1].stop();
        }
    },
    /**
  * @param {Object} [params] Object of key:value params to add to the request.
  */ fireManifest: function fireManifest(params, message) {
        var paramsObject = {
            params: params
        };
        if (typeof params === "string") {
            paramsObject = {
                params: {
                    errorType: params,
                    errorMessage: message
                }
            };
        }
        this.emit(AdapterConstants.Event.MANIFEST, paramsObject);
    },
    /*
  * Emits related event and set flags if current status is valid.
  * ie: won't sent start if isStarted is already true.
  *
  * @param {Object} [params] Object of key:value params to add to the request.
  */ fireSkip: function fireSkip(params) {
        if (params === undefined) {
            params = {};
        }
        params.skipped = true;
        this.fireStop(params);
    },
    /**
  * Emits related event and set flags if current status is valid.
  * ie: won't sent start if isStarted is already true.
  *
  * @param {Object} [params] Object of key:value params to add to the request.
  */ fireBreakStart: function fireBreakStart(params) {
        this.emit(AdapterConstants.Event.PODSTART, {
            params: params
        });
    },
    /**
  * Emits related event and set flags if current status is valid.
  * ie: won't sent start if isStarted is already true.
  *
  * @param {Object} [params] Object of key:value params to add to the request.
  */ fireBreakStop: function fireBreakStop(params) {
        this.emit(AdapterConstants.Event.PODSTOP, {
            params: params
        });
    }
};
module.exports = AdapterAdsMixin;


/***/ }),

/***/ 41850:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
var AdapterConstants = __webpack_require__(76917);
var Log = __webpack_require__(39610);
var AdapterContentMixin = {
    /** Override to return current playrate */ getPlayrate: function getPlayrate() {
        return !this.flags.isPaused ? 1 : 0;
    },
    /** Override to return Frames Per Secon (FPS) */ getFramesPerSecond: function getFramesPerSecond() {
        return null;
    },
    /** Override to return dropped frames since start */ getDroppedFrames: function getDroppedFrames() {
        return null;
    },
    /** Override to return user bandwidth throughput */ getThroughput: function getThroughput() {
        return null;
    },
    /** Override to return rendition */ getRendition: function getRendition() {
        return null;
    },
    /** Override to return title2 */ getTitle2: function getTitle2() {
        return null;
    },
    /** Override to recurn true if live and false if VOD */ getIsLive: function getIsLive() {
        return null;
    },
    /** Override to return CDN traffic bytes not using streamroot or peer5. */ getCdnTraffic: function getCdnTraffic() {
        return null;
    },
    /** Override to return P2P traffic bytes not using streamroot or peer5. */ getP2PTraffic: function getP2PTraffic() {
        return null;
    },
    /** Override to return P2P traffic sent in bytes, not using streamroot or peer5. */ getUploadTraffic: function getUploadTraffic() {
        return null;
    },
    /** Override to return if P2P is enabled not using streamroot or peer5. */ getIsP2PEnabled: function getIsP2PEnabled() {
        return null;
    },
    /** Override to return video segment duration. */ getSegmentDuration: function getSegmentDuration() {
        return null;
    },
    /** Override to return household id */ getHouseholdId: function getHouseholdId() {
        return null;
    },
    /** Override to return the latency */ getLatency: function getLatency() {
        return null;
    },
    /** Override to return the number of packets lost */ getPacketLoss: function getPacketLoss() {
        return null;
    },
    /** Override to return the number of packets sent */ getPacketSent: function getPacketSent() {
        return null;
    },
    /** Override to return a json with metrics */ getMetrics: function getMetrics() {
        return null;
    },
    /** Override to return the audio codec */ getAudioCodec: function getAudioCodec() {
        return null;
    },
    /** Override to return the video codec */ getVideoCodec: function getVideoCodec() {
        return null;
    },
    /** Override to return a chunk or intermediate manifest url */ getURLToParse: function getURLToParse() {
        return null;
    },
    /**
 * Emits related event and set flags if current status is valid.
 * ie: won't sent start if isStarted is already true.
 *
 * @param {Object} [params] Object of key:value params to add to the request.
 * @param {bool} [convertFromBuffer=true] If false, will convert current buffer to seek.
 * @param {string} [triggeredEvent]
 */ fireSeekBegin: function fireSeekBegin(params, convertFromBuffer, triggeredEvent) {
        // First, discard false buffers triggered by state changed before seek
        this._discardFalseBuffers();
        if (this.plugin && this.plugin.getIsLive() && this.plugin.options["content.isLive.noSeek"]) return null;
        if (this.flags.isJoined && !this.flags.isSeeking) {
            if (this.flags.isBuffering) {
                if (convertFromBuffer !== false) {
                    Log.notice("Converting current buffer to seek");
                    this.chronos.seek = this.chronos.buffer.clone();
                    this.chronos.buffer.reset();
                    this.flags.isBuffering = false;
                } else {
                    return;
                }
            } else {
                this.chronos.seek.start();
            }
            try {
                // Create new seek empty structure to add event to detect seek begins
                this.fireEventsStruct.seek = [];
                if (triggeredEvent) {
                    this.fireEventsStruct.seek.push(triggeredEvent);
                } else {
                    this.fireEventsStruct.seek.push("undefinedEvent");
                }
            } catch (e) {}
            this.flags.isSeeking = true;
            this.emit(AdapterConstants.Event.SEEK_BEGIN, {
                params: params
            });
        }
    },
    /**
   * Emits related event and set flags if current status is valid.
   * ie: won't sent start if isStarted is already true.
   *
   * @param {Object} [params] Object of key:value params to add to the request.
   * @param {string} [triggeredEvent]
   */ fireSeekEnd: function fireSeekEnd(params, triggeredEvent) {
        if (this.plugin && this.plugin.getIsLive() && this.plugin.options["content.isLive.noSeek"]) return null;
        if (this.flags.isJoined && this.flags.isSeeking) {
            try {
                // Add triggered event to detect buffer ends
                if (triggeredEvent) {
                    this.fireEventsStruct.seek.push(triggeredEvent);
                } else {
                    this.fireEventsStruct.seek.push("undefinedEvent");
                }
            } catch (e) {}
            params = params || {};
            params.triggeredEvents = this.fireEventsStruct.seek;
            if (this._shouldSplitView()) {
                params.viewIndex = this.plugin.viewTransform._viewIndex;
            }
            this.cancelSeek();
            this.emit(AdapterConstants.Event.SEEK_END, {
                params: params
            });
        }
    },
    /**
   *
   * @param {Object} [params] Object of key:value params to add to the request.
   */ cancelSeek: function cancelSeek(params) {
        if (this.flags.isJoined && this.flags.isSeeking) {
            this.flags.isSeeking = false;
            this.chronos.seek.stop();
            if (this.monitor) this.monitor.skipNextTick();
        }
    },
    /**
 * Emits event request.
 *
 * @param {Object} [params] Object of key:value params to add to the request.
 */ fireEvent: function fireEvent(eventName, dimensions, values, topLevelDimensions, hasEndDatetime) {
        var returnparams = topLevelDimensions || {};
        returnparams.name = eventName || "";
        returnparams.dimensions = dimensions || {};
        returnparams.values = values || {};
        if (typeof hasEndDatetime !== "boolean") {
            hasEndDatetime = false;
        }
        if (hasEndDatetime) {
            returnparams.hasEndDatetime = hasEndDatetime;
        }
        this.emit(AdapterConstants.Event.VIDEO_EVENT, {
            params: returnparams
        });
    },
    /**
 * Emits event end request.
 *
 * @param {Object} [params] Object of key:value params to add to the request.
 */ fireEventEnd: function fireEventEnd(eventName) {
        var returnparams = {};
        returnparams.name = eventName || "";
        this.emit(AdapterConstants.Event.VIDEO_EVENT_END, {
            params: returnparams
        });
    }
};
module.exports = AdapterContentMixin;


/***/ }),

/***/ 28077:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
var Emitter = __webpack_require__(15885);
var Log = __webpack_require__(39610);
var Util = __webpack_require__(37280);
var version = __webpack_require__(29379);
var PlaybackChronos = __webpack_require__(75175);
var PlaybackFlags = __webpack_require__(24371);
var PlayheadMonitor = __webpack_require__(15501);
var StateMonitor = __webpack_require__(20520);
var AdapterConstants = __webpack_require__(76917);
var Adapter = Emitter.extend(/** @lends youbora.this.prototype */ {
    /**
     * Main Adapter class. All specific player adapters should extend this class specifying a player
     * class.
     *
     * The Adapter works as the 'glue' between the player and YOUBORA acting both as event
     * translator and as proxy for the {@link Plugin} to get info from the player.
     *
     * @constructs Adapter
     * @extends youbora.Emitter
     * @memberof youbora
     *
     * @param {object|string} player Either an instance of the player or a string containing an ID.
     */ constructor: function constructor(player) {
        /** An instance of {@link FlagStatus} */ this.flags = new PlaybackFlags();
        /** An instance of {@link ChronoStatus} */ this.chronos = new PlaybackChronos();
        /** A dictionary to store the events fired */ this.fireEventsStruct = {};
        this.fireEventsStruct.buffer = [];
        this.fireEventsStruct.seek = [];
        /** Reference to {@link PlayheadMonitor}. Helps the plugin detect buffers/seeks. */ this.monitor = null;
        /** Reference to {@link Plugin}. */ this.plugin = null;
        /** Reference to the player tag */ this.player = null;
        /** Defines if the adapter is used as adapter or adsAdapter */ this._isAdsAdapter = null;
        // Register player and event listeners
        this.setPlayer(player);
        /** Reference to the video/object tag, could be the same as the player. */ this.tag = this.player;
        Log.notice("Adapter " + this.getVersion() + " with Lib " + version + " is ready.");
    },
    /**
     * Sets a new player, removes the old listeners if needed.
     *
     * @param {Object} player Player to be registered.
     */ setPlayer: function setPlayer(player) {
        if (this.player) this.unregisterListeners();
        if (typeof player === "string" && typeof document !== "undefined") {
            this.player = document.getElementById(player);
        } else {
            this.player = player;
        }
        this.registerListeners();
    },
    /**
     * Override to create event binders.
     * It's a good practice when implementing a new Adapter to create intermediate methods and call
     * those when player events are detected instead of just calling the `fire*` methods. This
     * will allow future users of the Adapter to customize its behaviour by overriding these
     * methods.
     *
     * @example
     * registerListeners: function () {
     *  this.player.addEventListener('start', this.onStart.bind(this))
     * },
     *
     * onStart: function (e) {
     *  this.emit('start')
     * }
     */ registerListeners: function registerListeners() {},
    /**
     * Override to create event de-binders.
     *
     * @example
     * registerListeners: function () {
     *  this.player.removeEventListener('start', this.onStart)
     * }
     */ /** Unregister listeners to this.player. */ unregisterListeners: function unregisterListeners() {},
    /**
     * This function disposes the currend adapter, removes player listeners and drops references.
     */ dispose: function dispose() {
        // Stop Monitor and Network monitor
        this.stopMonitor();
        this.stopReadyStateMonitor();
        // Fire Stop
        this.fireStop();
        // Unregister listener
        this.unregisterListeners();
        this.player = null;
        this.tag = null;
    },
    /**
     * Creates a new {@link PlayheadMonitor} at this.monitor.
     *
     * @param {bool} monitorBuffers If true, it will monitor buffers.
     * @param {bool} monitorSeeks If true, it will monitor seeks.
     * @param {number} [interval=800] The interval time in ms.
     */ monitorPlayhead: function monitorPlayhead(monitorBuffers, monitorSeeks, interval) {
        this.stopMonitor();
        var type = 0;
        if (monitorBuffers) type |= PlayheadMonitor.Type.BUFFER;
        if (monitorSeeks) type |= PlayheadMonitor.Type.SEEK;
        if (!this.monitor || !this.monitor._timer.isRunning) {
            this.monitor = new PlayheadMonitor(this, type, interval);
        } else {
            this.monitor.skipNextTick();
        }
    },
    stopMonitor: function stopMonitor() {
        if (this.monitor) this.monitor.stop();
    },
    /**
     *
     * @param {number} [intervalMilliseconds=300]
     */ monitorReadyState: function monitorReadyState(intervalMilliseconds) {
        this.stopReadyStateMonitor();
        this.stateMonitor = new StateMonitor(this, intervalMilliseconds);
    },
    /**
     * Start ReadyState monitor
     */ startReadyStateMonitor: function startReadyStateMonitor() {
        if (this.stateMonitor) this.stateMonitor.start();
    },
    /**
     * Stop ReadyState monitor
     */ stopReadyStateMonitor: function stopReadyStateMonitor() {
        if (this.stateMonitor) this.stateMonitor.stop();
    },
    /**
     * Check readyState video properties
     * @param readyState
     * @param triggeredEvent
     */ checkReadyState: function checkReadyState(readyState, triggeredEvent) {
        try {
            if (this.plugin && this.plugin.getReadyStateMonitorEnabled()) {
                if (readyState) {
                    if (readyState > 3 && !this.flags.isSeeking) {
                        if (this.flags.isBuffering) {
                            this.fireBufferEnd({}, triggeredEvent + "-readyState");
                        } else if (!this.flags.isJoined) {
                            this.fireJoin({}, triggeredEvent + "-readyState");
                        }
                    } else if (readyState < 4 && !this.flags.isBuffering) {
                        this.fireBufferBegin({}, false, triggeredEvent + "-readyState", true);
                    }
                }
            }
        } catch (e) {
            Log.error("Can't check readyState property correctly");
        }
    },
    // GETTERS //
    /** Override to return current playhead of the video */ getPlayhead: function getPlayhead() {
        return null;
    },
    /** Override to return video duration */ getDuration: function getDuration() {
        return null;
    },
    /** Override to return current bitrate */ getBitrate: function getBitrate() {
        return null;
    },
    /** Override to return total downloaded bytes */ getTotalBytes: function getTotalBytes() {
        return null;
    },
    /** Override to return title */ getTitle: function getTitle() {
        return null;
    },
    /** Override to return resource URL. */ getResource: function getResource() {
        return null;
    },
    /** Override to return player version */ getPlayerVersion: function getPlayerVersion() {
        return null;
    },
    /** Override to return player's name */ getPlayerName: function getPlayerName() {
        return null;
    },
    /** Override to return adapter version. */ getVersion: function getVersion() {
        return version + "-generic-js";
    },
    /** Override to return video object */ getVideoObject: function getVideoObject() {
        return null;
    },
    // FLOW //
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent init if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */ fireInit: function fireInit(params, triggeredEvent) {
        if (this.plugin) this.plugin.fireInit(params, triggeredEvent);
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */ fireStart: function fireStart(params, triggeredEvent) {
        if (this.plugin && this.plugin.backgroundDetector && this.plugin.backgroundDetector.canBlockStartCalls()) {
            return null;
        }
        if (!this.flags.isStarted) {
            this.flags.isStarted = true;
            this.chronos.total.start();
            this.chronos.join.start();
            if (triggeredEvent) {
                params = params || {};
                params.triggeredEvents = [
                    triggeredEvent
                ];
            }
            this.startReadyStateMonitor();
            this.emit(AdapterConstants.Event.START, {
                params: params
            });
        }
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */ fireJoin: function fireJoin(params, triggeredEvent) {
        if (!this.flags.isJoined && !this.flags.isStarted && !this._isAds() && this.plugin && this.plugin.isInitiated) {
            this.fireStart({}, triggeredEvent);
        }
        if (this.flags.isStarted && !this.flags.isJoined) {
            this.flags.isStarted = true;
            if (this.monitor) this.monitor.start();
            this.flags.isJoined = true;
            this.chronos.join.stop();
            params = params || {};
            if (triggeredEvent) {
                params.triggeredEvents = [
                    triggeredEvent
                ];
            }
            if (this._shouldSplitView()) {
                params.viewIndex = this.plugin.viewTransform._viewIndex;
            }
            this.emit(AdapterConstants.Event.JOIN, {
                params: params
            });
        }
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */ firePause: function firePause(params, triggeredEvent) {
        // First, discard false buffers triggered by state changed before pause
        this._discardFalseBuffers();
        if (this.flags.isBuffering) {
            this.fireBufferEnd(null, "firePauseCall");
        }
        if (this.flags.isJoined && !this.flags.isPaused) {
            this.flags.isPaused = true;
            this.chronos.pause.start();
            params = params || {};
            if (triggeredEvent) {
                params.triggeredEvents = [
                    triggeredEvent
                ];
            }
            if (this._shouldSplitView()) {
                params.viewIndex = this.plugin.viewTransform._viewIndex;
            }
            this.emit(AdapterConstants.Event.PAUSE, {
                params: params
            });
        }
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */ fireResume: function fireResume(params, triggeredEvent) {
        // First, discard false buffers triggered by state changed before resume
        this._discardFalseBuffers();
        if (this.flags.isJoined && this.flags.isPaused) {
            this.flags.isPaused = false;
            this.chronos.pause.stop();
            if (this.monitor) this.monitor.skipNextTick();
            params = params || {};
            if (triggeredEvent) {
                params.triggeredEvents = [
                    triggeredEvent
                ];
            }
            if (this._shouldSplitView()) {
                params.viewIndex = this.plugin.viewTransform._viewIndex;
            }
            this.emit(AdapterConstants.Event.RESUME, {
                params: params
            });
        }
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {boolean} [convertFromSeek=false] If true, will convert current seek to buffer.
     * @param {string} [triggeredEvent]
     * @param {boolean} [triggeredByStateProperty]
     */ fireBufferBegin: function fireBufferBegin(params, convertFromSeek, triggeredEvent, triggeredByStateProperty) {
        triggeredByStateProperty = triggeredByStateProperty || false;
        if (this.flags.isJoined && !this.flags.isBuffering) {
            if (this.flags.isSeeking) {
                if (convertFromSeek) {
                    Log.notice("Converting current buffer to seek");
                    this.chronos.buffer = this.chronos.seek.clone();
                    this.chronos.seek.reset();
                    this.flags.isSeeking = false;
                } else {
                    return;
                }
            } else {
                this.chronos.buffer.start();
            }
            try {
                // Create new buffer empty structure to add event to detect buffer begins
                this.fireEventsStruct.buffer = [];
                if (triggeredEvent) {
                    this.fireEventsStruct.buffer.push(triggeredEvent);
                } else {
                    this.fireEventsStruct.buffer.push("undefinedEvent");
                }
            } catch (e) {}
            this.flags.isBuffering = true;
            this.flags.isVideoStateBuffering = triggeredByStateProperty;
            if (this._shouldSplitView()) {
                params = params || {};
                params.viewIndex = this.plugin.viewTransform._viewIndex;
            }
            this.emit(AdapterConstants.Event.BUFFER_BEGIN, {
                params: params
            });
        }
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */ fireBufferEnd: function fireBufferEnd(params, triggeredEvent) {
        if (this.flags.isJoined && this.flags.isBuffering) {
            try {
                // Add triggered event to detect buffer ends
                if (triggeredEvent) {
                    this.fireEventsStruct.buffer.push(triggeredEvent);
                } else {
                    this.fireEventsStruct.buffer.push("undefinedEvent");
                }
            } catch (e) {}
            params = params || {};
            params.triggeredEvents = this.fireEventsStruct.buffer;
            if (this._shouldSplitView()) {
                params.viewIndex = this.plugin.viewTransform._viewIndex;
            }
            this.cancelBuffer();
            this.emit(AdapterConstants.Event.BUFFER_END, {
                params: params
            });
        }
    },
    /**
     * Discard false buffer events from state changed
     * @private
     */ _discardFalseBuffers: function _discardFalseBuffers() {
        try {
            if (this.flags.isBuffering && this.flags.isVideoStateBuffering && this._getDeltaBufferTime() <= 100) {
                this.cancelBuffer();
            }
        } catch (e) {}
    },
    /**
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */ cancelBuffer: function cancelBuffer(params) {
        if (this.flags.isJoined && this.flags.isBuffering) {
            this.flags.isBuffering = false;
            this.flags.isVideoStateBuffering = false;
            this.chronos.buffer.stop();
            if (this.monitor) this.monitor.skipNextTick();
        }
    },
    /**
     * Get Delta buffer time
     * @returns {number|number|*}
     * @private
     */ _getDeltaBufferTime: function _getDeltaBufferTime() {
        if (this.chronos && this.chronos.buffer) {
            return this.chronos.buffer.getDeltaTime(false);
        }
        return 0;
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */ fireStop: function fireStop(params, triggeredEvent) {
        if (this._isAds() || this.plugin && this.plugin._isStopReady()) {
            if (this._isAds() && this.flags.isStarted || !this._isAds() && (this.flags.isStarted || this.plugin && this.plugin.isInitiated)) {
                // Stop Monitor and Network monitor
                this.stopMonitor();
                this.stopReadyStateMonitor();
                this.flags.reset();
                this.chronos.total.stop();
                this.chronos.join.reset();
                this.chronos.pause.stop();
                this.chronos.buffer.stop();
                this.chronos.seek.stop();
                params = params || {};
                if (triggeredEvent) {
                    params.triggeredEvents = [
                        triggeredEvent
                    ];
                }
                if (this._shouldSplitView()) {
                    params.viewIndex = this.plugin.viewTransform._viewIndex;
                }
                this.emit(AdapterConstants.Event.STOP, {
                    params: params
                });
                this.chronos.pause.reset();
                this.chronos.buffer.reset();
                this.chronos.seek.reset();
                this.chronos.viewedMax.splice(0, this.chronos.viewedMax.length);
            }
        }
    },
    setIsAds: function setIsAds(value) {
        this._isAdsAdapter = value;
    },
    _isAds: function _isAds() {
        return this._isAdsAdapter;
    },
    /**
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */ fireCasted: function fireCasted(params, triggeredEvent) {
        if (!params) params = {};
        params.casted = true;
        this.fireStop(params, triggeredEvent);
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
     * @param {string} [triggeredEvent]
     */ fireError: function fireError(code, msg, metadata, level, triggeredEvent) {
        var params = Util.buildErrorParams(code, msg, metadata, level);
        if (params.code) {
            delete params.code;
        }
        params = params || {};
        if (triggeredEvent) {
            params.triggeredEvents = [
                triggeredEvent
            ];
        }
        if (this._shouldSplitView()) {
            params.viewIndex = this.plugin.viewTransform._viewIndex;
        }
        var options = this.plugin ? this.plugin.options : {};
        if (typeof params.errorCode !== "undefined" && options["errors.ignore"] && options["errors.ignore"].indexOf(params.errorCode.toString()) > -1) {
        // ignore error
        } else {
            this.emit(AdapterConstants.Event.ERROR, {
                params: params
            });
            if (typeof params.errorCode !== "undefined" && options["errors.fatal"] && options["errors.fatal"].indexOf(params.errorCode.toString()) > -1) {
                this.fireStop({}, triggeredEvent);
            }
        }
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
     * @param {string} [triggeredEvent]
     */ fireFatalError: function fireFatalError(code, msg, metadata, level, triggeredEvent) {
        var options = this.plugin ? this.plugin.options : {};
        if (typeof code !== "undefined" && options["errors.ignore"] && options["errors.ignore"].indexOf(code.toString()) > -1) {
        // ignore error
        } else {
            if (this.monitor) this.monitor.stop();
            this.fireError(code, msg, metadata, level, triggeredEvent);
            if (typeof code !== "undefined" && options["errors.nonFatal"] && options["errors.nonFatal"].indexOf(code.toString()) > -1) {
            // no stop
            } else {
                this.fireStop({}, triggeredEvent);
            }
        }
    },
    _shouldSplitView: function _shouldSplitView() {
        return this.plugin && this.plugin.options && this.plugin.options["session.splitViews"];
    }
}, {
    /** @lends youbora.Adapter */ // Static Memebers //
    /**
     * List of events that could be fired
     * @enum
     * @event
     */ Event: AdapterConstants.Event
});
Util.assign(Adapter.prototype, __webpack_require__(19917));
Util.assign(Adapter.prototype, __webpack_require__(41850));
module.exports = Adapter;


/***/ }),

/***/ 75175:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
var YouboraObject = __webpack_require__(831);
var Chrono = __webpack_require__(92747);
var PlaybackChronos = YouboraObject.extend(/** @lends youbora.PlaybackChronos.prototype */ {
    /**
     * This class contains all the {@link Chrono}s related to view status.
     * Chronos measure time lapses between events.
     * ie: between start and join, between seek-begin and seek-end, etc.
     * Each plugin will have an instance of this class.
     *
     * @constructs PlaybackChronos
     * @extends youbora.YouboraObject
     * @memberof youbora
     */ constructor: function constructor() {
        this.reset();
    },
    /** Reset flag values */ reset: function reset() {
        /** Chrono between start and joinTime. */ this.join = new Chrono();
        /** Chrono between seek-begin and seek-end. */ this.seek = new Chrono();
        /** Chrono between pause and resume. */ this.pause = new Chrono();
        /** Chrono between buffer-begin and buffer-end. */ this.buffer = new Chrono();
        /** Chrono for the totality of the view. */ this.total = new Chrono();
        // For ads
        /** List of chronos with seen intervals */ this.viewedMax = [];
    }
});
module.exports = PlaybackChronos;


/***/ }),

/***/ 24371:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
var YouboraObject = __webpack_require__(831);
var PlaybackFlags = YouboraObject.extend(/** @lends youbora.PlaybackFlags.prototype */ {
    /**
     * This class contains all the flags related to view status.
     * Each plugin will have an instance of this class.
     *
     * @constructs PlaybackFlags
     * @extends youbora.YouboraObject
     * @memberof youbora
     */ constructor: function constructor() {
        this.reset();
    },
    /** Reset flag values */ reset: function reset() {
        /** Flag when Start has been sent. */ this.isStarted = false;
        /** Flag when Join has been sent. */ this.isJoined = false;
        /** Flag when Player is paused. */ this.isPaused = false;
        /** Flag when Player is seeking. */ this.isSeeking = false;
        /** Flag when Player is buffering. */ this.isBuffering = false;
        /** Flag when Player is buffering by video state. */ this.isVideoStateBuffering = false;
        /** Flag when Player is ended. */ this.isEnded = false;
        /** Flag when Player view ends and stop is already sent. */ this.isStopped = false;
        /** Flag with last quartile sent. */ this.lastQuartileSent = 0;
    }
});
module.exports = PlaybackFlags;


/***/ }),

/***/ 15501:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var YouboraObject = __webpack_require__(831);
var Timer = __webpack_require__(45193);
var Chrono = __webpack_require__(92747);
var PlayheadMonitor = YouboraObject.extend(/** @lends youbora.PlayheadMonitor.prototype */ {
    /**
     * This class periodically checks the player's playhead in order to infer buffer and/or seek
     * events.
     *
     * Instances of this class are bounded to an {@link Adapter} and fires its buffer and seek
     * start and end methods.
     *
     * In order to use this feature, {@link Adapter#monitorPlayhead} should be used.
     *
     * @constructs PlayheadMonitor
     * @extends youbora.YouboraObject
     * @memberof youbora
     *
     * @param {Adapter} adapter Adapter to monitor. Must have getPlayhead defined.
     * @param {PlayheadMonitor.Type} [type=NONE]
     * Which metric to monitor seek and/or buffer.
     * Use bitwise operators to join both values (Type.BUFFER | Type.SEEK)
     * @param {int} [interval=800] How many ms will wait between progress. -1 to disable.
     */ constructor: function constructor(adapter, type, interval) {
        this._adapter = adapter;
        this._seekEnabled = type & PlayheadMonitor.Type.SEEK;
        this._bufferEnabled = type & PlayheadMonitor.Type.BUFFER;
        interval = interval || 800;
        this._chrono = new Chrono();
        this._lastPlayhead = 0;
        if (interval > 0) {
            this._timer = new Timer(this.progress.bind(this), interval);
        }
    },
    /**
     * Start interval checks.
     */ start: function start() {
        this.stop();
        if (this.canBeUsed()) this._timer.start();
    },
    /**
     * Stop interval checks.
     */ stop: function stop() {
        this._lastPlayhead = 0;
        if (this._timer) this._timer.stop();
    },
    skipNextTick: function skipNextTick() {
        this._lastPlayhead = 0;
    },
    /**
     * Call this method at every tick of timeupdate/progress.
     * If you defined an interval, do not fire this method manually.
     */ progress: function progress() {
        // Reset timer
        var deltaTime = this._chrono.stop();
        this._chrono.start();
        // Define thresholds
        var bufferThreshold = deltaTime * PlayheadMonitor.kBUFFER_THRESHOLD_RATIO;
        var seekThreshold = deltaTime * PlayheadMonitor.kSEEK_THRESHOLD_RATIO;
        if (this._adapter.getPlayrate && this._adapter.getPlayrate() && this._adapter.getPlayrate() !== 1) {
            bufferThreshold *= this._adapter.getPlayrate();
            seekThreshold *= this._adapter.getPlayrate();
        }
        // Calculate diff playhead
        var currentPlayhead = this._getPlayhead();
        var diffPlayhead = Math.abs(this._lastPlayhead - currentPlayhead) * 1000;
        // youbora.Log.debug('curr: ' + currentPlayhead + ' last: ' + this._lastPlayhead + ' diff: ' + diffPlayhead)
        if (diffPlayhead < bufferThreshold) {
            // Playhead is stalling > buffer
            if (this._bufferEnabled && this._lastPlayhead > 0 && !this._adapter.flags.isPaused && !this._adapter.flags.isSeeking) {
                this._adapter.fireBufferBegin(null, false, "playheadMonitor");
            }
        } else if (diffPlayhead > seekThreshold) {
            // Playhead has jumped > seek
            if (this._seekEnabled && this._lastPlayhead > 0) {
                this._adapter.fireSeekBegin(null, false, "playheadMonitor");
            }
        } else {
            // Healthy
            if (this._seekEnabled) {
                this._adapter.fireSeekEnd(null, "playheadMonitor");
            }
            if (this._bufferEnabled) {
                this._adapter.fireBufferEnd(null, "playheadMonitor");
            }
        }
        // Update Playhead
        this._lastPlayhead = currentPlayhead;
    },
    /**
     * Returns if the monitor can be used or not.
     * Enabled by default, except the case where the content is live and the option 'content.isLive.noMonitor' is true.
     * @public
     * @returns {boolean} If the monitor can be used or not.
     */ canBeUsed: function canBeUsed() {
        var plugin = this._adapter.plugin;
        if (plugin && plugin.getPlayheadMonitorEnabled() && (this._seekEnabled || this._bufferEnabled)) {
            return plugin.getIsLive() ? !plugin.options["content.isLive.noMonitor"] : true;
        } else {
            return false;
        }
    },
    /**
     * Returns adapter's playhead. Override to add a custom playhead getter.
     * @private
     * @returns {double} Playhead in seconds
     */ _getPlayhead: function _getPlayhead() {
        return this._adapter.getPlayhead();
    }
}, /** @lends youbora.PlayheadMonitor */ {
    // Static methods
    /**
     * Enum for monitoring type
     * @enum
     */ Type: {
        /** Would not monitor */ NONE: 0,
        /** Sends buffer-begin/end */ BUFFER: 1,
        /** Sends seek-begin/end */ SEEK: 2
    },
    /** Buffer threshold */ kBUFFER_THRESHOLD_RATIO: 0.5,
    /** Seek threshold */ kSEEK_THRESHOLD_RATIO: 2
});
module.exports = PlayheadMonitor;


/***/ }),

/***/ 20520:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
var YouboraObject = __webpack_require__(831);
var Log = __webpack_require__(39610);
var StateMonitor = YouboraObject.extend(/** @lends youbora.NetworkMonitor.prototype */ {
    /**
     * @constructs StateMonitor
     * @extends youbora.YouboraObject
     * @memberof youbora
     *
     * @param {Adapter} adapter Adapter to monitor. Must have getVideoObject defined.
     * @param {int} [intervalMilliseconds=300] How many ms will wait between progress. -1 to disable.
     */ constructor: function constructor(adapter, intervalMilliseconds) {
        this._adapter = adapter;
        this._videoElement = adapter.getVideoObject();
        this._startedStateCheck = false;
        this._intervalCheckId = null;
        this._intervalMilliseconds = intervalMilliseconds || 300;
    },
    /**
     * Start Network monitor
     */ start: function start() {
        var plugin = this._adapter.plugin;
        if (plugin && plugin.getReadyStateMonitorEnabled()) {
            if (this._videoElement && !this._startedStateCheck) {
                this._intervalCheckId = setInterval(this.checkStateProperty.bind(this), this._intervalMilliseconds);
                this._startedStateCheck = true;
            }
        }
    },
    /**
     * Stop Network monitor
     */ stop: function stop() {
        try {
            if (this._startedStateCheck && this._intervalCheckId) {
                clearInterval(this._intervalCheckId);
            }
            this._intervalCheckId = null;
            this._startedStateCheck = false;
        } catch (e) {
            Log.error("Produced error stopping the network monitor");
        }
    },
    /**
     * Check ReadyState properties values
     * @param e
     */ checkStateProperty: function checkStateProperty(e) {
        try {
            if (this._videoElement && this._adapter) {
                if (this._videoElement.readyState) {
                    if (this._videoElement.readyState > 3 && !this._adapter.flags.isSeeking) {
                        if (this._adapter.flags.isBuffering) {
                            this.fireBufferEnd({}, "stateMonitor");
                        } else if (!this._adapter.flags.isJoined) {
                            this.fireJoin({}, "stateMonitor");
                        }
                    } else if (this._videoElement.readyState < 4 && !this._adapter.flags.isBuffering) {
                        this.fireBufferBegin({}, false, "stateMonitor", true);
                    }
                }
            }
        } catch (e) {}
    }
});
module.exports = StateMonitor;


/***/ }),

/***/ 92747:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
var YouboraObject = __webpack_require__(831);
var Chrono = YouboraObject.extend(/** @lends youbora.Chrono.prototype */ {
    /**
     * This class calculates time lapses between two points in time.
     *
     * @constructs Chrono
     * @extends youbora.YouboraObject
     * @memberof youbora
     */ constructor: function constructor() {
        this.reset();
    },
    /** Reset chrono values. */ reset: function reset() {
        /** Start time */ this.startTime = 0;
        /** Stop time */ this.stopTime = 0;
        /** Pause time */ this.pauseTime = 0;
        /** Offset to be added to deltaTime and stop. in ms. */ this.offset = 0;
    },
    /**
     * Returns the time between start() and the last stop() in ms. Returns -1 if start wasn't
     * called.
     * @param {boolean} [stop=true] If true, it will force a stop() if it wasn't called before.
     * @return {number} Time lapse in ms.
     */ getDeltaTime: function getDeltaTime(stop) {
        var retValue = -1;
        var now = new Date().getTime();
        if (this.startTime) {
            if (stop && !this.stopTime) {
                this.stopTime = now;
            }
            var tempOffset = this.pauseTime ? now - this.pauseTime : 0;
            var tempStop = this.stopTime ? this.stopTime : now;
            retValue = this.offset - tempOffset + (tempStop - this.startTime);
        }
        return retValue;
    },
    /**
     * Starts the chrono.
     */ start: function start() {
        this.startTime = new Date().getTime();
        this.stopTime = 0;
        this.offset = 0;
    },
    /**
     * Stops the timer and returns current delta time.
     * @return {number} Returns the delta time
     */ stop: function stop() {
        if (this.pauseTime) this.resume();
        this.stopTime = new Date().getTime();
        return this.startTime ? this.offset + (this.stopTime - this.startTime) : -1;
    },
    pause: function pause() {
        this.pauseTime = new Date().getTime();
    },
    resume: function resume() {
        this.offset -= new Date().getTime() - this.pauseTime;
        this.pauseTime = 0;
    },
    /**
     * Creates a copy of the chrono.
     */ clone: function clone() {
        var chrono = new Chrono();
        chrono.startTime = this.startTime;
        chrono.stopTime = this.stopTime;
        chrono.offset = this.offset;
        return chrono;
    }
});
module.exports = Chrono;


/***/ }),

/***/ 30495:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
var YouboraObject = __webpack_require__(831);
var Log = __webpack_require__(39610);
var YBRequest = __webpack_require__(57195);
var Transform = __webpack_require__(51293);
var Communication = YouboraObject.extend(/** @lends youbora.Communication.prototype */ {
    /**
     * Youbora Communication implements an abstraction layer over API requests.
     * Internally, Communication implements queues of {@link Request} objects.
     * This queue can be blocked using {@link Transform}
     *
     * @constructs Communication
     * @extends youbora.YouboraObject
     * @memberof youbora
     *
     * @param {string} host The fastdata host address.
     * @param {boolean} httpSecure True for https, false for http, undefined for //.
     */ constructor: function constructor(pluginref) {
        /** Array of {@link Transform}, only when the array is empty the request Queues will begin sending. */ this.transforms = [];
        this.pluginRef = pluginref;
        /**
       * Queue of {@link YBRequest}
       * @private
       */ this._requests = [];
    },
    /**
     * Enqueues the request provided.
     *
     * @param {YBRequest} request Request to be enqueued
     * @param {function} [callback] The defined load callback to the Request
     */ sendRequest: function sendRequest(request, callback, callbackParams) {
        if (request) {
            if (typeof callback === "function") request.on(YBRequest.Event.SUCCESS, callback, callbackParams);
            this._registerRequest(request);
        }
    },
    /**
     * Build a generic request to the given host.
     *
     * @param {string} host Host of the service called.
     * @param {string} service A string with the service to be called. ie: '/data', '/joinTime'...
     * @param {Object} [params] Object of key:value params.
     * @param {function} [callback] The defined load callback to the Request
     */ buildRequest: function buildRequest(host, service, params, callback) {
        params = params || {};
        var request = new YBRequest(host, service, params);
        if (typeof callback === "function") request.on(YBRequest.Event.SUCCESS, callback);
        this._registerRequest(request);
    },
    /**
     * Adds a Transform to the queue. See {@link Transform}.
     *
     * @param {RequestTransform} transform
     */ addTransform: function addTransform(transform) {
        if (transform.parse && transform.isBlocking) {
            this.transforms.push(transform);
            transform.on(Transform.Event.DONE, this._processRequests.bind(this));
        } else {
            Log.warn(transform + " is not a valid RequestTransform.");
        }
    },
    /**
     * Removes a {@link Transform}.
     *
     * @param {RequestTransform} transform Transform object to remove.
     */ removeTransform: function removeTransform(transform) {
        var pos = this.transforms.indexOf(transform);
        if (pos !== -1) {
            this.transforms.splice(pos, 1);
        } else {
            Log.warn("Trying to remove unexisting Transform '" + transform + "'.");
        }
    },
    /**
     * Adds an {@link YBRequest} to the queue of requests.
     *
     * @private
     * @param {YBRequest} request The Request to be queued.
     */ _registerRequest: function _registerRequest(request) {
        if (this.pluginRef) {
            var options = this.pluginRef.options;
            if (options.authToken) {
                request.options.requestHeaders.Authorization = options.authType + " " + options.authToken;
            }
        }
        this._requests.push(request);
        this._processRequests();
    },
    /**
     * Execute pending requests in the queue. Returns rejected ones to the queue.
     * @private
     */ _processRequests: function _processRequests() {
        var workingQueue = this._requests;
        this._requests = [];
        var rejected = [];
        while(workingQueue.length){
            var request = workingQueue.shift();
            var transformState = this._transform(request);
            if (transformState === Transform.STATE_NO_BLOCKED) {
                if (this.pluginRef) request.host = this.pluginRef.getHost();
                request.send();
            } else if (transformState === Transform.STATE_BLOCKED) {
                rejected.push(request);
            } // else { remove }
        }
        while(rejected.length){
            this._requests.push(rejected.shift());
        }
    },
    /**
     * Pass the given request to each transform.
     * @private
     * @returns {int} STATE_NO_BLOCKED if everything is right. STATE_BLOCKED if some parser rejected it.
     * STATE_OFFLINE if offline transform blocked it.
     */ _transform: function _transform(request) {
        var ret = Transform.STATE_NO_BLOCKED;
        this.transforms.forEach(function(transform) {
            if (transform.isBlocking(request)) {
                ret = Transform.STATE_BLOCKED;
                return;
            } else {
                transform.parse(request);
            }
            if (transform.getState() === Transform.STATE_OFFLINE) {
                ret = Transform.STATE_OFFLINE;
            }
        });
        return ret;
    }
});
module.exports = Communication;


/***/ }),

/***/ 57195:
/***/ ((module, exports, __webpack_require__) => {

/* global  atv, XMLHttpRequest, ActiveXObject */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var YouboraObject = __webpack_require__(831);
var Log = __webpack_require__(39610);
var Util = __webpack_require__(37280);
var YBRequest = YouboraObject.extend(/** @lends youbora.YBRequest.prototype */ {
    /**
     * YBYBRequest class will wrap XmlHttpRequest and extend its functionality, allowing youbora
     * to manage queues, blockers and retries.
     *
     * @constructs YBRequest
     * @extends youbora.Object
     * @memberof youbora
     *
     * @param {string} host URL of the request. ie: a-fds.youborafds01.com
     * @param {string} [service] Name of the service. ie '/start'
     * @param {Object} [params] Object of key:value params.
     * @param {Object} [options] Object with custom options.
     * @param {string} [options.method="GET"] Specifies the method of the request. ie: "GET", "HEAD".
     * @param {string} [options.requestHeaders] Object with options of requestHeaders.
     * ie: { header: value }.
     * @param {number} [options.retryAfter=5000] Time in ms before sending a failed request again.
     * 0 to disable.
     * @param {number} [options.maxRetries=3] Max number of retries. 0 to disable.
     * @param {bool} [options.cache=false] If false, timestamp will be added to each request to
     * prevent caching.
     */ constructor: function constructor(host, service, params, options) {
        /** Instance of XmlHttpRequest (or the item returned by createXHR method). */ this.xhr = this.createXHR();
        /** Host of the request */ this.host = host || "";
        /** Service of the request */ this.service = service || "";
        /** Object of params of the request */ this.params = params || {};
        /** Options of the current request */ this.options = Util.assign({}, YBRequest.defaultOptions, options);
        /** Number of times this request has failed and retried. */ this.retries = 0;
        /** Define if plugin has enabled to send requests with POST method */ this.sendPostRequest = false;
        this.preparedPostRequest = false;
        // Add timemark
        if (!this.options.cache) {
            this.setParam("timemark", new Date().getTime());
        }
    },
    /**
     * Creates XMLHttpRequest if it is available in the browser.
     * If not, it tries to create an ActiveXObject XMLHTTP item.
     * Override this function for custom environments.
     *
     * @return YBRequest handler.
     */ createXHR: function createXHR() {
        var xhr = {};
        try {
            if (XMLHttpRequest) {
                xhr = new XMLHttpRequest();
            } else {
                xhr = new ActiveXObject("Microsoft.XMLHTTP");
            }
        } catch (err) {
            Log.error(err);
        }
        return xhr;
    },
    /**
     * Returns xhr object.
     *
     * @return {XmlHttpRequest} object.
     */ getXHR: function getXHR() {
        return this.xhr;
    },
    getResponse: function getResponse() {
        return this.xhr.response;
    },
    getResponseText: function getResponseText() {
        return this.xhr.responseText;
    },
    getResponseHeaders: function getResponseHeaders() {
        return this.xhr.getAllResponseHeaders();
    },
    /** Returns the complete formed url of the request url+service+params. */ getUrl: function getUrl() {
        return this.host + this.service + this.getParamString();
    },
    /**
     * Wraps this.getHXR.addEventListener.
     * Accepts a callback that receives (this YBRequest, event)
     */ on: function on(event, callback, callbackParams) {
        if (this.xhr.addEventListener) {
            this.xhr.addEventListener(event, callback.bind(this, this, callbackParams));
        } else {
            if (event === YBRequest.Event.SUCCESS) {
                this.xhr.onreadystatechange = (function() {
                    if (this.xhr.readyState === 4) {
                        callback.bind(this, this, callbackParams);
                    }
                }).bind(this);
            }
        }
        return this;
    },
    /** Wraps this.getHXR.removeEventListener */ off: function off(event, callback) {
        this.xhr.removeEventListener(event, callback);
        return this;
    },
    /**
     * Returns the params of the request, stringified.
     * ie: '?pluginVersion=5.1.0&systemCode=nicetv'.
     * @return {string} Concatenated Params
     */ getParamString: function getParamString() {
        try {
            var params = "?";
            for(var key in this.params){
                var param = this.params[key];
                if (param !== null && typeof param === "object") {
                    var string = JSON.stringify(param);
                    if (string !== "{}") {
                        params += encodeURIComponent(key) + "=" + encodeURIComponent(string) + "&";
                    }
                } else if (param !== null && typeof param !== "undefined" && param !== "") {
                    params += encodeURIComponent(key) + "=" + encodeURIComponent(param) + "&";
                }
            }
            return params.slice(0, -1);
        } catch (err) {
            Log.error(err);
            return "";
        }
    },
    /**
     * Returns the value of the given param, or undefined.
     * @param {string} key Name of the param.
     * @return {any}
     */ getParam: function getParam(key) {
        return this.params[key];
    },
    /**
     * Add or set a parameter for the request.
     * ie: if you want to add 'username=user' use setParam('username', 'user').
     * @param {string} key Name of the param.
     * @param {string} value Name of the param.
     * @return this
     */ setParam: function setParam(key, value) {
        this.params[key] = value;
        return this;
    },
    setBody: function setBody(body) {
        this.body = body;
    },
    /**
     * Set if is enabled send requests with POST method
     * @param {boolean} sendPostRequest
     */ setPostRequest: function setPostRequest(sendPostRequest) {
        this.sendPostRequest = sendPostRequest;
    },
    /**
     * Create Params object with the basic get params we need to send to the Data Collector nodes
     * @returns {{}}
     */ getParamsForPostMessages: function getParamsForPostMessages() {
        // Creating empty params object
        var params = {};
        try {
            // Get previous params
            var timemark = this.getParam("timemark");
            var code = this.getParam("code");
            var sessionRoot = this.getParam("sessionRoot");
            var sessionId = this.getParam("sessionId");
            // Adding params
            if (timemark) {
                params.timemark = timemark;
            }
            if (code) {
                params.code = code;
            }
            if (sessionRoot) {
                params.sessionRoot = sessionRoot;
            }
            if (sessionId) {
                params.sessionId = sessionId;
            }
        } catch (err) {
            Log.error(err);
        }
        return params;
    },
    /**
     * Sends the request.
     *
     * @return returns xhr.send()
     */ send: function send() {
        try {
            try {
                if (this.sendPostRequest && !this.preparedPostRequest) {
                    this.options.method = "POST";
                    this.body = JSON.stringify(this.params);
                    this.params = this.getParamsForPostMessages();
                    this.preparedPostRequest = true;
                }
            } catch (err) {}
            this.xhr.open(this.options.method, this.getUrl(), true);
            // Add custom headers
            if (this.options.requestHeaders) {
                for(var key in this.options.requestHeaders){
                    if (this.options.requestHeaders.hasOwnProperty(key)) {
                        this.xhr.setRequestHeader(key, this.options.requestHeaders[key]);
                    }
                }
            }
            // Add retries system
            if (this.options.retryAfter > 0 && this.options.maxRetries > 0) {
                var genericError = function genericError() {
                    if (this.retries >= this.options.maxRetries) {
                        Log.error('Aborting failed request "' + this.service + '". Max retries reached.');
                    } else {
                        Log.warn('YBRequest "' + this.service + '" failed. Retry ' + (this.retries + 1) + " of " + this.options.maxRetries + " in " + this.options.retryAfter + "ms.");
                        try {
                            setTimeout((function() {
                                this.retries += 1;
                                this.send();
                            }).bind(this), this.options.retryAfter);
                        } catch (err) {
                            if (typeof atv !== "undefined") {
                                atv.setTimeout((function() {
                                    this.retries += 1;
                                    this.send();
                                }).bind(this), this.options.retryAfter);
                            } else {
                                Log.error(err);
                            }
                        }
                    }
                };
                if (this.retries === 0) {
                    this.on(YBRequest.Event.ERROR, genericError.bind(this));
                }
            }
            // Log XHR
            if (Log.logLevel <= Log.Level.VERBOSE) {
                Log.verbose("XHR Req: " + this.getUrl());
            }
            // Register 'on every' listeners
            for(var event in YBRequest._globalListeners){
                YBRequest._globalListeners[event].forEach((function(callback) {
                    this.on(event, callback);
                }).bind(this));
            }
            // Send
            return this.xhr.send(this.body);
        } catch (err) {
            Log.error(err);
        }
    }
}, /** @lends youbora.YBRequest */ {
    /**
     * List of events that could be fired from XHR
     * @enum
     */ Event: {
        /** Request successful */ SUCCESS: "load",
        /** Request successful */ LOAD: "load",
        /** Request returned error */ ERROR: "error",
        /** Request aborted */ ABORT: "abort"
    },
    /**
     * This static property includes the default values for the options. In case you do not define
     * one of them in the constructor, these values will be used instead.
     *
     * @param {string} [defaultOptions.method="GET"] Specifies the method of the request.
     * ie: "GET", "HEAD".
     * @param {string} [defaultOptions.requestHeaders] Object with options of requestHeaders.
     * ie: { header: value }.
     * @param {number} [defaultOptions.retryAfter=5000] Time in ms before sending a failed request
     * again. 0 to disable.
     * @param {number} [defaultOptions.maxRetries=3] Max number of retries. 0 to disable.
     * @param {bool} [defaultOptions.cache=false] If false, timemark will be added to each request
     * to prevent caching.
     */ defaultOptions: {
        method: "GET",
        requestHeaders: {},
        maxRetries: 3,
        retryAfter: 5000,
        cache: false
    },
    /** @private */ _globalListeners: {},
    /**
     * Adds a callback to every instance.
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     */ onEvery: function onEvery(event, callback) {
        YBRequest._globalListeners[event] = YBRequest._globalListeners[event] || [];
        YBRequest._globalListeners[event].push(callback);
    },
    /**
     * Removes a global callback
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     */ offEvery: function offEvery(event, callback) {
        if (YBRequest._globalListeners[event]) {
            var index = YBRequest._globalListeners[event].indexOf(callback);
            if (index !== -1) {
                YBRequest._globalListeners[event].splice(index, 1);
            }
        }
    }
});
module.exports = YBRequest;


/***/ }),

/***/ 57009:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
var Transform = __webpack_require__(51293);
var Constants = __webpack_require__(56230);
/**
 * This transform ensures that no requests will be sent before an /init or /start request.
 * As these are the two possible first requests that the API expects for a view.
 *
 * @constructs
 * @extends youbora.Transform
 * @memberof youbora
 * @name FlowTransform
 *
 * @param {Plugin} plugin Instance of {@link Plugin}
 */ var FlowTransform = Transform.extend(/** @lends youbora.FlowTransform.prototype */ {
    _services: [
        Constants.Service.INIT,
        Constants.Service.START,
        Constants.Service.OFFLINE_EVENTS
    ],
    /**
     * Returns if transform is blocking.
     *
     * @param {YBRequest} request Request to transform.
     * @return {bool} True if queue shall be blocked.
     */ isBlocking: function isBlocking(request) {
        if (this._isBusy && request != null) {
            if (this._services.indexOf(request.service) !== -1) {
                this.done();
            } else if (request.service === Constants.Service.ERROR) {
                return false;
            }
        }
        return Transform.prototype.isBlocking.apply(this, arguments);
    }
});
module.exports = FlowTransform;


/***/ }),

/***/ 14219:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
var Transform = __webpack_require__(51293);
var OfflineTransform = Transform.extend(/** @lends youbora.OfflineTransform.prototype */ {
    /**
     * This class manages Fastdata service and view index.
     *
     * @constructs
     * @extends youbora.Transform
     * @memberof youbora
     *
     * @param {Plugin} plugin Instance of {@link Plugin}
     * @param {string} session If provided, plugin will use this as a FD response.
     */ constructor: function constructor(plugin, session) {
        this._sendRequest = false;
        this._isBusy = false;
        this.plugin = plugin;
        this.session = session;
        this.transformName = "Offline";
    },
    /**
     * Transform requests
     * @param {youbora.comm.YBRequest} request YBRequest to transform.
     */ parse: function parse(request) {
        if (request && this.plugin.offlineStorage) {
            this.plugin.offlineStorage.addEvent(request.service, request.params);
        }
    },
    hasToSend: function hasToSend(request) {
        return false;
    },
    getState: function getState() {
        return Transform.STATE_OFFLINE;
    }
});
module.exports = OfflineTransform;


/***/ }),

/***/ 88584:
/***/ ((module, exports, __webpack_require__) => {

/* global atv */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
var Transform = __webpack_require__(51293);
var HlsParser = __webpack_require__(91513);
var CdnParser = __webpack_require__(95627);
var CdnSwitch = __webpack_require__(32152);
var DashParser = __webpack_require__(41174);
var Parser = __webpack_require__(94945);
var LocationheaderParser = __webpack_require__(74713);
var Log = __webpack_require__(39610);
var Constants = __webpack_require__(56230);
var ResourceTransform = Transform.extend(/** @lends youbora.ResourceTransform.prototype */ {
    /**
     * This class parses resource to fetch HLS transportstreams and CDN-related info.
     *
     * @constructs ResourceTransform
     * @extends youbora.Transform
     * @memberof youbora
     *
     * @param {Plugin} plugin Instance of {@link Plugin}
     */ constructor: function constructor(plugin) {
        ResourceTransform.__super__.constructor.apply(this, arguments);
        this._plugin = plugin;
        this._realResource = null;
        this._transportFormat = null;
        this._initResource = null;
        this._cdnName = null;
        this._cdnNodeHost = null;
        this._cdnNodeTypeString = null;
        this._cdnNodeType = null;
        this._responses = {};
        this._isBusy = false;
        this.transformName = "Resource";
    },
    /**
     * Get the resource. If the transform is done, the real (parsed) resource will be returned
     * Otherwise the initial one is returned.
     *
     * @return {string} The initial or parsed resource
     */ getResource: function getResource() {
        return this._realResource;
    },
    _getInitialCdnResource: function _getInitialCdnResource() {
        return this._realResource || this._initResource;
    },
    /**
     * Get the transport format. If the transform detected the chunk format it will be returned, if not, null.
     *
     * @return {string} The streaming protocol
     */ getTransportFormat: function getTransportFormat() {
        return this._transportFormat;
    },
    /**
     * Get the parsed CDN name.
     *
     * @return {string} The CDN name or null if unknown
     */ getCdnName: function getCdnName() {
        return this._cdnName;
    },
    /**
     * Get the parsed CDN node.
     *
     * @return {string} The CDN node or null if unknown
     */ getNodeHost: function getNodeHost() {
        return this._cdnNodeHost;
    },
    /**
     * Get the parsed CDN type string, as returned in the cdn header response.
     *
     * @return {string} The CDN type string
     */ getNodeTypeString: function getNodeTypeString() {
        return this._cdnNodeTypeString;
    },
    /**
     * Get the parsed CDN type, parsed from the type string.
     *
     * @return {string} The CDN type
     */ getNodeType: function getNodeType() {
        return this._cdnNodeType;
    },
    /**
     * Start the execution. Can be called more than once. If already running, it will be ignored,
     * if ended it will restart.
     * @param {string} resource the original resource
     */ init: function init(resource) {
        if (!resource) {
            this.done();
            return;
        }
        if (!this._isBusy) {
            this._isBusy = true;
            this._initResource = resource;
            this._parseManifestEnabled = this._plugin.isParseManifest();
            this._cdnEnabled = this._plugin.isParseCdnNode();
            this._cdnList = this._plugin.getParseCdnNodeList().slice() // clone
            ;
            CdnParser.setBalancerHeaderName(this._plugin.getParseCdnNodeNameHeader(), this._plugin.getParseNodeHeader());
            this._setTimeout();
            if (this._parseManifestEnabled) {
                if (!this._isFinalUrl(this._initResource)) {
                    this.parseManifest() // Unknown lastManifest or lastSrc, call without arguments
                    ;
                } else {
                    this._realResource = this._initResource;
                    this.done();
                }
            } else {
                this._parseCDN();
            }
        }
    },
    _isFinalUrl: function _isFinalUrl(url) {
        var segmentExtensions = [
            ".ts",
            ".mp4",
            ".m4s",
            ".cmfv",
            ".mp3"
        ];
        url = url || "";
        for(var i in segmentExtensions){
            var ext = segmentExtensions[i];
            if (url.lastIndexOf(ext) === url.length - ext.length) {
                return true;
            }
        }
        return false;
    },
    // done: function () {
    //  Transform.prototype.done.apply(this, arguments) // super
    // },
    _setTimeout: function _setTimeout() {
        // Abort operation after 3s
        var timeoutComplete = (function() {
            if (this._isBusy) {
                this.done();
                Log.warn("ResourceTransform has exceeded the maximum execution time (3s) and will be aborted.");
            }
        }).bind(this);
        try {
            this._parseTimeout = setTimeout(timeoutComplete, 3000);
        } catch (err) {
            if (typeof atv !== "undefined") {
                this._parseTimeout = atv.setTimeout(timeoutComplete, 3000);
            } else {
                Log.error(err);
            }
        }
    },
    parseManifest: function parseManifest(lastManifest, lastSrc) {
        var headers = this._plugin.options["parse.manifest.auth"];
        var parseHeaderLocationGet = this._plugin.isParseLocationHeaderGetRequest();
        var parseManifestEnabled = this._plugin.isParseManifest();
        var parseLastChunk = this._plugin.options["parse.manifest.lastChunk"] || false;
        var locationheaderParser = new LocationheaderParser(headers);
        locationheaderParser.setGetRequest(parseManifestEnabled || parseHeaderLocationGet);
        var dashParser = new DashParser(headers);
        dashParser.setParseLastChunk(parseLastChunk);
        var hlsParser = new HlsParser(headers);
        hlsParser.setParseLastChunk(parseLastChunk);
        var parserArray = [
            locationheaderParser,
            dashParser,
            hlsParser
        ];
        this._parseManifest(parserArray, lastManifest, lastSrc || this._initResource);
    },
    _parseManifest: function _parseManifest(parserArray, lastManifest, lastSrc, format) {
        if (parserArray.length > 0) {
            var parser = parserArray[0];
            if (parser.shouldExecute(lastManifest)) {
                parser.on(Parser.Event.DONE, (function() {
                    this._parseManifest(parserArray.slice(1, parserArray.length), parser.getLastManifest(), parser.getResource(), parser.getTransportFormat() || format);
                }).bind(this));
                parser.parse(lastSrc, lastManifest);
            } else {
                this._parseManifest(parserArray.slice(1, parserArray.length), lastManifest, lastSrc, format);
            }
        } else {
            this._transportFormat = format;
            this._realResource = lastSrc;
            this._parseCDN();
        }
    },
    _parseCDN: function _parseCDN() {
        if (this._plugin.isCdnSwitch()) {
            this.switchDetector = new CdnSwitch(this._plugin);
            this.switchDetector.on(CdnSwitch.Events.DONE, (function(resp) {
                this._cdnName = resp.data;
                this.done();
            }).bind(this));
            this.switchDetector.on(CdnSwitch.Events.ERROR, (function() {
                this.done();
            }).bind(this));
            this.switchDetector.init();
        } else if (this._cdnEnabled && this._cdnList.length > 0) {
            var cdn = this._cdnList.shift();
            if (this.getNodeHost()) return; // abort
            var cdnParser = CdnParser.create(cdn);
            if (cdnParser) {
                var requestMethod = this._plugin.isCDNParserHeaderGetRequest() ? "GET" : "HEAD";
                cdnParser.setRequestMethod(requestMethod);
                cdnParser.on(CdnParser.Event.DONE, (function() {
                    this._responses = cdnParser.getResponses();
                    this._cdnName = cdnParser.getParsedCdnName();
                    this._cdnNodeHost = cdnParser.getParsedNodeHost();
                    this._cdnNodeTypeString = cdnParser.getParsedNodeTypeString();
                    this._cdnNodeType = cdnParser.getParsedNodeType();
                    if (this.getNodeHost()) {
                        this.done();
                    } else {
                        this._parseCDN();
                    }
                }).bind(this));
                // Run parse
                cdnParser.parse(this._getInitialCdnResource(), this._responses);
            } else {
                this._parseCDN();
            }
        } else {
            this.done();
        }
    },
    /**
     * Replaces the resource and/or Cdn info for the /start service.
     *
     * @param {YBRequest} request YBRequest to transform.
     */ parse: function parse(request) {
        if (request.service === Constants.Service.START) {
            var lastSent = this._plugin.requestBuilder.lastSent;
            lastSent.parsedResource = request.params.parsedResource = this.getResource() || request.params.parsedResource;
            lastSent.transportFormat = request.params.transportFormat = this.getTransportFormat() || request.params.transportFormat;
            if (this._cdnEnabled) {
                lastSent.cdn = request.params.cdn = request.params.cdn || this.getCdnName();
                lastSent.nodeHost = request.params.nodeHost = this.getNodeHost() || request.params.nodeHost;
                lastSent.nodeType = request.params.nodeType = this.getNodeType() || request.params.nodeType;
                lastSent.nodeTypeString = request.params.nodeTypeString = this.getNodeTypeString() || request.params.nodeTypeString;
            }
        }
    }
});
module.exports = ResourceTransform;


/***/ }),

/***/ 32152:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
var Emitter = __webpack_require__(15885);
var Log = __webpack_require__(39610);
var YBRequest = __webpack_require__(57195);
var CdnSwitch = Emitter.extend({
    constructor: function constructor(plugin) {
        this.plugin = plugin;
        this.headerName = "x-cdn";
    },
    init: function init() {
        var url = null;
        if (this.plugin) {
            if (this.plugin.getAdapter() && this.plugin.getAdapter().getURLToParse()) {
                url = this.plugin.getAdapter().getURLToParse();
            } else {
                url = this.plugin.getResource();
            }
        }
        if (this.plugin && this.plugin.getAdapter() && this.plugin.getAdapter().flags.isStarted) {
            this._request(url);
        }
    },
    done: function done(data) {
        this.emit(CdnSwitch.Events.DONE, data);
    },
    error: function error() {
        this.emit(CdnSwitch.Events.ERROR);
    },
    _successfulRequest: function _successfulRequest(resp) {
        setTimeout(this.init.bind(this), parseInt(this.plugin.options["parse.cdnTTL"]) * 1000);
        var headers = resp.getResponseHeaders().split("\n");
        var cdn = null;
        for(var i in headers){
            var line = headers[i];
            var index = line.indexOf(this.headerName);
            if (index > -1) {
                cdn = line.substring(index + this.headerName.length + 1, line.length - 1).replace(" ", "");
            }
        }
        this.done(cdn);
    },
    _failedRequest: function _failedRequest() {
        setTimeout(this.init.bind(this), parseInt(this.plugin.options["parse.cdnTTL"]) * 1000);
        Log.warn("CDN switch detection request failed");
        this.error();
    },
    _request: function _request(url) {
        var request = new YBRequest(url, null, null, {
            method: "HEAD",
            cache: true
        });
        request.on(YBRequest.Event.SUCCESS, this._successfulRequest.bind(this));
        request.on(YBRequest.Event.ERROR, this._failedRequest.bind(this));
        request.send();
    }
}, {
    Events: {
        DONE: "done",
        ERROR: "error"
    }
});
module.exports = CdnSwitch;


/***/ }),

/***/ 95627:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
var Emitter = __webpack_require__(15885);
var Log = __webpack_require__(39610);
var Util = __webpack_require__(37280);
var YBRequest = __webpack_require__(57195);
var CdnParser = Emitter.extend(/** @lends youbora.CdnParser.prototype */ {
    /**
         * Class that asynchronously tries to get information about the CDN where a given resource is
         * hosted.
         *
         * The info we care about is the CDN code itself, the node host and node type.
         *
         * The CDN is queried with http HEAD requests. This only will work if the CDN has been properly
         * configured.
         *
         * When HEAD requests are performed against the resources, the CDN returns a set of headers that
         * contain info about the cdn header and/or cdn type.
         *
         * Each CDN is different; some require special headers to be set when the HEAD request is
         * performed and others don't. Also, the info can come back in any fashion of ways, sometimes
         * both type and host come in the same response header while sometimes they're in different
         * headers. The format of these response headers is also different from CDN to CDN, so a
         * different regex is used for each CDN.
         *
         * Lastly, as the values indicating the CDN type are also different, we need a specific mapping
         * for each one.
         *
         * Every instance of this class will represent a 'way' of parsing the HEAD response. So an
         * instance should be created for Level3, Akamai, Highwinds, etc...
         *
         * @constructs CdnParser
         * @extends youbora.Emitter
         * @memberof youbora
         *
         * @param {object} options This object represents the configuration of a certain CDN parsing
         * methodology.
         * @param {string} options.cdnName see {@link CdnParser#setCdnName}.
         * @param {array} options.parsers see {@link CdnParser#addParser}.
         * @param {array} options.requestMethod see {@link CdnParser#setRequestMethod}.
         * @param {array} options.requestHeaders see {@link CdnParser#setRequestHeader}.
         * @param {function} options.parseType see {@link CdnParser#setParseType}.
         */ constructor: function constructor(options) {
        this._options = Util.assign({
            cdnName: null,
            parsers: [],
            requestMethod: "HEAD",
            requestHeaders: {},
            parseType: function parseType() {
                return 0;
            }
        }, options);
        this._responses = {};
    },
    /**
         * Emits DONE event
         */ done: function done() {
        this.emit(CdnParser.Event.DONE);
    },
    /**
         * Adds an object that represents a parse step of the headers.
         *
         * Each parser item will define the element parsed (whether if it is a host, a type, both...)
         * a headerName to parse (ie: x-cache) and a regex to execute over that header.
         *
         * @param {object} parser
         * @param {string} parser.element Which element will be parsed from the request.
         * Use {@link CdnParser.ElementType} enum.
         * @param {string} parser.headerName Name of the header to parse.
         * @param {regex} parser.regex Regex to match against the header content.
         *
         * @return itself to chain method calls
         */ addParser: function addParser(parser) {
        this._options.parsers.push(parser);
        return this;
    },
    /**
         * Sets the cdn name. Note that this names are provided by Youbora and must coincede with the
         * ones offered here: {@link http://mapi.youbora.com:8081/cdns}.
         *
         * @return itself to chain method calls
         */ setCdnName: function setCdnName(name) {
        this._options.cdnName = name;
        return this;
    },
    /**
         * Sets the method of the request. HEAD by default.
         *
         * @return itself to chain method calls
         */ setRequestMethod: function setRequestMethod(method) {
        this._options.requestMethod = method;
        return this;
    },
    /**
         * if this CDN requires special headers to be set in order to respond with the info we want,
         * add them using this method.
         *
         * @param {string} key Name of the header.
         * @param {string} value Content of the header.
         *
         * @return itself to chain method calls
         */ setRequestHeader: function setRequestHeader(key, value) {
        this._options.requestHeaders[key] = value;
        return this;
    },
    /**
         * Adds a parsing function for parsing the type (hit or miss) of the request.
         *
         * Parser fucntion will receive a string parsed from a type header (see
         * {@link CdnParser#addParser}). Should return 1 in case of HIT, 2 in case of MISS and
         * 0 otherwise.
         *
         * @param {function} parser Parsing function
         *
         * @return itself to chain method calls
         */ setParseType: function setParseType(parser) {
        this._options.parseType = parser;
        return this;
    },
    /**
         * Get parsed CDN name.
         *
         * @return {string} The CDN name or null if unknown
         */ getParsedCdnName: function getParsedCdnName() {
        return this._cdnName;
    },
    /**
         * Get the parsed CDN node.
         *
         * @return {string} The CDN node or null if unknown
         */ getParsedNodeHost: function getParsedNodeHost() {
        return this._cdnNodeHost;
    },
    /**
         * Get the parsed CDN type string, as returned in the cdn header response.
         *
         * @return {string} The CDN type string
         */ getParsedNodeTypeString: function getParsedNodeTypeString() {
        return this._cdnNodeTypeString;
    },
    /**
         * Get the parsed CDN type, parsed from the type string.
         *
         * @return {string} The CDN type
         */ getParsedNodeType: function getParsedNodeType() {
        return this._cdnNodeType;
    },
    /**
         * Returns the request responses from this CdnParser.
         * This is filled with the responses from the constructor, or created empty if null.
         * Then the performed request response (if any) is added to this map.
         * Call this method after "using" the CdnParser and pass the responses to the following
         * CdnParser so it can use the responses if it applies.
         * @return the request responses
         */ getResponses: function getResponses() {
        return this._responses;
    },
    /**
         * Parses given headers to check for matches.
         */ parse: function parse(url, responses) {
        this._responses = responses || {};
        var headerString = JSON.stringify(this._options.requestHeaders);
        if (this._responses[headerString]) {
            this._parseResponse(this._responses[headerString]);
        } else {
            this._requestResponse(url);
        }
    },
    _requestResponse: function _requestResponse(url) {
        var headerString = JSON.stringify(this._options.requestHeaders);
        var useheaders = headerString !== "{}";
        var request = new YBRequest(url, null, null, {
            method: this._options.requestMethod,
            maxRetries: 0,
            requestHeaders: this._options.requestHeaders,
            cache: true
        });
        request.on(YBRequest.Event.SUCCESS, (function(resp) {
            this._responses[headerString] = resp.getResponseHeaders();
            this._parseResponse(this._responses[headerString]);
        }).bind(this));
        request.on(YBRequest.Event.ERROR, (function(resp) {
            if (useheaders) {
                this._options.requestHeaders = {};
                this._requestResponse(url);
            } else {
                this.done();
            }
        }).bind(this));
        request.send();
    },
    /**
     *
     * @param headers
     * @private
     */ _parseResponse: function _parseResponse(headers) {
        this._options.parsers.forEach((function(parser) {
            if (typeof parser.headerName === "string") {
                this._parseHeaderResponse(headers, parser, parser.headerName);
            } else if (Array.isArray(parser.headerName)) {
                for(var i = 0, len = parser.headerName.length; i < len; i++){
                    var headerNameElement = parser.headerName[i];
                    if (typeof headerNameElement === "string") {
                        this._parseHeaderResponse(headers, parser, headerNameElement);
                    }
                }
            }
        }).bind(this));
        this.done();
    },
    /**
     *
     * @param headers
     * @param parser
     * @param parser
     * @private
     */ _parseHeaderResponse: function _parseHeaderResponse(headers, parser, headerName) {
        if (headerName) {
            headerName = headerName ? headerName.toLowerCase() : "";
            headers.split("\n").forEach((function(line) {
                var index = line.indexOf(":");
                if (index !== -1) {
                    var key = line.slice(0, index).toLowerCase();
                    if (key === headerName) {
                        this._executeParser(parser, line.slice(index + 1));
                    }
                }
            }).bind(this));
        }
    },
    _executeParser: function _executeParser(parser, value) {
        try {
            var matches = parser.regex.exec(value.trim());
            if (matches !== null) {
                if (this._options.cdnName) this._cdnName = this._options.cdnName;
                switch(parser.element){
                    case CdnParser.ElementType.HOST:
                        this._cdnNodeHost = matches[1];
                        break;
                    case CdnParser.ElementType.TYPE:
                        this._cdnNodeTypeString = matches[1];
                        this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString);
                        break;
                    case CdnParser.ElementType.HOST_AND_TYPE:
                        this._cdnNodeHost = matches[1];
                        this._cdnNodeTypeString = matches[2];
                        this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString);
                        break;
                    case CdnParser.ElementType.TYPE_AND_HOST:
                        this._cdnNodeTypeString = matches[1];
                        this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString);
                        this._cdnNodeHost = matches[2];
                        break;
                    case CdnParser.ElementType.NAME:
                        this._cdnName = matches[1].toUpperCase();
                        break;
                }
            }
        } catch (err) {
            Log.warn("CDN parsing for " + this._options.cdnName + " could not parse header value " + value);
        }
    },
    shouldExecute: function shouldExecute() {
        return true;
    }
}, /** @lends youbora.CdnParser */ {
    // Static members
    /**
         * List of events that could be fired from this class.
         *
         * @enum
         */ Event: {
        /** Notifies that this CdnParser is done processing. */ DONE: "done"
    },
    /**
         * Possible different bits of info we can get from a header.
         *
         * @enum
         */ ElementType: {
        HOST: "host",
        TYPE: "type",
        HOST_AND_TYPE: "host+type",
        TYPE_AND_HOST: "type+host",
        NAME: "name"
    },
    /**
         * List of available CDN parsers.
         * @private
         */ _cdnConfigs: {},
    /**
         * This is a special case. The BalancerCdnParser is a custom CDN definition
         * that tries to get the CDN name directly from one of the headers. This method can be used
         * as a shortcut to creating a new CDN definition.
         *
         * This is usually used with DNS-based load balance services, such as Cedexis.
         *
         * Youboralib will use this method by itself using the configuration passed in the
         * {@link Options}.
         *
         * @param {string} cdnNameHeader the header response name where to get the CDN name from.
         * @param {string} cdnNodeNameHeader the header response name where to get the host name from.
         */ setBalancerHeaderName: function setBalancerHeaderName(name, nodename) {
        CdnParser._cdnConfigs.Balancer.parsers[0].headerName = name;
        CdnParser._cdnConfigs.Balancer.parsers[1].headerName = nodename;
    },
    /**
         * Create one of the pre-defined CDN parsers. This method will be called with the keys passed
         * to {@link Options#'parse.CdnNode.list'}.
         *
         * Before using this method, configs must be added first using {@link CdnParser.add}.
         *
         * @param {string} cdnName Name of the CDN
         * @return {CdnParser} An instance or undefined if the names does not match any CDN.
         */ create: function create(key) {
        if (CdnParser._cdnConfigs[key]) {
            return new CdnParser(CdnParser._cdnConfigs[key]);
        } else {
            Log.warn("Tried to create an unexisting CdnParser named " + key);
        }
    },
    /**
         * Adds the given CdnParser's config to the available list. Objects sent must comply with
         * CdnParser constructor.
         *
         * @param {string} key The name that will identify the CDN.
         * @param {Object} config The parser that defines the CDN.
         */ add: function add(key, config) {
        CdnParser._cdnConfigs[key] = config;
    }
});
// Adding built-in parsers
CdnParser.add("Level3", __webpack_require__(26946));
CdnParser.add("Cloudfront", __webpack_require__(46745));
CdnParser.add("Akamai", __webpack_require__(62358));
CdnParser.add("Highwinds", __webpack_require__(85835));
CdnParser.add("Fastly", __webpack_require__(18042));
CdnParser.add("Telefonica", __webpack_require__(61623));
CdnParser.add("Amazon", __webpack_require__(50576));
CdnParser.add("Edgecast", __webpack_require__(43155));
CdnParser.add("Balancer", __webpack_require__(68988));
CdnParser.add("NosOtt", __webpack_require__(48107));
module.exports = CdnParser;


/***/ }),

/***/ 62358:
/***/ ((module, exports, __webpack_require__) => {

// {@see CdnParser}

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
module.exports = {
    cdnName: "AKAMAI",
    // requestMethod: 'GET',
    parsers: [
        {
            element: "type+host",
            headerName: "X-Cache",
            regex: /(.+)\sfrom.+AkamaiGHost\/(.+)\).+/
        },
        {
            element: "host",
            headerName: "akamai-mon-iucid-del",
            regex: /(.*)/
        },
        {
            element: "type",
            headerName: "akamai-cache-status",
            regex: /(.+)\sfrom\schild/
        }
    ],
    requestHeaders: {
        Pragma: "akamai-x-cache-on"
    },
    parseType: function parseType(type) {
        var t = type.toLowerCase();
        if (t.indexOf("hit") !== -1) {
            return 1;
        } else if (t.indexOf("miss") !== -1) {
            return 2;
        }
        return 0;
    }
};


/***/ }),

/***/ 50576:
/***/ ((module, exports, __webpack_require__) => {

// {@see CdnParser}

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
module.exports = {
    cdnName: "AMAZON",
    parsers: [
        {
            element: "host",
            headerName: "x-amz-cf-pop",
            regex: /(.+)/
        },
        {
            element: "type",
            headerName: "x-cache",
            regex: /(.+)\sfrom.+/
        }
    ],
    parseType: function parseType(type) {
        if (type.toLowerCase().indexOf("hit") !== -1) {
            return 1;
        } else if (type.toLowerCase().indexOf("miss") !== -1) {
            return 2;
        }
        return 0;
    }
};


/***/ }),

/***/ 68988:
/***/ ((module, exports, __webpack_require__) => {

// {@see CdnParser}

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
module.exports = {
    parsers: [
        {
            element: "name",
            headerName: null,
            regex: /(.+)/
        },
        {
            element: "host",
            headerName: null,
            regex: /(.+)/
        }
    ]
};


/***/ }),

/***/ 46745:
/***/ ((module, exports, __webpack_require__) => {

// {@see CdnParser}

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
module.exports = {
    cdnName: "CLOUDFRT",
    parsers: [
        {
            element: "host",
            headerName: "X-Amz-Cf-Id",
            regex: /(.+)/
        },
        {
            element: "type",
            headerName: "X-Cache",
            regex: /(\S+)\s.+/
        }
    ],
    parseType: function parseType(type) {
        switch(type){
            case "Hit":
                return 1;
            case "Miss":
                return 2;
            default:
                return 0;
        }
    }
};


/***/ }),

/***/ 43155:
/***/ ((module, exports, __webpack_require__) => {

// {@see CdnParser}

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
module.exports = {
    cdnName: "EDGECAST",
    parsers: [
        {
            element: "host",
            headerName: "Server",
            regex: /\((.+)\/.+\)/
        },
        {
            element: "type",
            headerName: "X-Cache",
            regex: /(.+)/
        }
    ],
    parseType: function parseType(type) {
        switch(type){
            case "HIT":
                return 1;
            case "MISS":
            default:
                return 2;
        }
    }
};


/***/ }),

/***/ 18042:
/***/ ((module, exports, __webpack_require__) => {

// {@see CdnParser}

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
module.exports = {
    cdnName: "FASTLY",
    parsers: [
        {
            element: "host",
            headerName: "X-Served-By",
            regex: /([^,\s]+)$/
        },
        {
            element: "type",
            headerName: "X-Cache",
            regex: /([^,\s]+)$/
        }
    ],
    parseType: function parseType(type) {
        switch(type){
            case "HIT":
                return 1;
            case "MISS":
                return 2;
            default:
                return 0;
        }
    }
};


/***/ }),

/***/ 85835:
/***/ ((module, exports, __webpack_require__) => {

// {@see CdnParser}

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
module.exports = {
    cdnName: "HIGHNEGR",
    parsers: [
        {
            element: "host+type",
            headerName: "X-HW",
            regex: /.+,[0-9]+\.(.+)\.(.+)/
        }
    ],
    parseType: function parseType(type) {
        switch(type){
            case "c":
            case "x":
                return 1;
            default:
                return 2;
        }
    }
};


/***/ }),

/***/ 26946:
/***/ ((module, exports, __webpack_require__) => {

// {@see CdnParser}

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
module.exports = {
    cdnName: "LEVEL3",
    parsers: [
        {
            element: "host+type",
            headerName: "X-WR-Diag",
            regex: /Host:(.+)\sType:(.+)/
        }
    ],
    requestHeaders: {
        "X-WR-Diag": "host"
    },
    parseType: function parseType(type) {
        if (type) {
            if (type.indexOf("TCP_HIT") === 0 || type.indexOf("TCP_MEM_HIT") === 0 || type.indexOf("TCP_IMS_HIT") === 0) {
                return 1;
            } else if (type.indexOf("TCP_MISS") === 0) {
                return 2;
            }
        }
        return 0;
    }
};


/***/ }),

/***/ 48107:
/***/ ((module, exports, __webpack_require__) => {

// {@see CdnParser}

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
module.exports = {
    cdnName: "NOSOTT",
    parsers: [
        {
            element: "host",
            headerName: "X-NOS-Server",
            regex: /(.+)/
        },
        {
            element: "type",
            headerName: "X-Cache",
            regex: /(.*)/
        }
    ],
    parseType: function parseType(type) {
        switch(type){
            case "Hit":
                return 1;
            case "Miss":
                return 2;
            default:
                return 0;
        }
    }
};


/***/ }),

/***/ 61623:
/***/ ((module, exports, __webpack_require__) => {

// {@see CdnParser}

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
module.exports = {
    cdnName: "TELEFO",
    parsers: [
        {
            element: "host+type",
            headerName: "x-tcdn",
            regex: /Host:(.+)\sType:(.+)/
        }
    ],
    requestHeaders: {
        "x-tcdn": "host"
    },
    parseType: function parseType(type) {
        if (type) {
            if (type.indexOf("p") !== -1 || type.indexOf("c") !== -1) {
                return 1;
            } else if (type.indexOf("i") !== -1 || type.indexOf("m") !== -1) {
                return 2;
            }
        }
        return 0;
    }
};


/***/ }),

/***/ 41174:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var YBRequest = __webpack_require__(57195);
var Parser = __webpack_require__(94945);
var Log = __webpack_require__(39610);
var TransportFormat = __webpack_require__(60124);
var DashParser = Parser.extend(/** @lends youbora.DashParser.prototype */ {
    /**
     * Starts the Dash parsing from the given resource. The first (outside) call should set the
     * parentResource to null.
     *
     * @param {string} resource The resource url.
     */ parse: function parse(resource, lastManifest) {
        if (!lastManifest) {
            var request = new YBRequest(resource, null, null, {
                cache: true,
                requestHeaders: this._headers
            });
            request.on(YBRequest.Event.SUCCESS, (function(resp) {
                this.parseLocation(resp, resource);
            }).bind(this));
            request.on(YBRequest.Event.ERROR, (function(resp) {
                this.done();
            }).bind(this));
            request.send();
        } else {
            this.parseLocation(lastManifest, resource);
        }
    },
    parseLocation: function parseLocation(lastManifest, resource) {
        this.iterations--;
        var locationRegexp = new RegExp(/<Location>([\s\S]+)<\/Location>/);
        try {
            this._lastManifest = lastManifest;
            var manifest = lastManifest.getResponseText();
            var matches = locationRegexp.exec(manifest);
            if (matches && matches[1]) {
                var newRes = this._htmlDecode(matches[1].replace("\n", ""));
            }
            if (newRes && newRes !== resource && this.iterations > 0) {
                this.parse(newRes);
            } else {
                this.parseFinalResource(manifest, resource);
            }
        } catch (err) {
            Log.warn("Dash parse failed");
            this.done();
        }
    },
    _htmlDecode: function _htmlDecode(input) {
        if (typeof document !== "undefined" && typeof document.createElement === "function") {
            var e = document.createElement("textarea");
            e.innerHTML = input;
            return e.childNodes && e.childNodes.length ? e.childNodes[0].nodeValue : input;
        }
        return input;
    },
    parseFinalResource: function parseFinalResource(manifest, resource) {
        var baseUrlRegexp = new RegExp(/<BaseURL>[\r\n]*(.*?)[\r\n]*<\/BaseURL>/g);
        var segmentTemplateRegexp = new RegExp(/<SegmentTemplate[\s\S]*?media="([^"]+)"/g);
        var segmentUrlRegexp = new RegExp(/<SegmentURL[\s\S]*?media="([^"]+)"/g);
        var matches = null;
        try {
            if (this._parseLastChunk) {
                // Find all matches and take the last one
                var allMatches = [];
                var match;
                // Check BaseURL elements
                while((match = baseUrlRegexp.exec(manifest)) !== null){
                    if (match[1] && this._isFullUrl(match[1])) {
                        allMatches.push(match);
                    }
                }
                // If no BaseURL found, check SegmentTemplate
                if (allMatches.length === 0) {
                    while((match = segmentTemplateRegexp.exec(manifest)) !== null){
                        if (match[1]) {
                            allMatches.push(match);
                        }
                    }
                }
                // If no SegmentTemplate found, check SegmentURL
                if (allMatches.length === 0) {
                    while((match = segmentUrlRegexp.exec(manifest)) !== null){
                        if (match[1]) {
                            allMatches.push(match);
                        }
                    }
                }
                // Use the last match if available
                if (allMatches.length > 0) {
                    matches = allMatches[allMatches.length - 1];
                }
            } else {
                // Original behavior - get first match
                var baseUrlMatch = /<BaseURL>[\r\n]*(.*?)[\r\n]*<\/BaseURL>/.exec(manifest);
                var segmentTemplateMatch = /<SegmentTemplate[\s\S]*media="([^"]+)/.exec(manifest);
                var segmentUrlMatch = /<SegmentURL[\s\S]*media="([^"]+)/.exec(manifest);
                matches = baseUrlMatch || segmentTemplateMatch || segmentUrlMatch;
            }
            this._getManifestMetadata(manifest);
            if (matches && matches[1] && this._isFullUrl(matches[1])) {
                if (matches[1].indexOf('"') > 0) {
                    this._realResource = matches[1].substr(0, matches[1].indexOf('"')).replace("\n", "");
                } else {
                    this._realResource = matches[1].replace("\n", "");
                }
            } else {
                this._realResource = resource;
            }
        } catch (err) {
            Log.warn("Dash manifest parse failed");
        }
        this.done();
    },
    _getManifestMetadata: function _getManifestMetadata(manifest) {
        try {
            var transportFormatRegexp = new RegExp(/<AdaptationSet[\s\S]*mimeType="video\/([^"]+)/);
            var matches = transportFormatRegexp.exec(manifest);
            var ret = null;
            switch(matches[1]){
                case "mp4":
                case "m4s":
                    ret = TransportFormat.MP4;
                    break;
                case "mp2t":
                    ret = TransportFormat.MPEG2;
                    break;
                case "cmfv":
                    ret = TransportFormat.CMF;
                    break;
            }
            this._transportFormat = ret;
        } catch (err) {
            Log.warn("Couldnt find the transport format");
        }
    },
    _isFullUrl: function _isFullUrl(url) {
        return url.indexOf("http") !== -1;
    },
    shouldExecute: function shouldExecute(lastManifest) {
        var ret = true;
        if (lastManifest) {
            var response = lastManifest.getResponseText();
            ret = response.indexOf("<MPD") !== -1;
        }
        return ret;
    }
});
module.exports = DashParser;


/***/ }),

/***/ 91513:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
var YBRequest = __webpack_require__(57195);
var Parser = __webpack_require__(94945);
var Log = __webpack_require__(39610);
var TransportFormat = __webpack_require__(60124);
var HlsParser = Parser.extend(/** @lends youbora.HlsParser.prototype */ {
    /**
     * Starts the HLS parsing from the given resource. The first (outside) call should set the
     * parentResource to null.
     *
     * @param {string} resource Either the resource url or the manifest body.
     * @param {string} parentResource Parent resource in case relative paths are sent.
     */ parse: function parse(resource, lastManifest, parentResource) {
        parentResource = parentResource || "";
        var matches = null;
        try {
            // First try to find video streams (EXT-X-STREAM-INF lines followed by URLs)
            var videoStreamMatch = this._findVideoStreamUrl(resource);
            if (videoStreamMatch) {
                matches = videoStreamMatch;
            } else {
                // Prepare resource for parsing
                var preparedResource = resource.replaceAll(",URI=", "\n").replaceAll('"', "").replaceAll(",", "\n");
                if (this._parseLastChunk) {
                    // Find ALL matching chunks and take the last one
                    var allMatches = [];
                    var videoRegex = /((\S*?)(\.m3u8|\.m3u|\.ts|\.m4s|\.mp4|\.cmfv|\.fmp4)((\?|;)\S*|\n|\r|$))/gi;
                    var match;
                    while((match = videoRegex.exec(preparedResource)) !== null){
                        allMatches.push(match);
                    }
                    if (allMatches.length > 0) {
                        // Get the last match
                        matches = allMatches[allMatches.length - 1];
                    } else {
                        // If no video chunks found, look for audio chunks
                        var audioRegex = /((\S*?)(\.m4a|\.aac|\.mp3|\.ac3|\.ec3)((\?|;)\S*|\n|\r|$))/gi;
                        allMatches = [];
                        while((match = audioRegex.exec(preparedResource)) !== null){
                            allMatches.push(match);
                        }
                        if (allMatches.length > 0) {
                            matches = allMatches[allMatches.length - 1];
                        }
                    }
                } else {
                    // Original behavior - get first match
                    // Step 1: Prioritize video chunks and manifests
                    matches = /((\S*?)(\.m3u8|\.m3u|\.ts|\.m4s|\.mp4|\.cmfv|\.fmp4)((\?|;)\S*|\n|\r|$))/i.exec(preparedResource);
                    // Step 2: If no video chunks found, look for audio chunks only
                    if (!matches) {
                        matches = /((\S*?)(\.m4a|\.aac|\.mp3|\.ac3|\.ec3)((\?|;)\S*|\n|\r|$))/i.exec(preparedResource);
                    }
                }
            }
        } catch (err) {
            Log.warn("Parse HLS Regex failed", err);
            this.done();
        }
        if (matches !== null) {
            var res = matches[1].trim();
            var prevParent = "";
            var index = parentResource.lastIndexOf("/");
            if (res.indexOf("http") !== 0 && index !== -1) {
                // If does not start with http, add parentResource relative route.
                if (res[0] === "/" && res[1] !== "/") {
                    // if its a relative route not using the same path, but the same domain
                    var ind = parentResource.indexOf("/") + 1;
                    ind += parentResource.substr(ind, parentResource.length).indexOf("/") + 1 // Second '/'
                    ;
                    ind += parentResource.substr(ind, parentResource.length).indexOf("/") // Third '/'
                    ;
                    res = parentResource.slice(0, ind) + res;
                } else {
                    // if its sharing the (omitted) path
                    res = parentResource.slice(0, index) + "/" + res;
                }
                prevParent = parentResource.slice(0, index) + "/";
            }
            if (matches[3] === ".m3u8" || matches[3] === ".m3u") {
                if (!lastManifest) {
                    var request = new YBRequest(res, null, null, {
                        cache: true,
                        requestHeaders: this._headers
                    });
                    request.on(YBRequest.Event.SUCCESS, (function(resp) {
                        this._parseWithManifest(resp, prevParent, matches);
                    }).bind(this));
                    request.on(YBRequest.Event.ERROR, (function(resp) {
                        this.done();
                    }).bind(this));
                    request.send();
                } else {
                    this._parseWithManifest(lastManifest, prevParent, matches);
                }
            } else {
                switch(matches[3]){
                    case ".mp4":
                    case ".m4s":
                    case ".fmp4":
                        // Video chunks are also MP4
                        this._transportFormat = TransportFormat.MP4;
                        break;
                    case ".m4a":
                    case ".aac":
                    case ".mp3":
                    case ".ac3":
                    case ".ec3":
                        // Audio chunks are also MP4
                        this._transportFormat = TransportFormat.MP4;
                        break;
                    case ".ts":
                        this._transportFormat = TransportFormat.MPEG2;
                        break;
                    case ".cmfv":
                        this._transportFormat = TransportFormat.CMF;
                }
                this._realResource = res;
                this.done();
            }
        } else {
            this.done();
        }
    },
    _parseWithManifest: function _parseWithManifest(resp, prevParent, matches) {
        this._lastManifest = resp;
        this.parse(resp.getResponseText(), null, prevParent + matches[2]);
    },
    shouldExecute: function shouldExecute(lastManifest) {
        var ret = true;
        if (lastManifest) {
            var response = lastManifest.getResponseText();
            ret = response.indexOf("#EXTM3U") !== -1;
        }
        return ret;
    },
    _findVideoStreamUrl: function _findVideoStreamUrl(resource) {
        // Check if this looks like an HLS manifest
        if (resource.indexOf("#EXTM3U") === -1) {
            return null;
        }
        var lines = resource.split("\n");
        // Look for EXT-X-STREAM-INF lines (video streams) and get the URL from the next line
        for(var i = 0; i < lines.length - 1; i++){
            var line = lines[i].trim();
            // Skip audio-only streams by checking for AUDIO= without VIDEO= or RESOLUTION=
            if (line.indexOf("#EXT-X-STREAM-INF:") === 0) {
                // This is a video stream if it has RESOLUTION or doesn't specify it's audio-only
                var hasResolution = line.indexOf("RESOLUTION=") !== -1;
                var hasVideoCodec = line.indexOf("avc1.") !== -1 || line.indexOf("hev1.") !== -1 || line.indexOf("hvc1.") !== -1;
                // Consider this a video stream if it has resolution or video codecs
                if (hasResolution || hasVideoCodec) {
                    var nextLine = lines[i + 1].trim();
                    var urlMatch = /((\S*?)(\.m3u8|\.m3u)((\?|;)\S*|$))/i.exec(nextLine);
                    if (urlMatch) {
                        return urlMatch;
                    }
                }
            }
        }
        return null;
    }
});
module.exports = HlsParser;


/***/ }),

/***/ 74713:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
var YBRequest = __webpack_require__(57195);
var Parser = __webpack_require__(94945);
var LocationheaderParser = Parser.extend(/** @lends youbora.LocationheaderParser.prototype */ {
    /**
     * Set use get Request
     */ setGetRequest: function setGetRequest(getRequest) {
        this._getRequest = getRequest;
    },
    /**
     * Parses given header to check.
     */ parse: function parse(url, lastManifest) {
        if (!lastManifest) {
            this._realResource = url;
            var options = {
                cache: true,
                requestHeaders: this._headers
            };
            if (!this._getRequest) {
                options.method = "HEAD";
            }
            var request = new YBRequest(url, null, null, options);
            request.on(YBRequest.Event.SUCCESS, (function(resp) {
                this._parseWithManifest(resp);
            }).bind(this));
            request.on(YBRequest.Event.ERROR, (function(resp) {
                this.done();
            }).bind(this));
            request.send();
        } else {
            this._parseWithManifest(lastManifest);
        }
    },
    _parseWithManifest: function _parseWithManifest(resp) {
        this._lastManifest = resp;
        var response = resp.getResponseHeaders();
        var found = false;
        if (resp && resp.xhr && resp.xhr.responseURL && resp.xhr.responseURL !== this._realResource) {
            this._realResource = resp.xhr.responseURL;
            this.parse(this._realResource);
            found = true;
        } else {
            response.split("\n").forEach((function(line) {
                if (line.startsWith("Location:")) {
                    this._realResource = line.slice(10);
                    this.parse(this._realResource);
                    found = true;
                }
            }).bind(this));
        }
        if (!found) {
            this.done();
        }
    }
});
module.exports = LocationheaderParser;


/***/ }),

/***/ 94945:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
var Emitter = __webpack_require__(15885);
var Parser = Emitter.extend(/** @lends youbora.Parser.prototype */ {
    /**
     * Class that asynchronously parses a resource in order to get to the URL.
     *
     * Since the CDN detection is performed with the resource url, it is essential that this
     * resource url is pointing to the CDN that is actually hosting the manifest.
     *
     * @constructs Parser
     * @extends youbora.Emitter
     * @memberof youbora
     */ constructor: function constructor(headers) {
        this._realResource = null;
        this._lastManifest = null;
        this._transportFormat = null;
        this.iterations = 3;
        this._headers = headers;
        this._parseLastChunk = false;
    },
    /**
     * Sets whether to parse the last chunk instead of the first chunk
     * @param {boolean} parseLastChunk If true, will parse the last chunk
     */ setParseLastChunk: function setParseLastChunk(parseLastChunk) {
        this._parseLastChunk = parseLastChunk;
    },
    /**
     * Emits DONE event
     */ done: function done() {
        this.iterations = 3;
        this.emit(Parser.Event.DONE);
    },
    /**
     * Starts the parsing from the given resource.
     *
     * @param {string} resource The resource url.
     * @param {object} lastManifest The manifest request response if parsed previously.
     */ parse: function parse(resource, lastManifest) {},
    /**
     * Get the parsed resource. Will be null/undefined if parsing is not yet started and can be a partial
     * (an intermediate manifest) result if the parser is still running.
     *
     * @return {string} The parsed resource.
     */ getResource: function getResource() {
        return this._realResource;
    },
    /**
     * Get the transport format. Will be null/undefined if parsing is not yet started or is still running.
     *
     * @return {string} The parsed resource.
     */ getTransportFormat: function getTransportFormat() {
        return this._transportFormat;
    },
    /**
     * Get the last request manifest response object used to parse the resource.
     * Will be null/undefined if parsing is not yet started and can be a partial
     * (an intermediate manifest) result if the parser is still running.
     *
     * @return {object} The last manifest request response used to parse the resource.
     */ getLastManifest: function getLastManifest() {
        return this._lastManifest;
    },
    /**
     * Get the result of checking a previous manifest to detect if the parser should be used or not.
     *
     * @param {string} resource The resource url.
     * @return {object} The last manifest request response used to parse the resource.
     */ shouldExecute: function shouldExecute(lastManifest) {
        return true;
    }
}, /** @lends youbora.Parser */ {
    // Static members
    /**
     * List of events that could be fired from this class.
     * @enum
     */ Event: {
        /** Notifies that this DashParser is done processing. */ DONE: "done"
    }
});
module.exports = Parser;


/***/ }),

/***/ 51293:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var Emitter = __webpack_require__(15885);
var Transform = Emitter.extend(/** @lends youbora.Transform.prototype */ {
    /**
     * Transform classes in YOUBORA help the library parse and work with data.
     *
     * A Transform makes some kind of task that may block requests until it's done, or applies changes
     * to the requests right before they're finally sent.
     *
     * {@link ResourceTransform}, {@link ViewTransform}... all extend from this class.
     *
     * @constructs Transform
     * @extends youbora.Emitter
     * @memberof youbora
     * @abstract
     */ constructor: function constructor() {
        /**
       * Whether the Transform is currently working or not.
       * @private
       */ this._isBusy = true;
        this._sendRequest = true;
        this.transformName = "Transform";
    },
    /**
     * Override this method to transform info.
     *
     * @param {YBRequest} request Request to transform.
     */ parse: function parse(request) {},
    /**
     * By default this will return true until {@link #done()} is called. This can be overridden
     * in order to block {@link Request}s based on any criteria. For instance its
     * {@link Request#getService()}.
     *
     * @param {YBRequest} request Request to transform.
     * @return {bool} True if queue shall be blocked.
     */ isBlocking: function isBlocking(request) {
        return this._isBusy;
    },
    /**
     * Emits DONE event
     */ done: function done() {
        this._isBusy = false;
        this.emit(Transform.Event.DONE);
    },
    // offline
    hasToSend: function hasToSend(request) {
        return this._sendRequest;
    },
    getState: function getState() {
        if (!this._sendRequest) {
            return this.STATE_OFFLINE;
        }
        if (this._isBusy) {
            return this.STATE_BLOCKED;
        }
        return this.STATE_NO_BLOCKED;
    }
}, /** @lends youbora.Transform */ {
    // Static members
    STATE_OFFLINE: 2,
    STATE_BLOCKED: 1,
    STATE_NO_BLOCKED: 0,
    /**
     * List of events that could be fired from this class.
     * @enum
     */ Event: {
        /** Notifies that this Transform is done processing. */ DONE: "done"
    }
});
module.exports = Transform;


/***/ }),

/***/ 96726:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
var YBRequest = __webpack_require__(57195);
var Transform = __webpack_require__(51293);
var Log = __webpack_require__(39610);
var Util = __webpack_require__(37280);
var Constants = __webpack_require__(56230);
var ViewTransform = Transform.extend(/** @lends youbora.ViewTransform.prototype */ {
    /**
     * This class manages Fastdata service and view index.
     *
     * @constructs
     * @extends youbora.Transform
     * @memberof youbora
     *
     * @param {Plugin} plugin Instance of {@link Plugin}
     * @param {string} session If provided, plugin will use this as a FD response.
     */ constructor: function constructor(plugin, session) {
        Transform.prototype.constructor.apply(this, arguments);
        /** /data response */ this.response = {};
        this._viewIndex = new Date().getTime();
        this._session = session;
        this._httpSecure = plugin.options["app.https"];
        this._plugin = plugin;
        this.transformName = "View";
    },
    /**
     * Starts the 'FastData' fetching. This will send the initial request to YOUBORA in order to get
     * the needed info for the rest of the requests.
     *
     * This is an asynchronous process.
     *
     * When the fetch is complete, {@link #fastDataConfig} will contain the parsed info.
     * @see FastDataConfig
     */ init: function init() {
        // offline
        if (this._plugin.options && this._plugin.options.offline) {
            // set the options
            this.response.host = "OFFLINE";
            this.response.code = "OFFLINE";
            this.response.pingTime = 60;
            this.response.beatTime = 60;
            this.done();
            return null;
        }
        // reusing old data not expired
        if (this._plugin.storage.isEnabled()) {
            var now = new Date().getTime();
            if (now < this._plugin.sessionExpire + (Number(this._plugin.getDataTime()) || 0) && this._plugin.getStoredData()) {
                this.setData(this._plugin.getStoredData());
                return null;
            }
        }
        // request new data
        var service = Constants.Service.DATA;
        var params = {
            outputformat: "json"
        };
        params = this._plugin.requestBuilder.buildParams(params, service);
        if (params !== null) {
            Log.notice(service + " " + params.system);
            if (params.system === "nicetest") {
                // "nicetest" is the default accountCode.
                // If found here, it's very likely that the customer has forgotten to set it.
                Log.error("No accountCode has been set. Please set your accountCode inside plugin's options.");
            }
            new YBRequest(this._plugin.getHost(), service, params).on(YBRequest.Event.SUCCESS, this._receiveData.bind(this)).on(YBRequest.Event.ERROR, this._failedData.bind(this)).send();
        }
    },
    /**
     * Uses given response to set fastdata response.
     *
     * @param {String} response Fastdata response as json string.
     */ setData: function setData(response) {
        try {
            var resp = JSON.parse(response);
            if (this._plugin.options["parse.fdsResponseHost"]) {
                response = response.replace(resp.q.h, this._plugin.options["parse.fdsResponseHost"](resp.q.h));
                resp = JSON.parse(response);
            }
            this.response.msg = response;
            this.response.host = Util.addProtocol(resp.q.h, this._httpSecure);
            this.response.code = resp.q.c;
            this.response.pingTime = resp.q.pt || 5;
            this.response.beatTime = resp.q.i ? resp.q.i.bt || 30 : 30;
            this.response.sessionExpire = resp.q.i ? resp.q.i.exp || 300 : 300;
            this._plugin.storage.setLocal("sessionExpire", this.response.sessionExpire);
            this.done();
        } catch (err) {
            Log.error("Fastdata response is invalid.");
        }
    },
    /**
     * Parse the response from the fastData service.
     *
     * @private
     */ _receiveData: function _receiveData(req, e) {
        var msg = req.getResponse();
        this.setData(msg);
    },
    _failedData: function _failedData(req, e) {
        Log.error("Fastdata request has failed.");
    },
    /**
     * This method will increment the view index (timestamp values). The library handles this
     * automatically, but some error flow might need calling this manually.
     * @return {string} new viewcode
     */ nextView: function nextView() {
        this._viewIndex = new Date().getTime();
        return this.getViewCode();
    },
    /**
     * Returns current viewcode
     * @return {string} viewcode
     */ getViewCode: function getViewCode(viewIndex) {
        if (viewIndex !== null && this._plugin && this._plugin.options && this._plugin.options["session.splitViews"]) {
            return this.response.code + "_" + (viewIndex || this._viewIndex);
        }
        return this.response.code + "_" + this._viewIndex;
    },
    /**
     * Returns the current session
     *
     * @returns {string} Session
     */ getSession: function getSession() {
        return this._session;
    },
    /**
     * Sets the session
     *
     * @param {String} sessionId Sets the session
     */ setSession: function setSession(session) {
        this._session = session;
    },
    /** Sets the host url
    *
    * @param {String} host Sets the host
    */ setHost: function setHost(host) {
        this.response.host = host;
    },
    /**
     * Transform requests
     * @param {youbora.comm.YBRequest} request YBRequest to transform.
     */ parse: function parse(request) {
        // Host, system and sessionRoot for all
        request.host = request.host || this.response.host;
        request.params.system = this._plugin.getAccountCode();
        request.params.sessionRoot = request.params.sessionRoot || this.getSession();
        // PingTime for ping and start
        if (ViewTransform.EventList.PingTime.indexOf(request.service) !== -1) {
            request.params.pingTime = request.params.pingTime || this.response.pingTime;
        }
        // ViewCode for non infinity events
        if (ViewTransform.EventList.Infinity.indexOf(request.service) === -1) {
            if (this._plugin && this._plugin.options && this._plugin.options["session.splitViews"]) {
                request.params.code = request.params.code || this.getViewCode(request.params.viewIndex);
                delete request.params.viewIndex;
            } else {
                request.params.code = request.params.code || this.getViewCode();
            }
        } else {
            // For infinity events, sessionId
            request.params.sessionId = request.params.sessionRoot;
        }
        // For init error and start, parentId and navContext
        if (ViewTransform.EventList.CreateView.indexOf(request.service) !== -1) {
            if (this._plugin.infinity.infinityStarted || this._plugin.storage.isEnabled() && this._plugin.storage.getLocal("infinityStarted")) {
                request.params.parentId = request.params.sessionRoot;
                request.params.navContext = request.params.navContext || this._plugin.getContext();
            }
        }
    }
}, {
    // Static members
    EventList: {
        CreateView: [
            Constants.Service.START,
            Constants.Service.INIT,
            Constants.Service.ERROR
        ],
        Infinity: [
            Constants.Service.NAV,
            Constants.Service.SESSION_START,
            Constants.Service.SESSION_STOP,
            Constants.Service.EVENT,
            Constants.Service.EVENT_END,
            Constants.Service.BEAT
        ],
        PingTime: [
            Constants.Service.START,
            Constants.Service.PING
        ]
    }
});
module.exports = ViewTransform;


/***/ }),

/***/ 52993:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
var Transform = __webpack_require__(51293);
/**
 * This transform ensures that no requests will be sent without sessionId when is required
 *
 * @constructs
 * @extends youbora.Transform
 * @memberof youbora
 * @name WrongTransform
 *
 * @param {Plugin} plugin Instance of {@link Plugin}
 */ var WrongTransform = Transform.extend(/** @lends youbora.WrongTransform.prototype */ {
    /**
   * Returns if transform is blocking.
   *
   * @param {YBRequest} request Request to transform.
   * @return {bool} True if queue shall be blocked.
   */ isBlocking: function isBlocking(request) {
        if (!request.params.sessionId) {
            return true;
        }
        return false;
    }
});
module.exports = WrongTransform;


/***/ }),

/***/ 56230:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var AdPosition = __webpack_require__(70752);
var Adapter = __webpack_require__(76917);
var ManifestError = __webpack_require__(78109);
var RequestMethod = __webpack_require__(84586);
var Service = __webpack_require__(533);
var WillSendEvent = __webpack_require__(96962);
var AdInsertionType = __webpack_require__(23782);
/**
 * This static class englobes youbora constants.
 *
 * @class
 * @static
 * @memberof youbora
 */ var Constants = {
    AdPosition: AdPosition,
    ManifestError: ManifestError,
    RequestMethod: RequestMethod,
    Service: Service,
    WillSendEvent: WillSendEvent,
    AdInsertionType: AdInsertionType,
    Adapter: Adapter
};
module.exports = Constants;


/***/ }),

/***/ 23782:
/***/ ((module, exports, __webpack_require__) => {

/**
 * List of ad insertion types
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
var InsertionType = {
    ClientSide: "csai",
    ServerSide: "ssai"
};
module.exports = InsertionType;


/***/ }),

/***/ 70752:
/***/ ((module, exports, __webpack_require__) => {

/**
 * List of ad positions
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
var AdPosition = {
    Preroll: "pre",
    Midroll: "mid",
    Postroll: "post"
};
module.exports = AdPosition;


/***/ }),

/***/ 76917:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
var Event = __webpack_require__(49834);
var Adapter = {
    Event: Event
};
module.exports = Adapter;


/***/ }),

/***/ 49834:
/***/ ((module, exports, __webpack_require__) => {

/**
 * List of events that can be triggered by the adapter
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
var Event = {
    START: "start",
    JOIN: "join",
    PAUSE: "pause",
    RESUME: "resume",
    SEEK_BEGIN: "seek-begin",
    SEEK_END: "seek-end",
    BUFFER_BEGIN: "buffer-begin",
    BUFFER_END: "buffer-end",
    ERROR: "error",
    STOP: "stop",
    CLICK: "click",
    MANIFEST: "manifest",
    PODSTART: "break-start",
    PODSTOP: "break-stop",
    QUARTILE: "quartile",
    VIDEO_EVENT: "video-event",
    VIDEO_EVENT_END: "video-event-end"
};
module.exports = Event;


/***/ }),

/***/ 78109:
/***/ ((module, exports, __webpack_require__) => {

/**
* List of ad manifest errors
*/ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var ManifestError = {
    NO_RESPONSE: "NO_RESPONSE",
    EMPTY: "EMPTY_RESPONSE",
    WRONG: "WRONG_RESPONSE"
};
module.exports = ManifestError;


/***/ }),

/***/ 84586:
/***/ ((module, exports, __webpack_require__) => {

/**
 * List of Request Methods
 *   - GET
 *   - POST
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var RequestMethod = {
    GET: "get",
    POST: "post"
};
module.exports = RequestMethod;


/***/ }),

/***/ 533:
/***/ ((module, exports, __webpack_require__) => {

/**
 * List of youbora services.
 *
 * @enum
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
var Service = {
    DATA: "/data",
    // Video
    INIT: "/init",
    START: "/start",
    JOIN: "/joinTime",
    PAUSE: "/pause",
    RESUME: "/resume",
    SEEK: "/seek",
    BUFFER: "/bufferUnderrun",
    ERROR: "/error",
    STOP: "/stop",
    PING: "/ping",
    VIDEO_EVENT: "/infinity/video/event",
    VIDEO_EVENT_END: "/infinity/video/event/stop",
    // Ads
    AD_INIT: "/adInit",
    AD_START: "/adStart",
    AD_JOIN: "/adJoin",
    AD_PAUSE: "/adPause",
    AD_RESUME: "/adResume",
    AD_BUFFER: "/adBufferUnderrun",
    AD_STOP: "/adStop",
    AD_CLICK: "/adClick",
    AD_ERROR: "/adError",
    AD_MANIFEST: "/adManifest",
    AD_POD_START: "/adBreakStart",
    AD_POD_STOP: "/adBreakStop",
    AD_QUARTILE: "/adQuartile",
    // Infinity
    EVENT: "/infinity/session/event",
    EVENT_END: "/infinity/session/event/stop",
    SESSION_START: "/infinity/session/start",
    SESSION_STOP: "/infinity/session/stop",
    NAV: "/infinity/session/nav",
    BEAT: "/infinity/session/beat",
    // Offline
    OFFLINE_EVENTS: "/offlineEvents"
};
module.exports = Service;


/***/ }),

/***/ 48679:
/***/ ((module, exports, __webpack_require__) => {

/**
 * List of streaming protocols
 *   - HDS (Adobe HDS)
 *   - HLS (Apple HLS)
 *   - MSS (Microsoft Smooth Streaming)
 *   - DASH (MPEG-DASH)
 *   - RTMP (Adobe RTMP)
 *   - RTP (RTP)
 *   - RTSP (RTSP)
 *   - MULTICAST (Multicast)
 *   - DVB (DVB)
 *   - DVBC (DVB-C)
 *   - DVBT (DVB-T)
 *   - DVBT2 (DVB-T2)
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
var StreamingProtocol = {
    HDS: "HDS",
    HLS: "HLS",
    MSS: "MSS",
    DASH: "DASH",
    RTMP: "RTMP",
    RTP: "RTP",
    RTSP: "RTSP",
    DVB: "DVB",
    DVBC: "DVB-C",
    DVBT: "DVB-T",
    DVBT2: "DVB-T2",
    MULTICAST: "MULTICAST"
};
module.exports = StreamingProtocol;


/***/ }),

/***/ 60124:
/***/ ((module, exports, __webpack_require__) => {

/**
 * List of transport formats
 *   - TS (MPEG-2 TS)
 *   - MP4 (Fragmented MP4)
 *   - CMF
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
var TransportFormat = {
    MP4: "MP4",
    MPEG2: "TS",
    CMF: "CMF"
};
module.exports = TransportFormat;


/***/ }),

/***/ 96962:
/***/ ((module, exports, __webpack_require__) => {

/**
 * List of will-send events.
 *
 * @memberof youbora.Plugin
 * @enum
 * @event
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
var WillSendEvent = {
    WILL_SEND_INIT: "will-send-init",
    WILL_SEND_START: "will-send-start",
    WILL_SEND_JOIN: "will-send-join",
    WILL_SEND_PAUSE: "will-send-pause",
    WILL_SEND_RESUME: "will-send-resume",
    WILL_SEND_SEEK: "will-send-seek",
    WILL_SEND_BUFFER: "will-send-buffer",
    WILL_SEND_ERROR: "will-send-error",
    WILL_SEND_FATAL_ERROR: "will-send-fatal-error",
    WILL_SEND_STOP: "will-send-stop",
    WILL_SEND_PING: "will-send-ping",
    WILL_SEND_VIDEO_EVENT: "will-send-video-event",
    WILL_SEND_VIDEO_EVENT_END: "will-send-video-event-end",
    WILL_SEND_AD_START: "will-send-ad-start",
    WILL_SEND_AD_JOIN: "will-send-ad-join",
    WILL_SEND_AD_PAUSE: "will-send-ad-pause",
    WILL_SEND_AD_RESUME: "will-send-ad-resume",
    WILL_SEND_AD_BUFFER: "will-send-ad-buffer",
    WILL_SEND_AD_STOP: "will-send-ad-stop",
    WILL_SEND_AD_CLICK: "will-send-ad-click",
    WILL_SEND_AD_ERROR: "will-send-ad-error",
    WILL_SEND_AD_MANIFEST: "will-send-ad-manifest",
    WILL_SEND_AD_POD_START: "will-send-ad-break-start",
    WILL_SEND_AD_POD_STOP: "will-send-ad-break-stop",
    WILL_SEND_AD_QUARTILE: "will-send-ad-quartile",
    WILL_SEND_SESSION_START: "will-send-session-start",
    WILL_SEND_SESSION_STOP: "will-send-session-stop",
    WILL_SEND_NAV: "will-send-nav",
    WILL_SEND_BEAT: "will-send-beat",
    WILL_SEND_EVENT: "will-send-event",
    WILL_SEND_EVENT_END: "will-send-event-end",
    WILL_SEND_OFFLINE_EVENTS: "will-send-offline-events"
};
module.exports = WillSendEvent;


/***/ }),

/***/ 64413:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var YouboraObject = __webpack_require__(831);
/**
 * This static class provides device detection methods.
 *
 * @class
 * @static
 * @memberof youbora
 */ var BackgroundDetector = YouboraObject.extend({
    constructor: function constructor(plugin) {
        this.plugin = plugin;
        this.isInBackground = false;
        this.listenerReference = this._visibilityListener.bind(this);
        this._reset();
    },
    startDetection: function startDetection() {
        if (!this.isBackgroundDetectorStarted && typeof document !== "undefined") {
            this.isBackgroundDetectorStarted = true;
            document.addEventListener("visibilitychange", this.listenerReference);
        }
    },
    stopDetection: function stopDetection() {
        if (this.isBackgroundDetectorStarted && typeof document !== "undefined") {
            document.removeEventListener("visibilitychange", this.listenerReference);
            this._reset();
        }
    },
    _reset: function _reset() {
        this.isBackgroundDetectorStarted = false;
    },
    _visibilityListener: function _visibilityListener(e) {
        if (typeof document !== "undefined") {
            var settings = this._getSettings();
            if (document.visibilityState === "hidden") {
                this._toBackground(settings);
            } else if (document.visibilityState === "visible") {
                this._toForeground(settings);
            }
        }
    },
    _toBackground: function _toBackground(settings) {
        this.isInBackground = true;
        if (this.plugin && this.plugin._adsAdapter) {
            this.plugin._adsAdapter.stopChronoView();
        }
        if (typeof settings === "string") {
            switch(settings){
                case "stop":
                    this._fireStop();
                    break;
                case "pause":
                    this._firePause();
                    break;
            }
            if (this.plugin.infinity.infinityStarted) {
                this.lastBeatTime = new Date().getTime();
                var difftime = this.plugin._beat.chrono.startTime ? this.lastBeatTime - this.plugin._beat.chrono.startTime : 0;
                this.plugin._sendBeat(difftime);
                this.plugin._beat.stop();
            }
        }
    },
    _toForeground: function _toForeground(settings) {
        this.isInBackground = false;
        // ads
        if (this.plugin && this.plugin._adsAdapter) {
            this.plugin._adsAdapter.startChronoView();
        }
        // nothing for video yet
        if (typeof settings === "string" && settings) {
            if (this.plugin.infinity.infinityStarted) {
                var now = new Date().getTime();
                if (now - this.lastBeatTime < this.plugin.sessionExpire) {
                    this.plugin._sendBeat(now - this.lastBeatTime);
                    this.plugin._beat.start();
                } else {
                    this.plugin.infinity.newSession();
                }
            }
        }
    },
    _getSettings: function _getSettings() {
        if (typeof this.plugin.options["background.settings"] === "string" && this.plugin.options["background.settings"]) {
            return this.plugin.options["background.settings"];
        }
        if (this.plugin.deviceDetector.isSmartTV()) {
            return this.plugin.options["background.settings.tv"];
        }
        if (this.plugin.deviceDetector.isDesktop()) {
            return this.plugin.options["background.settings.desktop"];
        }
        if (this.plugin.deviceDetector.isAndroid()) {
            return this.plugin.options["background.settings.android"];
        }
        if (this.plugin.deviceDetector.isIphone()) {
            return this.plugin.options["background.settings.iOS"];
        }
        if (this.plugin.deviceDetector.isPlayStation()) {
            return this.plugin.options["background.settings.playstation"];
        }
    },
    _firePause: function _firePause() {
        this._fireX("firePause");
    },
    _fireStop: function _fireStop() {
        this._fireX("fireStop");
        this.plugin.fireStop();
    },
    _fireX: function _fireX(fireMethod) {
        this.adsAdapter = this.plugin.getAdsAdapter();
        if (this.adsAdapter) {
            this.adsAdapter[fireMethod]();
        }
        this.contentAdapter = this.plugin.getAdapter();
        if (this.contentAdapter) {
            this.contentAdapter[fireMethod]();
        }
    },
    canBlockStartCalls: function canBlockStartCalls() {
        return this.isInBackground && this.plugin.options["background.enabled"] === true && this._getSettings() // it is stop or pause
        ;
    }
});
module.exports = BackgroundDetector;


/***/ }),

/***/ 1329:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
var YouboraObject = __webpack_require__(831);
/**
 * This static class provides device detection methods.
 *
 * @class
 * @static
 * @memberof youbora
 */ var DeviceDetector = YouboraObject.extend({
    constructor: function constructor() {
        if (typeof navigator !== "undefined" && navigator.userAgent) {
            this._isSmartTVDevice = navigator.userAgent.toLowerCase().match(/smarttv/) || navigator.userAgent.toLowerCase().match(/smart-tv/) || navigator.userAgent.toLowerCase().match(/appletv/) || navigator.userAgent.toLowerCase().match(/apple tv/);
            this._isPlaystationDevice = navigator.userAgent.match(/PlayStation/) !== null;
            this._isIphoneDevice = navigator.userAgent.match(/iPhone|iPad|iPod/i) !== null;
            this._isAndroidDevice = navigator.userAgent.match(/Android/) !== null;
            this._isSmartphoneDevice = !this._isSmartTVDevice && !this._isPlaystationDevice && (this._isIphoneDevice || this._isAndroidDevice);
            this._isDesktopDevice = !this._isSmartphoneDevice && !this._isSmartTVDevice && !this._isPlaystationDevice;
        }
    },
    isIphone: function isIphone() {
        return this._isIphoneDevice;
    },
    isAndroid: function isAndroid() {
        return this._isAndroidDevice;
    },
    isSmartphone: function isSmartphone() {
        return this._isSmartphoneDevice;
    },
    isDesktop: function isDesktop() {
        return this._isDesktopDevice;
    },
    isSmartTV: function isSmartTV() {
        return this._isSmartTVDevice;
    },
    isPlayStation: function isPlayStation() {
        return this._isPlaystationDevice;
    }
});
module.exports = DeviceDetector;


/***/ }),

/***/ 49855:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var YouboraObject = __webpack_require__(831);
/**
 * This static class provides screen scrolling and resizing detection methods.
 *
 * @class
 * @static
 * @memberof youbora
 */ var ResizeScrollDetector = YouboraObject.extend({
    constructor: function constructor(plugin) {
        this.pluginref = plugin;
        this.listenerReference = this._changeListener.bind(this);
        this.loadReference = this._loadListener.bind(this);
        this.isEnabled = false;
        this.pageHeight = 0;
        this.maxHeight = 0;
        this.startDetection();
    },
    startDetection: function startDetection() {
        if (!this.isEnabled && typeof window !== "undefined" && typeof window.addEventListener === "function") {
            window.addEventListener("scroll", this.listenerReference);
            window.addEventListener("resize", this.listenerReference);
            window.addEventListener("load", this.loadReference);
            this.isEnabled = true;
        }
    },
    stopDetection: function stopDetection() {
        if (this.isEnabled && typeof window !== "undefined" && typeof window.removeEventListener === "function") {
            window.removeEventListener("scroll", this.listenerReference);
            window.removeEventListener("resize", this.listenerReference);
            window.removeEventListener("load", this.loadReference);
            this.isEnabled = false;
        }
    },
    getScrollDepth: function getScrollDepth() {
        var ret = null;
        if (this.maxHeight && this.pageHeight) {
            ret = Math.min(Math.trunc(this.maxHeight / this.pageHeight * 100), 100);
        }
        return ret;
    },
    _loadListener: function _loadListener() {
        if (typeof document !== "undefined") {
            var docEl = document.documentElement;
            if (docEl) {
                this.pageHeight = Math.round(docEl.scrollHeight, docEl.clientHeight, docEl.offsetHeight);
                this.maxHeight = window.innerHeight;
                this._updateCompletionRate();
            }
        }
    },
    _changeListener: function _changeListener() {
        if (this.pageHeight) {
            var prevHeight = this.maxHeight;
            this.maxHeight = Math.max(this.maxHeight, window.pageYOffset + window.innerHeight);
            if (prevHeight !== this.maxHeight) {
                this._updateCompletionRate();
            }
        }
        var adsAdapter = this.pluginref.getAdsAdapter();
        if (adsAdapter && adsAdapter.flags.isStarted) {
            if (!adsAdapter.getIsVisible()) {
                adsAdapter.stopChronoView();
            } else {
                adsAdapter.startChronoView();
            }
        }
    },
    _updateCompletionRate: function _updateCompletionRate() {
        setTimeout((function() {
            this.pluginref.storage.setSession("pageScrollDepth", this.getScrollDepth());
        }).bind(this), 3000);
    }
});
module.exports = ResizeScrollDetector;


/***/ }),

/***/ 43058:
/***/ ((module, exports, __webpack_require__) => {

/* global ActiveXObject */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
var YouboraObject = __webpack_require__(831);
var DataExtractor = YouboraObject.extend({
    constructor: function constructor(plugin) {
        this.plugin = plugin;
    },
    getAllData: function getAllData() {
        var returnValue = this.getNonRandomData();
        returnValue.timestamp = this.getTimestamp();
        return returnValue;
    },
    getNonRandomData: function getNonRandomData() {
        var returnValue = {};
        returnValue.userAgent = this.getUserAgent();
        returnValue.threads = this.getVirtualCores();
        returnValue.language = this.getLanguage();
        returnValue.langList = this.getAvailableLanguages();
        returnValue.resolution = this.getResolution();
        returnValue.colorDepth = this.getColorDepth();
        returnValue.deviceMemory = this.getMemory();
        returnValue.touchscreen = this.getTouchscreen();
        returnValue.localStorage = this.getLocalStorage();
        returnValue.sessionStorage = this.getSessionStorage();
        returnValue.cookiesAvailable = this.getCookiesAvailable();
        returnValue.flashAvailable = this.getHasFlash();
        returnValue.timeZone = this.getTimeZone();
        returnValue.plugins = this.getPluginList();
        return returnValue;
    },
    // Getters
    getUserAgent: function getUserAgent() {
        return this._getNavigatorValue("userAgent");
    },
    getVirtualCores: function getVirtualCores() {
        return this._getNavigatorValue("hardwareConcurrency");
    },
    getLanguage: function getLanguage() {
        return this._getNavigatorValue("language");
    },
    getAvailableLanguages: function getAvailableLanguages() {
        return this._getNavigatorValue("languages");
    },
    getResolution: function getResolution() {
        var ret = null;
        try {
            if (this._getNavigatorValue("screen")) {
                ret = navigator.screen.width.toString() + navigator.screen.height.toString();
            }
        } catch (err) {
        // ret = null
        }
        return ret;
    },
    getColorDepth: function getColorDepth() {
        var ret = null;
        try {
            if (this._getNavigatorValue("screen")) {
                ret = navigator.screen.colorDepth;
            }
        } catch (err) {
        // ret = null
        }
        return ret;
    },
    getMemory: function getMemory() {
        return this._getNavigatorValue("deviceMemory");
    },
    getTouchscreen: function getTouchscreen() {
        return this._getNavigatorValue("maxTouchPoints") || false;
    },
    getLocalStorage: function getLocalStorage() {
        var ret = false;
        try {
            ret = typeof localStorage !== "undefined";
        } catch (err) {
        // ret = false
        }
        return ret;
    },
    getSessionStorage: function getSessionStorage() {
        var ret = false;
        try {
            ret = typeof sessionStorage !== "undefined";
        } catch (err) {
        // ret = false
        }
        return ret;
    },
    getCookiesAvailable: function getCookiesAvailable() {
        return this._getNavigatorValue("cookieEnabled") || false;
    },
    getHasFlash: function getHasFlash() {
        var ret = false;
        try {
            var plugins = this._getNavigatorValue("plugins");
            ret = plugins && typeof plugins["Shockwave Flash"] === "object" || typeof window !== "undefined" && window.ActiveXObject && new ActiveXObject("ShockwaveFlash.ShockwaveFlash") !== false;
        } catch (err) {
        // ret = false
        }
        return ret;
    },
    getPluginList: function getPluginList() {
        var ret = null;
        try {
            var plugins = this._getNavigatorValue("plugins");
            if (plugins && plugins.length !== 0) {
                var pluginlist = "";
                for(var counter = 0; counter < navigator.plugins.length; counter++){
                    pluginlist += navigator.plugins[counter].description + " " + navigator.plugins[counter].filename + " " + navigator.plugins[counter].name + " ";
                }
                ret = pluginlist;
            }
        } catch (err) {
        // return null
        }
        return ret;
    },
    getTimeZone: function getTimeZone() {
        var ret = null;
        try {
            var date = new Date();
            ret = date.getTimezoneOffset().toString();
        } catch (err) {
        // return null
        }
        return ret;
    },
    getTimestamp: function getTimestamp() {
        return new Date().getTime();
    },
    _navigatorCheck: function _navigatorCheck() {
        return typeof navigator !== "undefined";
    },
    _getNavigatorValue: function _getNavigatorValue(key) {
        var ret = null;
        try {
            if (this._navigatorCheck()) {
                ret = navigator[key];
            }
        } catch (err) {
        // ret = null
        }
        return ret;
    }
});
module.exports = DataExtractor;


/***/ }),

/***/ 1879:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
var DataExtractor = __webpack_require__(43058);
var YouboraObject = __webpack_require__(831);
var MD5 = __webpack_require__(73329);
var HashGenerator = YouboraObject.extend({
    constructor: function constructor(plugin) {
        this.plugin = plugin;
        this.dataExtractor = new DataExtractor();
        this.key = this.getPreviousKey();
    },
    generateHashKey: function generateHashKey() {
        if (!this.key) {
            var data = this.dataExtractor.getAllData();
            this.key = this._hashFunction(data);
            this.plugin.storage.setLocal("youboraDeviceUUID", this.key);
        }
    },
    getKey: function getKey() {
        if (!this.key) this.generateHashKey();
        return this.key;
    },
    _hashFunction: function _hashFunction(inputString) {
        var outputString = inputString;
        if (typeof inputString !== "string") {
            outputString = JSON.stringify(inputString);
        }
        return MD5(outputString);
    },
    _reset: function _reset() {
        this.key = undefined;
    },
    getPreviousKey: function getPreviousKey() {
        return this.plugin.storage.getLocal("youboraDeviceUUID");
    }
});
module.exports = HashGenerator;


/***/ }),

/***/ 73329:
/***/ ((module, exports, __webpack_require__) => {

/* istanbul ignore next */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
var MD5 = function MD5(s) {
    function L(k, d) {
        return k << d | k >>> 32 - d;
    }
    function K(G, k) {
        var I, d, F, H, x;
        F = G & 2147483648;
        H = k & 2147483648;
        I = G & 1073741824;
        d = k & 1073741824;
        x = (G & 1073741823) + (k & 1073741823);
        if (I & d) {
            return x ^ 2147483648 ^ F ^ H;
        }
        if (I | d) {
            if (x & 1073741824) {
                return x ^ 3221225472 ^ F ^ H;
            } else {
                return x ^ 1073741824 ^ F ^ H;
            }
        } else {
            return x ^ F ^ H;
        }
    }
    function r(d, F, k) {
        return d & F | ~d & k;
    }
    function q(d, F, k) {
        return d & k | F & ~k;
    }
    function p(d, F, k) {
        return d ^ F ^ k;
    }
    function n(d, F, k) {
        return F ^ (d | ~k);
    }
    function u(G, F, aa, Z, k, H, I) {
        G = K(G, K(K(r(F, aa, Z), k), I));
        return K(L(G, H), F);
    }
    function f(G, F, aa, Z, k, H, I) {
        G = K(G, K(K(q(F, aa, Z), k), I));
        return K(L(G, H), F);
    }
    function D(G, F, aa, Z, k, H, I) {
        G = K(G, K(K(p(F, aa, Z), k), I));
        return K(L(G, H), F);
    }
    function t(G, F, aa, Z, k, H, I) {
        G = K(G, K(K(n(F, aa, Z), k), I));
        return K(L(G, H), F);
    }
    function e(G) {
        var Z;
        var F = G.length;
        var x = F + 8;
        var k = (x - x % 64) / 64;
        var I = (k + 1) * 16;
        var aa = Array(I - 1);
        var d = 0;
        var H = 0;
        while(H < F){
            Z = (H - H % 4) / 4;
            d = H % 4 * 8;
            aa[Z] = aa[Z] | G.charCodeAt(H) << d;
            H++;
        }
        Z = (H - H % 4) / 4;
        d = H % 4 * 8;
        aa[Z] = aa[Z] | 128 << d;
        aa[I - 2] = F << 3;
        aa[I - 1] = F >>> 29;
        return aa;
    }
    function B(x) {
        var k = "", F = "", G, d;
        for(d = 0; d <= 3; d++){
            G = x >>> d * 8 & 255;
            F = "0" + G.toString(16);
            k = k + F.substr(F.length - 2, 2);
        }
        return k;
    }
    function J(k) {
        k = k.replace(/rn/g, "n");
        var d = "";
        for(var F = 0; F < k.length; F++){
            var x = k.charCodeAt(F);
            if (x < 128) {
                d += String.fromCharCode(x);
            } else {
                if (x > 127 && x < 2048) {
                    d += String.fromCharCode(x >> 6 | 192);
                    d += String.fromCharCode(x & 63 | 128);
                } else {
                    d += String.fromCharCode(x >> 12 | 224);
                    d += String.fromCharCode(x >> 6 & 63 | 128);
                    d += String.fromCharCode(x & 63 | 128);
                }
            }
        }
        return d;
    }
    var C = Array();
    var P, h, E, v, g, Y, X, W, V;
    var S = 7, Q = 12, N = 17, M = 22;
    var A = 5, z = 9, y = 14, w = 20;
    var o = 4, m = 11, l = 16, j = 23;
    var U = 6, T = 10, R = 15, O = 21;
    s = J(s);
    C = e(s);
    Y = 1732584193;
    X = 4023233417;
    W = 2562383102;
    V = 271733878;
    for(P = 0; P < C.length; P += 16){
        h = Y;
        E = X;
        v = W;
        g = V;
        Y = u(Y, X, W, V, C[P + 0], S, 3614090360);
        V = u(V, Y, X, W, C[P + 1], Q, 3905402710);
        W = u(W, V, Y, X, C[P + 2], N, 606105819);
        X = u(X, W, V, Y, C[P + 3], M, 3250441966);
        Y = u(Y, X, W, V, C[P + 4], S, 4118548399);
        V = u(V, Y, X, W, C[P + 5], Q, 1200080426);
        W = u(W, V, Y, X, C[P + 6], N, 2821735955);
        X = u(X, W, V, Y, C[P + 7], M, 4249261313);
        Y = u(Y, X, W, V, C[P + 8], S, 1770035416);
        V = u(V, Y, X, W, C[P + 9], Q, 2336552879);
        W = u(W, V, Y, X, C[P + 10], N, 4294925233);
        X = u(X, W, V, Y, C[P + 11], M, 2304563134);
        Y = u(Y, X, W, V, C[P + 12], S, 1804603682);
        V = u(V, Y, X, W, C[P + 13], Q, 4254626195);
        W = u(W, V, Y, X, C[P + 14], N, 2792965006);
        X = u(X, W, V, Y, C[P + 15], M, 1236535329);
        Y = f(Y, X, W, V, C[P + 1], A, 4129170786);
        V = f(V, Y, X, W, C[P + 6], z, 3225465664);
        W = f(W, V, Y, X, C[P + 11], y, 643717713);
        X = f(X, W, V, Y, C[P + 0], w, 3921069994);
        Y = f(Y, X, W, V, C[P + 5], A, 3593408605);
        V = f(V, Y, X, W, C[P + 10], z, 38016083);
        W = f(W, V, Y, X, C[P + 15], y, 3634488961);
        X = f(X, W, V, Y, C[P + 4], w, 3889429448);
        Y = f(Y, X, W, V, C[P + 9], A, 568446438);
        V = f(V, Y, X, W, C[P + 14], z, 3275163606);
        W = f(W, V, Y, X, C[P + 3], y, 4107603335);
        X = f(X, W, V, Y, C[P + 8], w, 1163531501);
        Y = f(Y, X, W, V, C[P + 13], A, 2850285829);
        V = f(V, Y, X, W, C[P + 2], z, 4243563512);
        W = f(W, V, Y, X, C[P + 7], y, 1735328473);
        X = f(X, W, V, Y, C[P + 12], w, 2368359562);
        Y = D(Y, X, W, V, C[P + 5], o, 4294588738);
        V = D(V, Y, X, W, C[P + 8], m, 2272392833);
        W = D(W, V, Y, X, C[P + 11], l, 1839030562);
        X = D(X, W, V, Y, C[P + 14], j, 4259657740);
        Y = D(Y, X, W, V, C[P + 1], o, 2763975236);
        V = D(V, Y, X, W, C[P + 4], m, 1272893353);
        W = D(W, V, Y, X, C[P + 7], l, 4139469664);
        X = D(X, W, V, Y, C[P + 10], j, 3200236656);
        Y = D(Y, X, W, V, C[P + 13], o, 681279174);
        V = D(V, Y, X, W, C[P + 0], m, 3936430074);
        W = D(W, V, Y, X, C[P + 3], l, 3572445317);
        X = D(X, W, V, Y, C[P + 6], j, 76029189);
        Y = D(Y, X, W, V, C[P + 9], o, 3654602809);
        V = D(V, Y, X, W, C[P + 12], m, 3873151461);
        W = D(W, V, Y, X, C[P + 15], l, 530742520);
        X = D(X, W, V, Y, C[P + 2], j, 3299628645);
        Y = t(Y, X, W, V, C[P + 0], U, 4096336452);
        V = t(V, Y, X, W, C[P + 7], T, 1126891415);
        W = t(W, V, Y, X, C[P + 14], R, 2878612391);
        X = t(X, W, V, Y, C[P + 5], O, 4237533241);
        Y = t(Y, X, W, V, C[P + 12], U, 1700485571);
        V = t(V, Y, X, W, C[P + 3], T, 2399980690);
        W = t(W, V, Y, X, C[P + 10], R, 4293915773);
        X = t(X, W, V, Y, C[P + 1], O, 2240044497);
        Y = t(Y, X, W, V, C[P + 8], U, 1873313359);
        V = t(V, Y, X, W, C[P + 15], T, 4264355552);
        W = t(W, V, Y, X, C[P + 6], R, 2734768916);
        X = t(X, W, V, Y, C[P + 13], O, 1309151649);
        Y = t(Y, X, W, V, C[P + 4], U, 4149444226);
        V = t(V, Y, X, W, C[P + 11], T, 3174756917);
        W = t(W, V, Y, X, C[P + 2], R, 718787259);
        X = t(X, W, V, Y, C[P + 9], O, 3951481745);
        Y = K(Y, h);
        X = K(X, E);
        W = K(W, v);
        V = K(V, g);
    }
    var i = B(Y) + B(X) + B(W) + B(V);
    return i.toLowerCase();
};
module.exports = MD5;


/***/ }),

/***/ 15885:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var YouboraObject = __webpack_require__(831);
var isArray = __webpack_require__(9831);
/**
 * This class extends YouboraObject, adding event emitting/listening functionalities.
 *
 * @constructs Emitter
 * @extends youbora.YouboraObject
 * @memberof youbora
 */ var Emitter = YouboraObject.extend(/** @lends youbora.Emitter.prototype */ {
    /**
     * Sets a listener to a given event. Use {@link emit} to trigger those events.
     * Pass '*' to listen ALL events.
     *
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event. Receives event and data.
     * @return this
     */ on: function on(event, callback) {
        this._listeners = this._listeners || {};
        if (typeof callback === "function") {
            this._listeners[event] = this._listeners[event] || [];
            this._listeners[event].push(callback);
            return this;
        }
    },
    /**
     * Removes given callback from the listeners of this object.
     *
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     * @return this
     */ off: function off(event, callback) {
        this._listeners = this._listeners || {};
        if (this._listeners[event]) {
            var index = this._listeners[event].indexOf(callback);
            if (index !== -1) {
                this._listeners[event].splice(index, 1);
            }
        }
        return this;
    },
    /**
     * Emits given event, triggering all the associated callbacks.
     *
     * @param {string} event Name of the event.
     * @param {object} [data] Custom data to be sent to the callbacks.
     * @return this
     */ emit: function emit(event, data) {
        this._listeners = this._listeners || {};
        data = data || {};
        if (isArray(this._listeners[event])) {
            this._listeners[event].forEach(this._eachCallback.bind(this, event, data));
        }
        if (isArray(this._listeners["*"])) {
            this._listeners["*"].forEach(this._eachCallback.bind(this, event, data));
        }
        return this;
    },
    /**
     * Travels through the listener list and executes them them.
     *
     * @private
     */ _eachCallback: function _eachCallback(event, data, callback) {
        if (typeof callback === "function") {
            var callbackArguments = {
                type: event,
                data: data,
                target: this
            };
            callback(callbackArguments);
        }
    }
});
module.exports = Emitter;


/***/ }),

/***/ 11308:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var Emitter = __webpack_require__(15885);
var Comm = __webpack_require__(30495);
var WrongTransform = __webpack_require__(52993);
var Util = __webpack_require__(37280);
var YouboraInfinity = Emitter.extend(/** @lends youbora.Infinity.prototype */ {
    /**
     * This class is the base of youbora infinity. Every plugin will have an instance.
     *
     * @param {youbora.Plugin} plugin Parent plugin.
     *
     * @constructs youbora.Infinity
     * @extends youbora.Emitter
     * @memberof youbora
     */ constructor: function constructor(plugin) {
        /** Parent {@link youbora.Plugin} reference. */ this._plugin = plugin;
        this.infinityStopped = false;
        this.infinityStarted = false;
    },
    /**
     * @alias youbora.Infinity.prototype.begin.
     */ andBeyond: function andBeyond() {
        YouboraInfinity.prototype.begin.apply(this, arguments);
    },
    /**
     * This method will start infinity logic, setting storage as needed.
     * Will call fireSessionStart the first time and fireNav for every subsequent route change.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {boolean} [forceNewSession] boolean to force open a new session.
     */ begin: function begin(dimensions, forceNewSession) {
        forceNewSession = forceNewSession || false;
        if (forceNewSession) {
            this._plugin.storage.removeStorages("infinityStarted");
            this._plugin.storage.removeStorages("data");
            this._plugin.restartViewTransform();
        }
        this._comm = new Comm(this._plugin);
        this._comm.addTransform(this._plugin.viewTransform);
        this._comm.addTransform(new WrongTransform(this._plugin));
        if (this._plugin && this._plugin.storage && typeof this._plugin.storage.getLocal === "function") {
            this._registeredProperties = this._plugin.storage.getLocal("inifnityRegisteredProperties");
        }
        // Retrieve infinityStarted state. Otherwise it will always be false (at this stage) and session will always be started.
        this.infinityStarted = this._plugin.storage.getLocal("infinityStarted") === "true";
        if (this.infinityStopped || !this.infinityStarted) {
            // send start session with navigation information at beginning
            this.fireSessionStart(dimensions);
        } else {
            // if plugin is previously initiated (appAnalyticsStarted), fire Navigation directly
            this.fireNav(dimensions);
            this._sendExtraBeat();
        }
    },
    _setLastActive: function _setLastActive() {
        if (!this._firstActive) {
            this._firstActive = this.getFirstActive();
        }
        this._plugin.storage.setStorages("lastactive", new Date().getTime());
    },
    getFirstActive: function getFirstActive() {
        return Number(this._plugin.getLastActive()) || 0;
    },
    /**
     * Returns the current {@link youbora.Communication} instance.
     *
     * @returns {youbora.Communication} communication instance
     */ getComm: function getComm() {
        return this._comm;
    },
    // Fire
    /**
     * Emits session start request.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */ fireSessionStart: function fireSessionStart(dimensions) {
        if (this.infinityStopped) {
            this._plugin.restartViewTransform();
            this._comm = new Comm(this._plugin);
            this._comm.addTransform(this._plugin.viewTransform);
            this._comm.addTransform(new WrongTransform(this._plugin));
            this.infinityStopped = false;
        }
        if (!this.infinityStarted) {
            this._plugin.storage.setLocal("infinityStarted", "true");
            this.infinityStarted = true;
            this.emit(YouboraInfinity.Event.SESSION_START, this._getParamsJson(dimensions, null, null, true, true));
            this._setLastActive();
        }
    },
    /**
     * Emits session start request.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */ fireSessionStop: function fireSessionStop(params) {
        if (this.infinityStarted) {
            this.infinityStopped = true;
            this.infinityStarted = false;
            this._plugin.storage.removeStorages("infinityStarted");
            this.emit(YouboraInfinity.Event.SESSION_STOP, params);
            this._plugin.storage.removeStorages("data");
            this._plugin.storage.removeStorages("session");
            this._plugin.storage.removeStorages("lastactive");
        }
    },
    /**
     * Stops the session and creates a new one
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */ newSession: function newSession(options, params) {
        if (this.isActive()) {
            if (this.infinityStarted) {
                this.fireSessionStop();
            } else {
                this._plugin.storage.removeStorages("infinityStarted");
                this._plugin.storage.removeStorages("data");
                if (this._comm) this._comm.removeTransform(this._plugin.viewTransform);
                this._plugin.restartViewTransform();
                if (this._comm) this._comm.addTransform(this._plugin.viewTransform);
            }
        }
        this._plugin.setOptions(options);
        this.begin(params);
    },
    /**
     * Emits session start request.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */ fireNav: function fireNav(dimensions) {
        if (this.isActive()) {
            this.infinityStarted = true;
            this.emit(YouboraInfinity.Event.NAV, this._getParamsJson(dimensions, null, null, true));
        }
    },
    _sendExtraBeat: function _sendExtraBeat() {
        if (this._plugin && this._plugin._beat) {
            var now = new Date().getTime();
            var time = this._plugin._beat.chrono.startTime ? now - this._plugin._beat.chrono.startTime : 0;
            this._plugin._sendBeat(time);
            this._plugin._beat.chrono.startTime = now;
        }
        this._setLastActive();
    },
    /**
     * Emits session start request.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */ fireEvent: function fireEvent(eventName, dimensions, values, topLevelDimensions, hasEndDatetime) {
        if (this.infinityStarted) {
            var builtParams = this._getParamsJson(dimensions, values, eventName, false, false, hasEndDatetime);
            Util.assign(builtParams.params, topLevelDimensions || {});
            this.emit(YouboraInfinity.Event.EVENT, builtParams);
            this._setLastActive();
        }
    },
    /**
     * Emits session event end request.
     *
     * @param {string} eventName Name of the event to track.
     * @param {Object} [topLevelDimensions] Object of key:value params to add to the request.
     */ fireEventEnd: function fireEventEnd(eventName, topLevelDimensions) {
        if (this.infinityStarted) {
            var builtParams = this._getParamsJson(null, null, eventName, false, false, false);
            Util.assign(builtParams.params, topLevelDimensions || {});
            this.emit(YouboraInfinity.Event.EVENT_END, builtParams);
            this._setLastActive();
        }
    },
    /** Register properties sent by the User, to send in all the events
    *
    * @memberof youbora.Infinity.prototype
    */ register: function register(dimensions, values) {
        this._registeredProperties = {
            dimensions: dimensions,
            values: values
        };
        this._plugin.storage.setLocal("inifnityRegisteredProperties", JSON.stringify(this._registeredProperties));
    },
    /** Calls register if registeredProperties is empty
    *
    * @memberof youbora.Infinity.prototype
    */ registerOnce: function registerOnce(dimensions, values) {
        if (!this._registeredProperties) {
            this.register(dimensions, values);
        }
    },
    /** Unregister properties registered with register()
    *
    * @memberof youbora.Infinity.prototype
    */ unregister: function unregister() {
        this._registeredProperties = null;
        this._plugin.storage.removeLocal("inifnityRegisteredProperties");
    },
    /**
     * Splits params in dimensions (strings) and values (numbers)
     *
     * @param {Object} [params] Object of key:value params to split before adding to request.
     */ _getParamsJson: function _getParamsJson(dimensions, values, eventName, isNavigaton, isStart, hasEndDatetime) {
        var returnparams = {};
        if (typeof hasEndDatetime !== "boolean") {
            hasEndDatetime = false;
        }
        if (eventName) returnparams.name = eventName;
        returnparams.dimensions = dimensions || {};
        returnparams.values = values || {};
        if (this._registeredProperties) {
            for(var key in this._registeredProperties.dimensions){
                returnparams.dimensions[key] = this._registeredProperties.dimensions[key];
            }
            for(var key2 in this._registeredProperties.values){
                returnparams.values[key2] = this._registeredProperties.values[key2];
            }
        }
        var paramsObject = {
            params: returnparams
        };
        if (isNavigaton) {
            if (paramsObject.params.dimensions.page) {
                paramsObject.params.page = paramsObject.params.dimensions.page;
                delete paramsObject.params.dimensions.page;
            }
            if (paramsObject.params.dimensions.route) {
                paramsObject.params.route = paramsObject.params.dimensions.route;
                delete paramsObject.params.dimensions.route;
            }
            if (!isStart) {
                delete paramsObject.params.dimensions;
            }
            delete paramsObject.params.values;
        }
        if (hasEndDatetime) {
            paramsObject.params.hasEndDatetime = hasEndDatetime;
        }
        return paramsObject;
    },
    isActive: function isActive() {
        var started = this._plugin.storage.getLocal("infinityStarted");
        if (this.infinityStarted || started && started !== "false") {
            return true;
        }
        var now = new Date().getTime();
        if (Number(this._plugin.getLastActive()) + this._plugin.sessionExpire > now) {
            return true;
        }
        return false;
    }
}, /** @lends youbora.Plugin */ {
    // Static Memebers //
    /**
     * List of events that could be fired
     * @enum
     * @event
     */ Event: {
        NAV: "nav",
        SESSION_START: "sessionStart",
        SESSION_STOP: "sessionStop",
        BEAT: "beat",
        EVENT: "event",
        EVENT_END: "eventEnd"
    }
});
module.exports = YouboraInfinity;


/***/ }),

/***/ 39610:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var Emitter = __webpack_require__(15885);
var isArray = __webpack_require__(9831);
/**
 * Static Log class for YouboraLib
 *
 * @class
 * @static
 * @memberof youbora
 */ var Log = {
    _emitter: new Emitter(),
    /** Exposes {@link youbora.EvenfulObject.on} */ on: function on() {
        Log._emitter.on.apply(Log._emitter, arguments);
    },
    /** Exposes {@link youbora.EvenfulObject.off} */ off: function off() {
        Log._emitter.off.apply(Log._emitter, arguments);
    },
    /** Exposes {@link youbora.EvenfulObject.emit} */ emit: function emit() {
        Log._emitter.emit.apply(Log._emitter, arguments);
    },
    /**
   * Enum for log levels
   * @enum
   */ Level: {
        /** No console outputs */ SILENT: 6,
        /** Console will show errors */ ERROR: 5,
        /** Console will show warnings */ WARNING: 4,
        /** Console will show notices (ie: life-cyrcle logs) */ NOTICE: 3,
        /** Console will show debug messages (ie: player events) */ DEBUG: 2,
        /** Console will show verbose messages (ie: Http Requests) */ VERBOSE: 1
    },
    /**
   * Enum for events
   * @enum
   */ Event: {
        /** Sent each time a messaged is issued, even if log level does not handle it. */ LOG: "log"
    },
    /**
   * Only logs of this imporance or higher will be shown.
   * @default youbora.Log.Levels.ERROR
   * @see {@link youbora.Log.Levels}
   */ logLevel: 5,
    /**
   * If true, console logs will always be outputed without colors (for debbugin in devices).
   * @default false
   */ plainLogs: false,
    /**
   * Returns a console message
   *
   * @private
   * @param {(string|error|array)} msg Message string, error object or array of messages.
   * @param {Log.Levels} [level=Log.Levels.NOTICE] Defines the level of the error sent.
   * Only errors with higher or equal level than Log.logLevel will be displayed.
   * @param {string} [color=darkcyan] Color of the header
   * @see {@link Youbora.Log.debugLevel}
   */ report: function report(msg, level, color) {
        if (typeof console !== "undefined" && console.log && typeof document !== "undefined") {
            level = level || Log.Level.NOTICE;
            color = color || "darkcyan";
            var letters = {
                5: "e",
                4: "w",
                3: "n",
                2: "d",
                1: "v" // Verbose
            };
            var letter = letters[level];
            var prefix = "[Youbora]" + Log._getCurrentTime() + " " + letter + ":";
            this.emit("log", {
                level: level,
                msg: msg,
                prefix: prefix
            });
            // Show messages in actual console if level is enought
            if (Log.logLevel <= level) {
                if (Log.plainLogs || document.documentMode) {
                    // Plain log for IE and devices
                    Log._plainReport(msg, prefix);
                } else {
                    // choose log method
                    var logMethod;
                    if (level === Log.Level.ERROR && console.error) {
                        logMethod = console.error;
                    } else if (level === Log.Level.WARNING && console.warn) {
                        logMethod = console.warn;
                    } else if (level === Log.Level.DEBUG && console.debug) {
                        logMethod = console.debug;
                    } else {
                        logMethod = console.log;
                    }
                    // print message
                    prefix = "%c" + prefix;
                    if (isArray(msg)) {
                        msg.splice(0, 0, prefix, "color: " + color);
                        logMethod.apply(console, msg);
                    } else {
                        logMethod.call(console, prefix, "color: " + color, msg);
                    }
                }
            }
        }
    },
    /**
   * Returns the current time in format hh:mm:ss.mmm (with trailing 0s)
   * @private
   * @return {string} Current time.
   */ _getCurrentTime: function _getCurrentTime() {
        var d = new Date();
        var hh = ("0" + d.getDate()).slice(-2);
        var mm = ("0" + d.getMinutes()).slice(-2);
        var ss = ("0" + d.getSeconds()).slice(-2);
        var mmm = ("00" + d.getMilliseconds()).slice(-3);
        return "[" + hh + ":" + mm + ":" + ss + "." + mmm + "]";
    },
    /**
   * Returns a console message without style
   *
   * @private
   * @param {(string|object|array)} msg Message string, object or array of messages.
   * @param {string} prefix Prefix of the message.
   */ _plainReport: function _plainReport(msg, prefix) {
        if (msg instanceof Array) {
            for(var m in msg){
                Log._plainReport(msg[m], prefix);
            }
        } else {
            if (typeof msg === "string") {
                console.log(prefix + " " + msg);
            } else {
                console.log(prefix + " <next line>");
                console.log(msg);
            }
        }
    },
    /**
   * Sends an error (level 1) console log.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */ error: function error() {
        Log.report([].slice.call(arguments), Log.Level.ERROR, "darkred");
    },
    /**
   * Sends a warning (level 2) console log.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */ warn: function warn() {
        Log.report([].slice.call(arguments), Log.Level.WARNING, "darkorange");
    },
    /**
   * Sends a notice (level 3) console log.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */ notice: function notice() {
        Log.report([].slice.call(arguments), Log.Level.NOTICE, "darkgreen");
    },
    /**
   * Sends a debug message (level 4) to console.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */ debug: function debug() {
        Log.report([].slice.call(arguments), Log.Level.DEBUG, "indigo");
    },
    /**
   * Sends a verbose message (level 5) to console.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */ verbose: function verbose() {
        Log.report([].slice.call(arguments), Log.Level.VERBOSE, "navy");
    },
    /**
   * This function is automatically executed at youboralib's init.
   * Will search inside window.location.search for attribute 'youbora-debug=X'.
   * X can have one of these values, that will modify LogLevel.
   * 6: SILENT,
   * 5: ERROR,
   * 4: WARNING,
   * 3: NOTICE,
   * 2: DEBUG,
   * 1: VERBOSE
   *
   * If youbora-console=plain is present, plainLogs will be set to true.
   */ loadLevelFromUrl: function loadLevelFromUrl() {
        if (typeof window !== "undefined" && window.location) {
            this._parseLevelFromUrl(window.location.search);
        }
    },
    _parseLevelFromUrl: function _parseLevelFromUrl(url) {
        if (url) {
            var m = /\?.*&*youbora-debug=(.+)/i.exec(url);
            if (m !== null) {
                Log.logLevel = m[1];
            }
            var m2 = /\?.*&*youbora-debug=plain/i.exec(url);
            if (m2 !== null) {
                Log.plainLogs = true;
            }
        }
    }
};
module.exports = Log;


/***/ }),

/***/ 58122:
/***/ ((module, exports, __webpack_require__) => {

/**
 * See Object.assign.
 *
 * @memberof youbora.Util
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
module.exports = function(target) {
    if (target === undefined || target === null) {
        throw new TypeError("Cannot convert undefined or null to object");
    }
    var output = Object(target);
    for(var index = 1; index < arguments.length; index++){
        var source = arguments[index];
        if (source !== undefined && source !== null) {
            for(var nextKey in source){
                if (source.hasOwnProperty(nextKey)) {
                    output[nextKey] = source[nextKey];
                }
            }
        }
    }
    return output;
};


/***/ }),

/***/ 70287:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
var F = function F() {};
/** See Object.create. */ module.exports = function(o) {
    if (arguments.length > 1) {
        throw Error("Second argument not supported");
    }
    if (o === null) {
        throw Error("Cannot set a null [[Prototype]]");
    }
    if (typeof o !== "object") {
        throw TypeError("Argument must be an object");
    }
    F.prototype = o;
    return new F();
};


/***/ }),

/***/ 9831:
/***/ ((module, exports, __webpack_require__) => {

/**
 * See Array.isArray.
 * @memberof youbora.Util
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
module.exports = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
};


/***/ }),

/***/ 25758:
/***/ ((module, exports, __webpack_require__) => {

/* global PerformanceObserver */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var YouboraObject = __webpack_require__(831);
var RUMSpeedIndex = __webpack_require__(96494);
/**
 * This static class provides information about the load times of the page
 *
 * @constructs YouboraObject
 * @extends youbora.YouboraObject
 * @memberof youbora
 *
 */ var BrowserLoadTimes = YouboraObject.extend({
    constructor: function constructor(plugin) {
        this.infinity = plugin.infinity;
        this.timeObject = null;
        this.playerSetup = null;
        this.perfObject = null;
        this.myTimesObject = {};
        if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
            window.addEventListener("load", this._windowLoaded.bind(this));
            if (window.performance && window.performance.timing) {
                try {
                    if (typeof window.performance.getEntriesByType === "function") {
                        this.perfObject = window.performance;
                    }
                } catch (err) {
                // Nothing
                }
                this.timeObject = window.performance.timing;
            }
        }
        try {
            if (typeof PerformanceObserver === "function") {
                var observer = new PerformanceObserver((function(list, obj) {
                    var entries = list.getEntries();
                    this.myTimesObject.largestContentfulPaint = entries[entries.length - 1].renderTime;
                }).bind(this));
                if (PerformanceObserver.supportedEntryTypes.indexOf("largest-contentful-paint") > -1) {
                    observer.observe({
                        entryTypes: [
                            "largest-contentful-paint"
                        ]
                    });
                }
            }
        } catch (err) {
        // Cant use PerformanceObserver, entryTypes...
        }
    },
    _windowLoaded: function _windowLoaded() {
        this.myTimesObject.onLoad = new Date().getTime();
        this._getEnoughFPS();
        setTimeout(this._fireLoadTimesEvent.bind(this), 1000);
    },
    _fireLoadTimesEvent: function _fireLoadTimesEvent() {
        this._getLastMetrics();
        this.infinity.fireEvent("loadTimes", {}, this._getAllValues());
    },
    _getAllValues: function _getAllValues() {
        var ret = {
            // Time between the navigation starts and the page loadEventEnd
            PageLoadTime: this.getPageLoadTime(),
            // Domain lookup time
            DNSTime: this.getDnsTime(),
            // Connection time
            TCPTime: this.getTcpTime(),
            // Handshake (https) connection time
            HandshakeTime: this.getHandshakeTime(),
            // Time between navigation starts and DOM is ready
            DomReadyTime: this.getDomReadyTime(),
            // Time between navigation start and beginning of the backend response
            BackendTime: this.getBackendTime(),
            // Time between navigation starts and page load event
            FrontendTime: this.getFrontendTime(),
            // The maximum of First Paint / First Contentful Paint and domContentLoadedEventEnd
            VisualReady: this.getTimeToVisuallyReady(),
            // https://developer.mozilla.org/en-US/docs/Glossary/Time_to_interactive
            TimeToInteractive: this.getTimeToInteractive(),
            // Accumulated time to download all the JS files
            JsTime: this.getJSTime(),
            // Accumulated time to download all the CSS files
            CssTime: this.getCSSTime(),
            // Accumulated time to download all the images
            ImageTime: this.getImageTime(),
            // Accumulated time to download all the fonts
            FontTime: this.getFontTime(),
            // Average latency of all the file requests
            AvgReqLatency: this.getAvgReqLatency(),
            // Highest latency of all the file requests
            MaxReqLatency: this.getMaxReqLatency(),
            // https://developer.mozilla.org/en-US/docs/Glossary/First_paint
            FirstPaint: this.getFirstPaint(),
            // https://developer.mozilla.org/en-US/docs/Glossary/First_contentful_paint
            FirstContentfulPaint: this.getFirstContentfulPaint(),
            // https://rockcontent.com/blog/largest-contentful-paint/
            LargestContentfulPaint: this.getLargestContentfulPaint(),
            // https://developer.mozilla.org/en-US/docs/Glossary/Speed_index
            SpeedIndex: this.getSpeedIndex()
        };
        for(var key in ret){
            if (ret[key] === null || ret[key] === undefined || ret[key] < 0) {
                delete ret[key];
            } else {
                ret[key] = Math.round(ret[key]);
            }
        }
        return ret;
    },
    // Getters
    getPageLoadTime: function getPageLoadTime() {
        var ret = null;
        if (this.timeObject) {
            ret = this.timeObject.loadEventEnd - this.timeObject.navigationStart;
        }
        return ret;
    },
    getPlayerStartupTime: function getPlayerStartupTime() {
        var ret = null;
        if (this.timeObject && this.playerSetup) {
            ret = this.playerSetup - this.timeObject.navigationStart;
        }
        return ret;
    },
    getDnsTime: function getDnsTime() {
        var ret = null;
        if (this.timeObject) {
            ret = this.timeObject.domainLookupEnd - this.timeObject.domainLookupStart;
        }
        return ret;
    },
    getTcpTime: function getTcpTime() {
        var ret = null;
        if (this.timeObject) {
            ret = this.timeObject.connectEnd - this.timeObject.connectStart;
        }
        return ret;
    },
    getHandshakeTime: function getHandshakeTime() {
        var ret = null;
        if (this.timeObject && this.timeObject.secureConnectionStart) {
            ret = this.timeObject.connectEnd - this.timeObject.secureConnectionStart;
        }
        return ret;
    },
    getDomReadyTime: function getDomReadyTime() {
        var ret = null;
        if (this.timeObject) {
            ret = this.timeObject.domComplete - this.timeObject.navigationStart;
        }
        return ret;
    },
    getBackendTime: function getBackendTime() {
        var ret = null;
        if (this.timeObject) {
            ret = this.timeObject.responseStart - this.timeObject.navigationStart;
        }
        return ret;
    },
    getFrontendTime: function getFrontendTime() {
        var ret = null;
        if (this.timeObject) {
            ret = this.myTimesObject.onLoad - this.timeObject.responseStart;
        }
        return ret;
    },
    getTimeToVisuallyReady: function getTimeToVisuallyReady() {
        var ret = this.myTimesObject.firstPaint || 0;
        if (this.timeObject) {
            return Math.max(ret, this.timeObject.domContentLoadedEventEnd - this.timeObject.navigationStart || 0);
        }
        return ret || null;
    },
    getTimeToInteractive: function getTimeToInteractive() {
        if (this.myTimesObject.fps && this.getTimeToVisuallyReady()) {
            return Math.max(this.myTimesObject.fps, this.getTimeToVisuallyReady());
        } else {
            setTimeout((function() {
                this.getTimeToInteractive();
            }).bind(this), 500);
        }
    },
    getJSTime: function getJSTime() {
        return this._getXTime("script");
    },
    getCSSTime: function getCSSTime() {
        return this._getXTime("css");
    },
    getImageTime: function getImageTime() {
        return this._getXTime("img");
    },
    getFontTime: function getFontTime() {
        return this._getXTime("css", [
            ".woff",
            ".otf",
            ".ttf"
        ]);
    },
    getAvgReqLatency: function getAvgReqLatency() {
        try {
            if (this.perfObject && typeof this.perfObject.getEntriesByType === "function") {
                var count = 0;
                var latency = 0;
                var scripts = this.perfObject.getEntriesByType("resource");
                for(var i in scripts){
                    if (scripts[i].requestStart && scripts[i].responseStart) {
                        latency += scripts[i].responseStart - scripts[i].requestStart;
                    }
                    count++;
                }
                return latency / count;
            }
        } catch (err) {
        // Nothing
        }
        return null;
    },
    getFirstPaint: function getFirstPaint() {
        return this.myTimesObject ? this.myTimesObject.firstPaint : null;
    },
    getFirstContentfulPaint: function getFirstContentfulPaint() {
        return this.myTimesObject ? this.myTimesObject.firstContentfulPaint : null;
    },
    getLargestContentfulPaint: function getLargestContentfulPaint() {
        return this.myTimesObject ? this.myTimesObject.largestContentfulPaint : null;
    },
    getMaxReqLatency: function getMaxReqLatency() {
        try {
            if (this.perfObject && typeof this.perfObject.getEntriesByType === "function") {
                var scripts = this.perfObject.getEntriesByType("resource");
                var latency = 0;
                for(var i in scripts){
                    if (scripts[i].requestStart && scripts[i].responseStart) {
                        latency = Math.max(latency, scripts[i].responseStart - scripts[i].requestStart);
                    }
                }
                return latency;
            }
        } catch (err) {
        // Nothing
        }
        return null;
    },
    getSpeedIndex: function getSpeedIndex() {
        var ret = null;
        if (typeof window !== "undefined" && window.performance && typeof window.performance.getEntriesByType === "function") {
            try {
                ret = RUMSpeedIndex();
            } catch (e) {
            // nothing
            }
        }
        return ret;
    },
    _getXTime: function _getXTime(type, validExtensions) {
        var ret = 0;
        try {
            if (this.perfObject && typeof this.perfObject.getEntriesByType === "function") {
                var scripts = this.perfObject.getEntriesByType("resource");
                for(var i in scripts){
                    if (scripts[i].initiatorType === type) {
                        if (!validExtensions) {
                            ret += scripts[i].duration;
                        } else {
                            var valid = false;
                            for(var ext in validExtensions){
                                if (scripts[i].name.indexOf(validExtensions[ext] > 0)) {
                                    valid = true;
                                }
                            }
                            if (valid) {
                                ret += scripts[i].duration;
                            }
                        }
                    }
                }
            }
        } catch (err) {
        // Nothing
        }
        return Math.round(ret) || null;
    },
    _getLastMetrics: function _getLastMetrics() {
        var firstPaint = null;
        var contentfulPaint = null;
        try {
            if (this.perfObject && typeof this.perfObject.getEntriesByType === "function") {
                var entries = this.perfObject.getEntriesByType("paint");
                for(var i in entries){
                    if (entries[i].name === "first-paint") {
                        firstPaint = entries[i].startTime;
                    } else if (entries[i].name === "first-contentful-paint") {
                        contentfulPaint = entries[i].startTime;
                    }
                }
            }
        } catch (err) {
        // Nothing
        }
        // First paint
        if (!firstPaint && this.timeObject) {
            firstPaint = this.timeObject.msFirstPaint - this.timeObject.navigationStart;
        }
        // TODO first paint for firefox
        this.myTimesObject.firstPaint = firstPaint;
        // First contentful paint
        this.myTimesObject.firstContentfulPaint = contentfulPaint;
        // Others
        this.getTimeToInteractive();
    },
    _getEnoughFPS: function _getEnoughFPS() {
        if (this.timeObject && typeof window !== "undefined") {
            var req = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function() {};
            this.preFPS = new Date().getTime();
            req((function() {
                var now = new Date().getTime();
                if (now < this.preFPS + 50) {
                    this.myTimesObject.fps = now - this.timeObject.navigationStart;
                } else {
                    setTimeout((function() {
                        return this._getEnoughFPS();
                    }).bind(this), 50);
                }
            }).bind(this));
        } else {
            return true;
        }
    },
    // Setters
    setPlayerSetupTime: function setPlayerSetupTime() {
        this.playerSetup = this.playerSetup || new Date().getTime();
    }
});
module.exports = BrowserLoadTimes;


/***/ }),

/***/ 86940:
/***/ ((module, exports, __webpack_require__) => {

/* global Streamroot, peer5, teltoo, CdnBalancerStats */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var YouboraObject = __webpack_require__(831);
/**
 * This static class provides p2p and cdn network traffic information for
 * Streamroot, Peer5 and EasyBroadcast
 *
 * @constructs YouboraObject
 * @extends youbora.YouboraObject
 * @memberof youbora
 *
 */ var HybridNetowrk = YouboraObject.extend({
    /** Returns CDN traffic bytes using NPAW balancer, streamroot, peer5 or teltoo. Otherwise null */ getCdnTraffic: function getCdnTraffic() {
        var ret = null;
        if (typeof CdnBalancerStats !== "undefined" && CdnBalancerStats.cdn) {
            ret = CdnBalancerStats.cdn.totalDownloadedBytes;
        } else if (typeof Streamroot !== "undefined") {
            ret = this._getStreamrootPeerObject("cdn", false) || this._getStreamrootInstanceObject("cdnDownload");
        } else if (typeof peer5 !== "undefined" && peer5.getStats) {
            ret = peer5.getStats().totalHttpDownloaded;
        } else if (typeof teltoo !== "undefined" && teltoo.getStats) {
            var stats = teltoo.getStats();
            ret = stats.totalReceivedBytes - stats.p2pReceivedBytes;
        }
        return ret;
    },
    /** Returns CDN traffic when using multiple cdns, available only for NPAW solution. Otherwise null */ getMultiCdnInfo: function getMultiCdnInfo() {
        var ret = null;
        if (typeof CdnBalancerStats !== "undefined" && CdnBalancerStats.cdn && CdnBalancerStats.cdn.cdns) {
            var p2p = CdnBalancerStats.p2p;
            ret = {
                P2P: {
                    downloaded_bytes: p2p.downloadedBytes,
                    uploaded_bytes: p2p.uploadedBytes,
                    downloaded_chunks: p2p.downloadedSegments,
                    uploaded_chunks: p2p.uploadedSegments,
                    errors: p2p.failedRequests ? p2p.failedRequests.total : 0,
                    missed_downloaded_chunks: p2p.failedRequests ? p2p.failedRequests.absent : 0,
                    timeout_errors: p2p.failedRequests ? p2p.failedRequests.timeout : 0,
                    other_errors: p2p.failedRequests ? p2p.failedRequests.error : 0,
                    late_uploaded_chunks: p2p.discardedUploadedSegments,
                    late_uploaded_bytes: p2p.discardedUploadedBytes,
                    late_downloaded_bytes: p2p.discardedDownloadedBytes,
                    time: p2p.downloadMillis,
                    active_peers: p2p.activePeers,
                    peers: p2p.totalPeers
                }
            };
            CdnBalancerStats.cdn.cdns.forEach(function(cdn) {
                ret[cdn.name] = {
                    downloaded_bytes: cdn.bytes,
                    downloaded_chunks: cdn.chunks,
                    errors: cdn.failures,
                    time: cdn.downloadMillis
                };
            });
        }
        return ret;
    },
    /** Returns segment duration using NPAW balancer API. Otherwise null */ getSegmentDuration: function getSegmentDuration() {
        var ret = null;
        if (typeof CdnBalancerStats !== "undefined" && CdnBalancerStats.segmentDuration) {
            return CdnBalancerStats.segmentDuration;
        }
        return ret;
    },
    /** Returns CDN balancer API response id, available only for NPAW solution. Otherwise null */ getBalancerResponseId: function getBalancerResponseId() {
        var ret = null;
        if (typeof CdnBalancerStats !== "undefined" && CdnBalancerStats.cdn) {
            return CdnBalancerStats.cdn.responseUUID;
        }
        return ret;
    },
    /** Returns P2P traffic bytes using NPAW balancer, streamroot, peer5 or teltoo. Otherwise null */ getP2PTraffic: function getP2PTraffic() {
        var ret = null;
        if (typeof CdnBalancerStats !== "undefined" && CdnBalancerStats.p2p) {
            ret = CdnBalancerStats.p2p.downloadedBytes;
        } else if (typeof Streamroot !== "undefined") {
            ret = this._getStreamrootPeerObject("p2p", true) || this._getStreamrootInstanceObject("dnaDownload");
        } else if (typeof peer5 !== "undefined" && peer5.getStats) {
            ret = peer5.getStats().totalP2PDownloaded;
        } else if (typeof teltoo !== "undefined" && teltoo.getStats) {
            ret = teltoo.getStats().p2pReceivedBytes;
        }
        return ret;
    },
    /** Returns P2P traffic sent in bytes, using NPAW balancer, streamroot or peer5. Otherwise null */ getUploadTraffic: function getUploadTraffic() {
        var ret = null;
        if (typeof CdnBalancerStats !== "undefined" && CdnBalancerStats.p2p) {
            ret = CdnBalancerStats.p2p.uploadedBytes;
        } else if (typeof Streamroot !== "undefined") {
            ret = this._getStreamrootPeerObject("upload", true) || this._getStreamrootInstanceObject("dnaUpload");
        } else if (typeof peer5 !== "undefined" && peer5.getStats) {
            ret = peer5.getStats().totalP2PUploaded;
        }
        return ret;
    },
    /** Returns if P2P is enabled, using NPAW balancer, streamroot or peer5. Otherwise null */ getIsP2PEnabled: function getIsP2PEnabled() {
        var ret = false;
        if (typeof CdnBalancerStats !== "undefined" && CdnBalancerStats.p2p) {
            ret = CdnBalancerStats.p2p.downloadEnabled;
        } else if (typeof Streamroot !== "undefined") {
            if (Streamroot.p2pAvailable && Streamroot.peerAgents) {
                for(var agent in Streamroot.peerAgents){
                    ret = ret || Streamroot.peerAgents[agent].isP2PEnabled;
                }
            } else if (Streamroot.instances) {
                Streamroot.instances.forEach(function(instance) {
                    ret = ret || instance.dnaDownloadEnabled || instance.dnaUploadEnabled;
                });
            }
        } else if (typeof peer5 !== "undefined" && peer5.isEnabled) {
            ret = peer5.isEnabled();
        } else if (typeof teltoo !== "undefined") {
            ret = true;
        }
        return ret;
    },
    _getStreamrootPeerObject: function _getStreamrootPeerObject(objectName, check) {
        var ret = null;
        if (Streamroot.p2pAvailable && Streamroot.peerAgents) {
            for(var agent in Streamroot.peerAgents){
                var agentInst = Streamroot.peerAgents[agent];
                if (agentInst.stats && (!check || agentInst.isP2PEnabled)) {
                    ret += agentInst.stats[objectName];
                }
            }
        }
        return ret;
    },
    _getStreamrootInstanceObject: function _getStreamrootInstanceObject(objectName) {
        var ret = null;
        if (Streamroot.instances) {
            Streamroot.instances.forEach(function(instance) {
                if (instance.stats && instance.stats.currentContent) {
                    ret += instance.stats.currentContent[objectName];
                }
            });
        }
        return ret;
    }
});
module.exports = HybridNetowrk;


/***/ }),

/***/ 96494:
/***/ ((module, exports, __webpack_require__) => {

/* istanbul ignore next */ /******************************************************************************
Copyright (c) 2014, Google Inc.
All rights reserved.
Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:
    * Redistributions of source code must retain the above copyright notice,
      this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright notice,
      this list of conditions and the following disclaimer in the documentation
      and/or other materials provided with the distribution.
    * Neither the name of the <ORGANIZATION> nor the names of its contributors
    may be used to endorse or promote products derived from this software
    without specific prior written permission.
THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
******************************************************************************/ /******************************************************************************
*******************************************************************************
  Calculates the Speed Index for a page by:
  - Collecting a list of visible rectangles for elements that loaded
    external resources (images, background images, fonts)
  - Gets the time when the external resource for those elements loaded
    through Resource Timing
  - Calculates the likely time that the background painted
  - Runs the various paint rectangles through the SpeedIndex calculation:
    https://sites.google.com/a/webpagetest.org/docs/using-webpagetest/metrics/speed-index
  TODO:
  - Improve the start render estimate
  - Handle overlapping rects (though maybe counting the area as multiple paints
    will work out well)
  - Detect elements with Custom fonts and the time that the respective font
    loaded
  - Better error handling for browsers that don't support resource timing
*******************************************************************************
******************************************************************************/ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var RUMSpeedIndex = function RUMSpeedIndex1(win) {
    win = win || window;
    var doc = win.document;
    /****************************************************************************
    Support Routines
  ****************************************************************************/ // Get the rect for the visible portion of the provided DOM element
    var GetElementViewportRect = function GetElementViewportRect(el) {
        var intersect = false;
        if (el.getBoundingClientRect) {
            var elRect = el.getBoundingClientRect();
            intersect = {
                top: Math.max(elRect.top, 0),
                left: Math.max(elRect.left, 0),
                bottom: Math.min(elRect.bottom, win.innerHeight || doc.documentElement.clientHeight),
                right: Math.min(elRect.right, win.innerWidth || doc.documentElement.clientWidth)
            };
            if (intersect.bottom <= intersect.top || intersect.right <= intersect.left) {
                intersect = false;
            } else {
                intersect.area = (intersect.bottom - intersect.top) * (intersect.right - intersect.left);
            }
        }
        return intersect;
    };
    // Check a given element to see if it is visible
    var CheckElement = function CheckElement(el, url) {
        if (url) {
            var rect = GetElementViewportRect(el);
            if (rect) {
                rects.push({
                    url: url,
                    area: rect.area,
                    rect: rect
                });
            }
        }
    };
    // Get the visible rectangles for elements that we care about
    var GetRects = function GetRects() {
        // Walk all of the elements in the DOM (try to only do this once)
        var elements = doc.getElementsByTagName("*");
        var re = /url\(.*(http.*)\)/ig;
        for(var i = 0; i < elements.length; i++){
            var el = elements[i];
            var style = win.getComputedStyle(el);
            // check for Images
            if (el.tagName === "IMG") {
                CheckElement(el, el.src);
            }
            // Check for background images
            if (style["background-image"]) {
                re.lastIndex = 0;
                var matches = re.exec(style["background-image"]);
                if (matches && matches.length > 1) {
                    CheckElement(el, matches[1].replace('"', ""));
                }
            }
            // recursively walk any iFrames
            if (el.tagName === "IFRAME") {
                try {
                    var rect = GetElementViewportRect(el);
                    if (rect) {
                        var tm = RUMSpeedIndex(el.contentWindow);
                        if (tm) {
                            rects.push({
                                tm: tm,
                                area: rect.area,
                                rect: rect
                            });
                        }
                    }
                } catch (e) {}
            }
        }
    };
    // Get the time at which each external resource loaded
    var GetRectTimings = function GetRectTimings() {
        var timings = {};
        var requests = win.performance.getEntriesByType("resource");
        for(var i = 0; i < requests.length; i++){
            timings[requests[i].name] = requests[i].responseEnd;
        }
        for(var j = 0; j < rects.length; j++){
            if (!("tm" in rects[j])) {
                rects[j].tm = timings[rects[j].url] !== undefined ? timings[rects[j].url] : 0;
            }
        }
    };
    // Get the first paint time.
    var GetFirstPaint = function GetFirstPaint() {
        // If the browser supports a first paint event, just use what the browser reports
        if ("msFirstPaint" in win.performance.timing) {
            firstPaint = win.performance.timing.msFirstPaint - navStart;
        }
        var paintMetrics = win.performance.getEntriesByType("paint");
        for(var k = 0; k < paintMetrics.length; k++){
            if (paintMetrics[k].name === "first-paint") {
                firstPaint = paintMetrics[k].startTime;
            }
        }
        // For browsers that don't support first-paint or where we get insane values,
        // use the time of the last non-async script or css from the head.
        if (firstPaint === undefined || firstPaint < 0 || firstPaint > 120000) {
            firstPaint = win.performance.timing.responseStart - navStart;
            var headURLs = {};
            var headElements = doc.getElementsByTagName("head")[0].children;
            for(var i = 0; i < headElements.length; i++){
                var el = headElements[i];
                if (el.tagName === "SCRIPT" && el.src && !el.async) {
                    headURLs[el.src] = true;
                }
                if (el.tagName === "LINK" && el.rel === "stylesheet" && el.href) {
                    headURLs[el.href] = true;
                }
            }
            var requests = win.performance.getEntriesByType("resource");
            var doneCritical = false;
            for(var j = 0; j < requests.length; j++){
                if (!doneCritical && headURLs[requests[j].name] && (requests[j].initiatorType === "script" || requests[j].initiatorType === "link")) {
                    var requestEnd = requests[j].responseEnd;
                    if (firstPaint === undefined || requestEnd > firstPaint) {
                        firstPaint = requestEnd;
                    }
                } else {
                    doneCritical = true;
                }
            }
        }
        firstPaint = Math.max(firstPaint, 0);
    };
    // Sort and group all of the paint rects by time and use them to
    // calculate the visual progress
    var CalculateVisualProgress = function CalculateVisualProgress() {
        var paints = {
            0: 0
        };
        var total = 0;
        for(var i = 0; i < rects.length; i++){
            var tm = firstPaint;
            if ("tm" in rects[i] && rects[i].tm > firstPaint) {
                tm = rects[i].tm;
            }
            if (paints[tm] === undefined) {
                paints[tm] = 0;
            }
            paints[tm] += rects[i].area;
            total += rects[i].area;
        }
        // Add a paint area for the page background (count 10% of the pixels not
        // covered by existing paint rects.
        var pixels = Math.max(doc.documentElement.clientWidth, win.innerWidth || 0) * Math.max(doc.documentElement.clientHeight, win.innerHeight || 0);
        if (pixels > 0) {
            pixels = Math.max(pixels - total, 0) * pageBackgroundWeight;
            if (paints[firstPaint] === undefined) {
                paints[firstPaint] = 0;
            }
            paints[firstPaint] += pixels;
            total += pixels;
        }
        // Calculate the visual progress
        if (total) {
            for(var time in paints){
                if (paints.hasOwnProperty(time)) {
                    progress.push({
                        tm: time,
                        area: paints[time]
                    });
                }
            }
            progress.sort(function(a, b) {
                return a.tm - b.tm;
            });
            var accumulated = 0;
            for(var j = 0; j < progress.length; j++){
                accumulated += progress[j].area;
                progress[j].progress = accumulated / total;
            }
        }
    };
    // Given the visual progress information, Calculate the speed index.
    var CalculateSpeedIndex = function CalculateSpeedIndex() {
        if (progress.length) {
            SpeedIndex = 0;
            var lastTime = 0;
            var lastProgress = 0;
            for(var i = 0; i < progress.length; i++){
                var elapsed = progress[i].tm - lastTime;
                if (elapsed > 0 && lastProgress < 1) {
                    SpeedIndex += (1 - lastProgress) * elapsed;
                }
                lastTime = progress[i].tm;
                lastProgress = progress[i].progress;
            }
        } else {
            SpeedIndex = firstPaint;
        }
    };
    /****************************************************************************
    Main flow
  ****************************************************************************/ var rects = [];
    var progress = [];
    var firstPaint;
    var SpeedIndex;
    var pageBackgroundWeight = 0.1;
    try {
        var navStart = win.performance.timing.navigationStart;
        GetRects();
        GetRectTimings();
        GetFirstPaint();
        CalculateVisualProgress();
        CalculateSpeedIndex();
    } catch (e) {}
    return SpeedIndex;
};
module.exports = RUMSpeedIndex;


/***/ }),

/***/ 831:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
var assign = __webpack_require__(58122);
var createObject = __webpack_require__(70287);
var YouboraObject = function YouboraObject() {};
YouboraObject.prototype = {
    /**
   * A base class that other Classes should inherit from.
   * It has a no-op constructor intended to be overridden by classes that extend from this.
   *
   * @constructs YouboraObject
   * @abstract
   * @memberof youbora
   */ constructor: function constructor() {}
};
/**
 * This method allows the extension of the current class, emulating 1-level inheritance.
 * It is inspired by Backbone's extend, but removing all references to underscore.
 *
 * @see http://backbonejs.org/#Model-extend
 *
 * @example
 * var A = YouboraObject.extend({ a: 1, b: 1, c: { d: 0 } });
 * var a = new A(); // { a: 1, b: 1, c: { d: 0 } }
 *
 * var B = A.extend({ b: 2, c: { e: 3 } });
 * var b = new B(); // { a: 1, b: 2, c: { e: 3 } }
 *
 * @param  {Object} protoProps  Prototype properties (available on the instances)
 * @param  {Object} staticProps Static properties (available on the contructor)
 * @return {Object}             New sub class
 */ YouboraObject.extend = function(protoProps, staticProps) {
    var parent = this;
    var child;
    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && protoProps.hasOwnProperty("constructor")) {
        child = protoProps.constructor;
    } else {
        child = function child() {
            return parent.apply(this, arguments);
        };
    }
    // Add static properties to the constructor function, if supplied.
    assign(child, parent, staticProps);
    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function and add the prototype properties.
    child.prototype = createObject(parent.prototype);
    if (protoProps) assign(child.prototype, protoProps);
    child.prototype.constructor = child;
    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;
    return child;
};
module.exports = YouboraObject;


/***/ }),

/***/ 71293:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
var YouboraObject = __webpack_require__(831);
var Log = __webpack_require__(39610);
var DeprecatedOptions = YouboraObject.extend({
    exists: function exists(optionName) {
        return DeprecatedOptions.Dictionary.hasOwnProperty(optionName) // eslint-disable-line no-prototype-builtins
        ;
    },
    getNewName: function getNewName(optionName) {
        var newName = DeprecatedOptions.Dictionary[optionName];
        Log.warn('The option "' + optionName + '" is deprecated, use "' + newName + '" instead');
        return newName;
    }
}, {
    // Keys are old option names
    // Values are new option names
    Dictionary: {
        httpSecure: "app.https",
        username: "user.name",
        anonymousUser: "user.anonymousId",
        obfuscateIp: "user.obfuscateIp",
        userType: "user.type",
        "content.title2": "content.program",
        "background.settings.iphone": "background.settings.iOS",
        "parse.hls": "parse.manifest",
        "parse.dash": "parse.manifest",
        "parse.locationHeader": "parse.manifest",
        "extraparam.1": "content.customDimension.1",
        "extraparam.2": "content.customDimension.2",
        "extraparam.3": "content.customDimension.3",
        "extraparam.4": "content.customDimension.4",
        "extraparam.5": "content.customDimension.5",
        "extraparam.6": "content.customDimension.6",
        "extraparam.7": "content.customDimension.7",
        "extraparam.8": "content.customDimension.8",
        "extraparam.9": "content.customDimension.9",
        "extraparam.10": "content.customDimension.10",
        "extraparam.11": "content.customDimension.11",
        "extraparam.12": "content.customDimension.12",
        "extraparam.13": "content.customDimension.13",
        "extraparam.14": "content.customDimension.14",
        "extraparam.15": "content.customDimension.15",
        "extraparam.16": "content.customDimension.16",
        "extraparam.17": "content.customDimension.17",
        "extraparam.18": "content.customDimension.18",
        "extraparam.19": "content.customDimension.19",
        "extraparam.20": "content.customDimension.20",
        "ad.extraparam.1": "ad.customDimension.1",
        "ad.extraparam.2": "ad.customDimension.2",
        "ad.extraparam.3": "ad.customDimension.3",
        "ad.extraparam.4": "ad.customDimension.4",
        "ad.extraparam.5": "ad.customDimension.5",
        "ad.extraparam.6": "ad.customDimension.6",
        "ad.extraparam.7": "ad.customDimension.7",
        "ad.extraparam.8": "ad.customDimension.8",
        "ad.extraparam.9": "ad.customDimension.9",
        "ad.extraparam.10": "ad.customDimension.10"
    }
});
module.exports = DeprecatedOptions;


/***/ }),

/***/ 5203:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
var YouboraObject = __webpack_require__(831);
var Storage = __webpack_require__(91305);
/**
 * This class manages data storage for offline events in an storage.
 *
 * @extends youbora.Emitter
 * @memberof youbora
 */ var OfflineStorage = YouboraObject.extend({
    constructor: function constructor() {
        this.storage = new Storage("youboraOffline", true) // No cookies for offline
        ;
        this.actualView = null;
        this.viewList = [];
        this.givenIds = [];
        this._getOldViewList();
    },
    _newView: function _newView() {
        // search for first unused id
        var viewId = this._getValidId();
        // create empty view
        this.storage.setLocal(viewId, "");
        // add to viewlist
        this.viewList.push(viewId);
        this.storage.setLocal("views", this.viewList);
        // save the id
        this.actualView = viewId;
    },
    addEvent: function addEvent(event, params) {
        // if event is start, create new view
        if (event === "/start") this._newView();
        // if event is init, ignore
        if (event === "/init") return null;
        // if we have no view discard
        if (!this.actualView) return null;
        // create event object
        var fullEvent = '{"request":"' + event.slice(1) + '",' // {"request":"start",
        ;
        fullEvent += '"unixtime":' + Date.now() + "," // "unixtime":1499876515,
        ;
        for(var param in params){
            if (params[param] === undefined) break;
            fullEvent += '"' + param + '":' // "aParam":
            ;
            if (param === "code") {
                fullEvent += '"' + "CODE_PLACEHOLDER" + '",' // "CODE_PLACEHOLDER",
                ;
            } else if (param === "sessionId") {
                fullEvent += '"' + "SESSION_PLACEHOLDER" + '",' // "SESSION_PLACEHOLDER",
                ;
            } else if (param === "sessionRoot") {
                fullEvent += '"' + "ROOT_PLACEHOLDER" + '",' // "ROOT_PLACEHOLDER",
                ;
            } else if (typeof params[param] === "string") {
                fullEvent += '"' + params[param] + '",' // "aStringValue",
                ;
            } else if (typeof params[param] === "object") {
                fullEvent += '"' + JSON.stringify(params[param]).replace(/"/g, '\\"') + '",' // json object
                ;
            } else {
                fullEvent += params[param] + "," // 123, for example
                ;
            }
        }
        fullEvent = fullEvent.slice(0, -1) // remove the last comma
        ;
        fullEvent += "}";
        // get accumulated view object
        var temp = this.storage.getLocal(this.actualView);
        if (temp !== "") temp = temp + "," // comma between events
        ;
        // add the event
        this.storage.setLocal(this.actualView, temp + fullEvent);
    },
    getView: function getView() {
        if (this.viewList.length > this.givenIds.length) {
            var position = 0;
            while(true){
                var idToSend = this.viewList[position];
                if (this.givenIds.indexOf(idToSend) < 0) {
                    this.givenIds.push(idToSend);
                    return [
                        "[" + this.storage.getLocal(idToSend) + "]",
                        idToSend
                    ];
                }
                position++;
            }
        }
        return [
            null,
            null
        ];
    },
    removeView: function removeView(id) {
        this.storage.removeLocal(id);
        var position = this.viewList.indexOf(id);
        if (position !== -1) this.viewList.splice(position, 1);
        position = this.givenIds.indexOf(id);
        if (position !== -1) this.givenIds.splice(position, 1);
        this.storage.setLocal("views", this.viewList.toString());
        if (id === this.actualView) this.actualView = null;
    },
    _getOldViewList: function _getOldViewList() {
        var stringList = "";
        if (this.storage.getLocal("views")) {
            stringList = this.storage.getLocal("views");
        } else {
            this.storage.setLocal("views", "");
        }
        if (stringList === "") {
            this.viewList = [];
        } else if (typeof stringList.split === "function") {
            this.viewList = stringList.split(",");
        }
    },
    _getValidId: function _getValidId() {
        // get a value not in the list
        var id = Math.floor(Math.random() * 1e8).toString();
        if (this.viewList.indexOf(id) >= 0) {
            return this._getValidId();
        }
        return id;
    },
    sent: function sent() {
        this.givenIds = [];
    }
});
module.exports = OfflineStorage;


/***/ }),

/***/ 50489:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
var YouboraObject = __webpack_require__(831);
var DeprecatedOptions = __webpack_require__(71293);
var Log = __webpack_require__(39610);
var TransportFormat = __webpack_require__(60124);
var StreamingProtocol = __webpack_require__(48679);
var RequestMethod = __webpack_require__(84586);
var Options = YouboraObject.extend(/** @lends youbora.Options.prototype */ {
    /**
     * This Class store youbora configuration settings.
     * Any value specified in this class, if set, will override the info the plugin is able to get
     * on its own.
     *
     * @constructs Options
     * @param {Object|Options} [options] A literal containing values.
     * @extends youbora.YouboraObject
     * @memberof youbora
     */ constructor: function constructor(options) {
        /** @prop {boolean} [enabled=true] If false, the plugin won't send NQS requests. */ this.enabled = true;
        /** @prop {string} [host='a-fds.youborafds01.com'] Host of the Fastdata service. */ this.host = "a-fds.youborafds01.com";
        /**
      * @prop {string} [accountCode='nicetest']
      * NicePeopleAtWork account code that indicates the customer account.
      */ this.accountCode = "nicetest";
        /**
       * @prop {string} [authToken]
       * Optional auth token to validate all the requests
       */ this.authToken = null;
        /**
       * @prop {string} [authType]
       * Optional auth type. Used if authToken is set.
       * 'Bearer' by default.
       */ this.authType = "Bearer";
        /**
      *  @prop {boolean} [preventZombieViews=true]
      * If true, the plugin will check if the last event
      * was sent more than 10 mins ago
      * so it will not send more events to the same view
      */ this.preventZombieViews = true;
        /**
      * @prop {boolean} [offline=false]
      * If true the plugin will store the events and send them later when there's connection
      */ this.offline = false;
        /** @prop {string} [referer] Site url.
      *  By default window.location.href */ this.referer = null;
        /** @prop {string} [referral] Previous site url.
      *  By default document.referrer */ this.referral = null;
        /**
      * @prop {boolean} [disableCookies]
      * To disable cookies storage fallback after local/sessionstorage
      * True by default
      */ this.disableCookies = true;
        /**
      * @prop {boolean} [forceCookies]
      * To force the use of cookies storage instead of local/sessionstorage
      * False by default
      */ this.forceCookies = false;
        /**
      * @prop {boolean} [disableStorage]
      * To disable all possible storages usage (cookies, localStorage, sessionStorage)
      * CAUTION: enabling this option session tracking may stop to work properly
      * False by default
      */ this.disableStorage = false;
        // USER
        /**
      * @prop {string} [user.email]
      * User email.
      */ this["user.email"] = null;
        /**
      * @prop {string} [user.type]
      * User type.
      */ this["user.type"] = null;
        /**
      * @prop {string} [user.name]
      * User ID value inside your system.
      */ this["user.name"] = null;
        /**
      *  @prop {boolean} [user.obfuscateIp=false]
      * If true, the view will have the IP obfuscated
      */ this["user.obfuscateIp"] = false;
        /**
      * @prop {string} [user.anonymousId]
      * Anonymous identifyer of the user provided by the customer.
      */ this["user.anonymousId"] = null;
        /**
      * @prop {string} [user.privacyProtocol]
      * Privacy protocol to be used, nothing by default.
      * Possible values are "optin" and "optout"
      */ this["user.privacyProtocol"] = null;
        /**
      * @prop {string} [user.profileId]
      * Profile ID value inside your system.
      */ this["user.profileId"] = null;
        // PARSERS
        /**
      * @prop {boolean} [parse.manifest=false]
      * If true the plugin will look for location value in manifest header to retrieve the actual resource,
      * will parse HLS files to use the first .ts file found as resource and
      * will look for location and segment values inside DASH manifest to retrieve the actual resource
      * It might slow performance down.
      */ this["parse.manifest"] = false;
        /**
      * @prop {boolean} [parse.cdnParser.get=false]
      * If true, the plugin will make a GET request to the CDN resource in order to retrieve the chunk headers
      * instead of using a HEAD request by default.
      */ this["parse.cdnParser.get"] = false;
        /**
      * @prop {boolean} [parse.manifest.lastChunk=false]
      * If true, when parsing manifests (HLS/DASH), the plugin will check the last chunk file instead
      * of the first chunk file. This is useful when the first chunk might be expired.
      * Only applies when parse.manifest is enabled.
      */ this["parse.manifest.lastChunk"] = false;
        /**
      * @prop {boolean} [parse.locationHeader.get=false]
      * If true, the plugin will make a GET request to the media resource in order to retrieve the location header,
      * instead of using a HEAD request by default.
      */ this["parse.locationHeader.get"] = false;
        /**
      * @prop {object} [parse.manifest.auth={}]
      * If parse.manifest enabled, it adds extra headers to the request of the content.
      * Use this if for example, the player needs to include authentication headers to request the content,
      * so the plugin needs it to access to the manifest files too.
      */ this["parse.manifest.auth"] = {};
        /**
       * @prop {array<string>} [parse.CdnNameHeader]
       * If defined, resource parse will try to fetch the CDN code from the custom header defined
       * by this property. ie: '[x-cdn-forward]'
       */ this["parse.cdnNameHeader"] = [
            "x-cdn-forward"
        ];
        /**
      * @prop {string} [parse.CdnNodeHeader]
      * If defined, resource parse will try to fetch the CDN node name from the custom header defined
      * by this property. ie: 'x-node'
      */ this["parse.cdnNodeHeader"] = "";
        /**
      * @prop {boolean} [parse.CdnNode=false]
      * If true the plugin will query the CDN to retrieve the node name.
      * It might slow performance down.
      */ this["parse.cdnNode"] = false;
        /**
      * @prop {array<string>} [parse.CdnNode.list=false]
      * If true the plugin will query the CDN to retrieve the node name.
      * It might slow performance down.
      */ this["parse.cdnNode.list"] = [
            "Akamai",
            "Amazon",
            "Cloudfront",
            "Level3",
            "Fastly",
            "Highwinds",
            "Telefonica",
            "Edgecast",
            "NosOtt"
        ];
        /**
       * @prop {function} [parse.fdsResponseHost=null]
       * Parses fastdata response to modify the host where the requests will be sent
       */ this["parse.fdsResponseHost"] = null;
        /**
       * @prop {function} [parse.cdnSwitchHeader=false]
       * Parses a video chunk or manifest every x seconds to read the x-cdn header and report it
       */ this["parse.cdnSwitchHeader"] = false;
        /**
       * @prop {function} [parse.cdnTTL=60]
       * if parse.cdnSwitchHeader enabled, the time between new requests
       */ this["parse.cdnTTL"] = 60;
        // NETWORK
        /** @prop {string} [network.ip] IP of the viewer/user. ie= '100.100.100.100'. */ this["network.ip"] = null;
        /** @prop {string} [network.isp] Name of the internet service provider of the viewer/user. */ this["network.isp"] = null;
        /**
      * @prop {string} [network.connectionType]
      * Type of connection used
      */ this["network.connectionType"] = null;
        // DEVICE
        /**
       * @prop {string} [device.id]
       * Unique identifyer of the device. If set it will consider the value as the device id.
       * By default the plugin tries to generate a unique id based on exposed information on the browser.
       * It wont be sent if 'device.isAnonymous option' is set to true.
       */ this["device.id"] = null;
        /**
      * @prop {string} [device.code]
      * Youbora's device code. If specified it will rewrite info gotten from user agent.
      * See a list of codes in {@link http://mapi.youbora.com/devices}
      */ this["device.code"] = null;
        /**
      * @prop {string} [device.model]
      * Device model name
      */ this["device.model"] = null;
        /**
      * @prop {string} [device.brand]
      * Device vendor name
      */ this["device.brand"] = null;
        /**
      * @prop {string} [device.type]
      * Device type (pc, smartphone, stb, tv, etc.)
      */ this["device.type"] = null;
        /**
      * @prop {string} [device.name]
      * Device name. It must exist in NPAW database.
      */ this["device.name"] = null;
        /**
      * @prop {string} [device.osName]
      * OS name.
      */ this["device.osName"] = null;
        /**
      * @prop {string} [device.osVersion]
      * OS version.
      */ this["device.osVersion"] = null;
        /**
      * @prop {string} [device.browserName]
      * Browser name.
      */ this["device.browserName"] = null;
        /**
      * @prop {string} [device.browserVersion]
      * Browser version.
      */ this["device.browserVersion"] = null;
        /**
      * @prop {string} [device.browserType]
      * Browser type.
      */ this["device.browserType"] = null;
        /**
      * @prop {string} [device.browserEngine]
      * Browser engine.
      */ this["device.browserEngine"] = null;
        /**
      * @prop {string} [device.EDID]
      * Connected screen EDID.
      * The expected format is a hex value
      */ this["device.EDID"] = null;
        /**
      * @prop {bool} [device.isAnonymous]
      * If true, it blocks 'deviceUUID' parameter in requests.
      */ this["device.isAnonymous"] = false;
        // CONTENT
        /** @prop {string} [content.transactionCode] Custom unique code to identify the view. */ this["content.transactionCode"] = null;
        /** @prop {string} [content.resource] URL/path of the current media resource. */ this["content.resource"] = null;
        /** @prop {boolean} [content.isLive] True if the content is live false if VOD. */ this["content.isLive"] = null;
        /** @prop {boolean} [content.isLive.noSeek] True if the player seeks automatically when resumed or ending buffer. Only for live content. False by default */ this["content.isLive.noSeek"] = false;
        /** @prop {boolean} [content.isLive.noMonitor] True if the player returns non consistent values for the playhead on live, so playhead monitor wont work to detect buffers and seeks. False by default. */ this["content.isLive.noMonitor"] = false;
        /** @prop {string} [content.title] Title of the media. */ this["content.title"] = null;
        /** @prop {string} [content.program] Secondary title of the media */ this["content.program"] = null;
        /** @prop {number} [content.duration] Duration of the media. */ this["content.duration"] = null;
        /** @prop {number} [content.fps] Frames per second of the content in the current moment. */ this["content.fps"] = null;
        /** @prop {number} [content.segmentDuration] Video segment length in milliseconds. */ this["content.segmentDuration"] = null;
        /** @prop {number} [content.bitrate] Bitrate of the content in bits per second. */ this["content.bitrate"] = null;
        /** @prop {number} [content.totalBytes] Total downloaded bytes of the content. */ this["content.totalBytes"] = null;
        /** @prop {bool} [content.sendTotalBytes] Additionaly report totalbytes or not, default false. */ this["content.sendTotalBytes"] = false;
        /** @prop {number} [content.throughput] Throughput of the client bandwith in bits per second. */ this["content.throughput"] = null;
        /** @prop {string} [content.rendition] Name of the current rendition of the content. */ this["content.rendition"] = null;
        /**
       * @prop {string} [content.cdn]
       * Codename of the CDN where the content is streaming from.
       * See a list of codes in {@link http://mapi.youbora.com/cdns}
       * */ this["content.cdn"] = null;
        /** @prop {string} [content.cdnNode] CDN node id */ this["content.cdnNode"] = null;
        /**
       * @prop {number} [content.cdnType] CDN node content access type
       * It defines if the content request hits the cache or not
       * TCP_HIT / HIT: 1
       * TCP_MISS / MISS: 2
       * TCP_MEM_HIT: 3
       * TCP_IMS_HIT: 4
       */ this["content.cdnType"] = null;
        /**
       * @prop {object} [content.metadata]
       * Item containing mixed extra information about the content like: director, parental rating,
       * device info or the audio channels.This object may store any serializable key:value info.
       */ this["content.metadata"] = {};
        /**
       * @prop {object} [content.metrics]
       * Item containing metrics in json format. Reported every ping if the values change
       */ this["content.metrics"] = {};
        /** @prop {string} [content.streamingProtocol] Name of the streaming media protocol.
       * Can be:
       *   - HDS (Adobe HDS)
       *   - HLS (Apple HLS)
       *   - MSS (Microsoft Smooth Streaming)
       *   - DASH (MPEG-DASH)
       *   - RTMP (Adobe RTMP)
       *   - RTP (RTP)
       *   - RTSP (RTSP)
       *   - MULTICAST (Multicast)
       *   - DVB (DVB)
       *   - DVBC (DVB-C)
       *   - DVBT (DVB-T)
       *   - DVBT2 (DVB-T2)
       */ this["content.streamingProtocol"] = null;
        /** @prop {string} [content.transportFormat] Name of the transport format.
       * Can be:
       *   - TS (MPEG-2 TS)
       *   - MP4 (Fragmented MP4)
       */ this["content.transportFormat"] = null;
        /** @prop {number} [content.package] Package of the media. */ this["content.package"] = null;
        /** @prop {number} [content.saga] Saga of the media. */ this["content.saga"] = null;
        /** @prop {number} [content.tvShow] TV Show of the media. */ this["content.tvShow"] = null;
        /** @prop {number} [content.season] Season of the media. */ this["content.season"] = null;
        /** @prop {number} [content.episodeTitle] Episode title of the media. */ this["content.episodeTitle"] = null;
        /** @prop {number} [content.channel] Channel name of the media. */ this["content.channel"] = null;
        /** @prop {number} [content.id] ID of the media. */ this["content.id"] = null;
        /** @prop {number} [content.imdbId] IMDB id of the media. */ this["content.imdbId"] = null;
        /** @prop {number} [content.gracenoteId] Gracenote id of the media. */ this["content.gracenoteId"] = null;
        /** @prop {number} [content.type] Type of the media. */ this["content.type"] = null;
        /** @prop {number} [content.genre] Genre of the media. */ this["content.genre"] = null;
        /** @prop {number} [content.language] Language of the media. */ this["content.language"] = null;
        /** @prop {boolean} [content.autodetect.language] Auto detect change languages value. */ this["content.autodetect.language"] = true;
        /** @prop {number} [content.subtitles] Subtitles of the media. */ this["content.subtitles"] = null;
        /** @prop {boolean} [content.autodetect.subtitles] Auto detect change subtitles value. */ this["content.autodetect.subtitles"] = true;
        /** @prop {number} [content.contractedResolution] Contracted Resolution of the media. */ this["content.contractedResolution"] = null;
        /** @prop {number} [content.cost] Cost of the media. */ this["content.cost"] = null;
        /** @prop {number} [content.price] Price of the media. */ this["content.price"] = null;
        /** @prop {number} [content.playbackType] Type of the media. Can be Vod, Live, catch-up or offline */ this["content.playbackType"] = null;
        /** @prop {number} [content.drm] DRM of the media. */ this["content.drm"] = null;
        // Encoding
        /** @prop {number} [content.encoding.videoCodec] Video codec of the media. */ this["content.encoding.videoCodec"] = null;
        /** @prop {number} [content.encoding.audioCodec] Audio codec of the media. */ this["content.encoding.audioCodec"] = null;
        /** @prop {number} [content.encoding.codecSettings] Codec settings of the media. */ this["content.encoding.codecSettings"] = null;
        /** @prop {number} [content.encoding.codecProfile] Codec profile of the media. */ this["content.encoding.codecProfile"] = null;
        /** @prop {number} [content.encoding.containerFormat] Container format of the media. */ this["content.encoding.containerFormat"] = null;
        // ADS
        /**
      * @prop {object} [ad.metadata]
      * Item containing mixed extra information about ads like: request url.
      * This object may store any serializable key:value info.
      */ this["ad.metadata"] = {};
        /**
      * @prop {string} [ad.campaign]
      * String containing the name of the campaign
      */ this["ad.campaign"] = null;
        /**
      * @prop {string} [ad.creativeId]
      * String containing the id of the creative
      */ this["ad.creativeId"] = null;
        /**
      * @prop {string} [ad.provider]
      * String containing the provider of the ad
      */ this["ad.provider"] = null;
        /**
      * @prop {string} [ad.resource]
      * String containing the ad resource
      */ this["ad.resource"] = null;
        /**
      * @prop {string} [ad.title]
      * String containing the title of the campaign
      */ this["ad.title"] = null;
        /**
      * @prop {duration} [ad.duration]
      * Duration of the ad in seconds
      */ this["ad.duration"] = null;
        /**
      * @prop {object} [ad.expectedPattern]
      * Json with the position of the breaks expected.
      * Arrays are the number of breaks, and the numbers in them, the number of ads for each break
      *
      * Example:
      * {pre: [1],
      * mid: [1,2],
      * post: [1]}
      * Would be a view with 1 preroll break with 1 ad, 2 midroll breaks, one with 1 ad and
      * the other with 2, and one postroll break with 1 ad.
      */ this["ad.expectedPattern"] = null;
        /**
      * @prop {string} [ad.givenAds]
      * Number of ads given by the adserver for this break
      */ this["ad.givenAds"] = null;
        /**
      * @prop {number[]} [ad.breaksTime]
      * Array of numbers for the time position of adbreaks
      */ this["ad.breaksTime"] = null;
        /**
      * @prop {string} [ad.expectedBreaks]
      * Number of breaks expected for the view
      */ this["ad.expectedBreaks"] = null;
        /**
      * @prop {number} [ad.givenBreaks]
      * Number of breaks given by the adserver for the view
      */ this["ad.givenBreaks"] = null;
        /**
      * @prop {boolean} [ad.ignore]
      * False by default.
      * If true, youbora blocks ad events and calculates jointime ignoring ad time.
      */ this["ad.ignore"] = false;
        /**
      * @prop {boolean} [ad.blockerDetected]
      * Null (notified as false) by default.
      * Sets if an adblocker has been detected
      */ this["ad.blockerDetected"] = null;
        // APP
        /**
      * @prop {string} [app.name]
      * String containing the name of the app
      */ this["app.name"] = null;
        /**
      * @prop {string} [app.releaseVerson]
      * String containing the app version
      */ this["app.releaseVersion"] = null;
        /**
      * @prop {boolean} [app.https=null]
      * Define the security of NQS calls.
      * If true it will use 'https://',
      * if false it will use 'http://',
      * if null/undefined it will use '//'.
      */ this["app.https"] = false;
        // BACKGROUND
        /**
      *  @prop {boolean} [background.enabled=false]
      * If true, plugin will send background/foreground events
      * Different device behaviour is settable in background.settings
      */ this["background.enabled"] = true;
        /**
      *  @prop {string} [background.settings]
      * Action to do when the browser goes to background.
      * Options are 'stop', 'pause', and '' for no action.
      * stop will be used to stop the view and track post-foreground events in a new view
      * pause will be used when after foreground event, an action like pressing play button is expected to resume the content
      * '' will be used if the content can be played in background
      * If not defined, specific device options will be used
      * background.setings.android / background.settings.iOS / background.settings.desktop / background.settings.tv
      * Default specific device values are stop for android and iphone, nothing for desktop.
      */ this["background.settings"] = null;
        /**
      *  @prop {string} [background.settings.android='stop']
      * If background.settings is not defined, action to do when the browser goes to background if
      * the device is android type.
      * Options are 'stop', 'pause', and '' or not defined for no action.
      * bg by default
      */ this["background.settings.android"] = "stop";
        /**
      *  @prop {string} [background.settings.iOS='stop']
      * If background.settings is not defined, action to do when the browser goes to background if
      * the device is iphone type.
      * Options are 'stop', 'pause', and '' or not defined for no action.
      * bg by default
      */ this["background.settings.iOS"] = "stop";
        /**
      *  @prop {string} [background.settings.desktop=null]
      * If background.settings is not defined, action to do when the browser goes to background if
      * the device is desktop type.
      * Options are 'stop', 'pause', and '' or not defined for no action.
      * Null by default
      */ this["background.settings.desktop"] = null;
        /**
      *  @prop {string} [background.settings.tv='stop']
      * If background.settings is not defined, action to do when the browser goes to background if
      * the device is smartTV type.
      * Options are 'stop', 'pause', and '' or not defined for no action.
      * bg by default
      */ this["background.settings.tv"] = "stop";
        /**
      *  @prop {string} [background.settings.playstation='stop']
      * If background.settings is not defined, action to do when the browser goes to background if
      * the device is playstation type.
      * Options are 'stop', 'pause', and '' or not defined for no action.
      * Null by default
      */ this["background.settings.playstation"] = "stop";
        // CDN BALANCER
        /**
      *  @prop {string} [cdnbalancer.uuid]
      * CDN Balancer Response UUID
      * null by default
      */ this["cdnbalancer.uuid"] = null;
        // EXTRAPARAMS // CUSTOM DIMENSIONS
        /** @prop {object} [content.customDimensions] Custom dimensions object. */ this["content.customDimensions"] = {};
        /** @prop {string} [content.customDimension.1] Custom parameter 1. */ this["content.customDimension.1"] = null;
        /** @prop {string} [content.customDimension.2] Custom parameter 2. */ this["content.customDimension.2"] = null;
        /** @prop {string} [content.customDimension.3] Custom parameter 3. */ this["content.customDimension.3"] = null;
        /** @prop {string} [content.customDimension.4] Custom parameter 4. */ this["content.customDimension.4"] = null;
        /** @prop {string} [content.customDimension.5] Custom parameter 5. */ this["content.customDimension.5"] = null;
        /** @prop {string} [content.customDimension.6] Custom parameter 6. */ this["content.customDimension.6"] = null;
        /** @prop {string} [content.customDimension.7] Custom parameter 7. */ this["content.customDimension.7"] = null;
        /** @prop {string} [content.customDimension.8] Custom parameter 8. */ this["content.customDimension.8"] = null;
        /** @prop {string} [content.customDimension.9] Custom parameter 9. */ this["content.customDimension.9"] = null;
        /** @prop {string} [content.customDimension.10] Custom parameter 10. */ this["content.customDimension.10"] = null;
        /** @prop {string} [content.customDimension.11] Custom parameter 11. */ this["content.customDimension.11"] = null;
        /** @prop {string} [content.customDimension.12] Custom parameter 12. */ this["content.customDimension.12"] = null;
        /** @prop {string} [content.customDimension.13] Custom parameter 13. */ this["content.customDimension.13"] = null;
        /** @prop {string} [content.customDimension.14] Custom parameter 14. */ this["content.customDimension.14"] = null;
        /** @prop {string} [content.customDimension.15] Custom parameter 15. */ this["content.customDimension.15"] = null;
        /** @prop {string} [content.customDimension.16] Custom parameter 16. */ this["content.customDimension.16"] = null;
        /** @prop {string} [content.customDimension.17] Custom parameter 17. */ this["content.customDimension.17"] = null;
        /** @prop {string} [content.customDimension.18] Custom parameter 18. */ this["content.customDimension.18"] = null;
        /** @prop {string} [content.customDimension.19] Custom parameter 19. */ this["content.customDimension.19"] = null;
        /** @prop {string} [content.customDimension.20] Custom parameter 20. */ this["content.customDimension.20"] = null;
        /** @prop {string} [ad.customDimension.1] Ad custom parameter 1. */ this["ad.customDimension.1"] = null;
        /** @prop {string} [ad.customDimension.2] Ad custom parameter 2. */ this["ad.customDimension.2"] = null;
        /** @prop {string} [ad.customDimension.3] Ad custom parameter 3. */ this["ad.customDimension.3"] = null;
        /** @prop {string} [ad.customDimension.4] Ad custom parameter 4. */ this["ad.customDimension.4"] = null;
        /** @prop {string} [ad.customDimension.5] Ad custom parameter 5. */ this["ad.customDimension.5"] = null;
        /** @prop {string} [ad.customDimension.6] Ad custom parameter 6. */ this["ad.customDimension.6"] = null;
        /** @prop {string} [ad.customDimension.7] Ad custom parameter 7. */ this["ad.customDimension.7"] = null;
        /** @prop {string} [ad.customDimension.8] Ad custom parameter 8. */ this["ad.customDimension.8"] = null;
        /** @prop {string} [ad.customDimension.9] Ad custom parameter 9. */ this["ad.customDimension.9"] = null;
        /** @prop {string} [ad.customDimension.10] Ad custom parameter 10. */ this["ad.customDimension.10"] = null;
        /** @prop {bool} [forceInit] Forces init to be sent instead of start, use it when mediaduration,
      *  title, source or is live is reported with a wrong value by the player until jointime happens */ this.forceInit = false;
        /**
      * @prop {object} [session.metrics]
      * Item containing metrics in json format. Reported every beat if the values change
      */ this["session.metrics"] = {};
        /**
      * @prop {bool} [session.context]
      * Boolean to choose to report context or not. False by default
      */ this["session.context"] = false;
        /**
      * @prop {array<string>} [errors.fatal=[]]
      * If it has elements on it, all the errors matching this code will fire the stop event to end the view
      */ this["errors.fatal"] = [];
        /**
      * @prop {array<string>} [errors.nonFatal=[]]
      * If it has elements on it, all the errors matching this code won't fire a stop event to end the view
      */ this["errors.nonFatal"] = [];
        /**
      * @prop {array<string>} [errors.ignore=[]]
      * If it has elements on it, all the errors matching this code wont be reported
      */ this["errors.ignore"] = [];
        /**
       * @prop {string} linkedViewId
       * String to send on start events to link views with previous session events
       */ this.linkedViewId = null;
        /**
      * @prop {bool} [waitForMetadata]
      * Boolean to delay the start event. Use with `pendingMetadata`
      */ this.waitForMetadata = false;
        /**
      * @prop {array<string>} [pendingMetadata]
      * List of values that should be ready to send in start event. Use with `waitForMetadata` set to True.
      */ this.pendingMetadata = [];
        /**
       * @prop {string} method
       * Method used to send request to backend side
       *  Options are 'get' or 'post'
       *  'get' by default
       */ this.method = RequestMethod.GET;
        /**
       * @prop {bool} [playhead.monitor]
       * Method to enabled/disable support for playhead monitor method
       */ this["playhead.monitor"] = true;
        /**
       * @prop {bool} [network.monitor]
       * Method to enabled/disable support for readyState monitor method
       */ this["readyState.monitor"] = true;
        /**
       * @prop {bool} [splitViews]
       * Method to enabled/disable the view splitting when some errors are stashed in the request
       */ this["session.splitViews"] = false;
        this.setOptions(options);
    },
    /**
    * Recursively sets the properties present in the params object.
    * ie: this.username = params.username.
    *
    * @param {Object} options A literal or another Data containing values.
    * @param {Object} [base=this] Start point for recursion.
    */ setOptions: function setOptions(options, base) {
        var isInBase = false;
        if (base === undefined) {
            base = this;
            isInBase = true;
            var deprecatedOptions = new DeprecatedOptions();
        }
        if (typeof options !== "undefined") {
            for(var key in options){
                var deprecated = false;
                var newKey = null;
                if (isInBase) {
                    if (!this.hasOwnProperty(key)) {
                        if (deprecatedOptions.exists(key)) {
                            newKey = deprecatedOptions.getNewName(key);
                            deprecated = true;
                        } else {
                            Log.warn('The option "' + key + '" does not exist, so it cannot be set');
                        }
                    }
                }
                if (typeof base[key] === "object" && base[key] !== null && !Array.isArray(base[key]) && key === "parse.cdnNode.list") {
                    this.setOptions(options[key], base[key]);
                } else {
                    if (deprecated) {
                        base[newKey] = options[key];
                    } else {
                        base[key] = options[key];
                    }
                }
            }
        }
    },
    /**
    * Sets all the values given in an array as extraparams. Limit is 20
    * @param {array<string>} paramsArray array of extraparam strings
    * */ setExtraParams: function setExtraParams(paramsArray) {
        var maxLength = 20;
        if (typeof paramsArray !== "object" || !paramsArray.length) return;
        if (paramsArray.length >= maxLength) paramsArray = paramsArray.slice(0, maxLength);
        while(paramsArray.length < maxLength){
            paramsArray.push(null);
        }
        paramsArray.forEach((function(param, index) {
            this["content.customDimension." + (index + 1).toString()] = param;
        }).bind(this));
    },
    /**
    * @alias youbora.options.prototype.setExtraParams.
    */ setCustomDimensions: function setCustomDimensions() {
        Options.prototype.setExtraParams.apply(this, arguments);
    },
    /**
    * Sets all the values given in an array as extraparams. Limit is 10
    * @param {array<string>} paramsArray array of extraparam strings
    * */ setAdExtraParams: function setAdExtraParams(paramsArray) {
        var maxLength = 10;
        if (typeof paramsArray !== "object" || !paramsArray.length) return;
        if (paramsArray.length >= maxLength) paramsArray = paramsArray.slice(0, maxLength);
        while(paramsArray.length < maxLength){
            paramsArray.push(null);
        }
        paramsArray.forEach((function(param, index) {
            this["ad.customDimension." + (index + 1).toString()] = param;
        }).bind(this));
    },
    /**
    * @alias youbora.options.prototype.setAdExtraParams.
    */ setAdCustomDimensions: function setAdCustomDimensions() {
        Options.prototype.setAdExtraParams.apply(this, arguments);
    }
}, {
    // Constants
    StreamingProtocol: StreamingProtocol,
    TransportFormat: TransportFormat,
    RequestMethod: RequestMethod
});
module.exports = Options;


/***/ }),

/***/ 97429:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
var Log = __webpack_require__(39610);
var Util = __webpack_require__(37280);
var Constants = __webpack_require__(56230);
// This file is designed to add extra functionalities to Plugin class
var PluginAdsGettersMixin = {
    /**
   * Returns ads's PlayerVersion
   *
   * @memberof youbora.Plugin.prototype
   */ getAdPlayerVersion: function getAdPlayerVersion() {
        return this._safeGetterAdsAdapter("getPlayerVersion") || "";
    },
    /**
   * Returns ad's position
   *
   * @memberof youbora.Plugin.prototype
   */ getAdPosition: function getAdPosition() {
        var ret = Constants.AdPosition.Preroll;
        if (this._adsAdapter) {
            try {
                var temporalRet = this._adsAdapter.getPosition();
                if (Constants.AdPosition.Preroll === temporalRet || Constants.AdPosition.Midroll === temporalRet || Constants.AdPosition.Postroll === temporalRet) {
                    ret = temporalRet;
                }
            } catch (err) {
                Log.warn("An error occured while calling getAdPosition", err);
            }
        }
        if (!ret && this._adapter) {
            ret = this._adapter.flags.isJoined ? Constants.AdPosition.Midroll : Constants.AdPosition.Preroll;
        }
        return ret;
    },
    getAdNumber: function getAdNumber() {
        return this.requestBuilder.lastSent.adNumber || 0;
    },
    getAdNumberInBreak: function getAdNumberInBreak() {
        return this.requestBuilder.lastSent.adNumberInBreak || 0;
    },
    getBreakNumber: function getBreakNumber() {
        return this.requestBuilder.lastSent.breakNumber || 0;
    },
    /**
   * Returns ad's AdPlayhead
   *
   * @memberof youbora.Plugin.prototype
   */ getAdPlayhead: function getAdPlayhead() {
        var ret = this._safeGetterAdsAdapter("getPlayhead");
        return Util.parseNumber(ret, 0);
    },
    /**
   * Returns ad's AdDuration
   *
   * @memberof youbora.Plugin.prototype
   */ getAdDuration: function getAdDuration() {
        var ret = this._safeGetterAdsAdapter("getDuration", "ad.duration");
        return Util.parseNumber(ret, 0);
    },
    /**
   * Returns ad's AdBitrate
   *
   * @memberof youbora.Plugin.prototype
   */ getAdBitrate: function getAdBitrate() {
        var ret = this._safeGetterAdsAdapter("getBitrate");
        if (!ret || ret === -1) {
            ret = this.getWebkitAdBitrate();
        }
        return Util.parseNumber(ret, -1);
    },
    /**
   * Returns bitrate as per webkitVideoDecodedByteCount
   *
   * @param {Object} tag Video tag DOM reference.
   * @returns {number}
   *
   * @memberof youbora.Plugin.prototype
   */ getWebkitAdBitrate: function getWebkitAdBitrate() {
        if (this._adsAdapter && this._adsAdapter.tag && this._adsAdapter.tag.webkitVideoDecodedByteCount) {
            var bitrate = this._adsAdapter.tag.webkitVideoDecodedByteCount;
            if (this._lastWebkitAdBitrate) {
                var delta = this._adsAdapter.tag.webkitVideoDecodedByteCount - this._lastWebkitAdBitrate;
                bitrate = Math.round(delta / this.viewTransform.response.pingTime * 8);
            }
            this._lastWebkitAdBitrate = this._adsAdapter.tag.webkitVideoDecodedByteCount;
            return bitrate !== 0 ? bitrate : -1;
        }
    },
    /**
   * Returns ad's AdTitle
   *
   * @memberof youbora.Plugin.prototype
   */ getAdTitle: function getAdTitle() {
        return this._safeGetterAdsAdapter("getTitle", "ad.title");
    },
    /**
   * Returns ad's AdResource
   *
   * @memberof youbora.Plugin.prototype
   */ getAdResource: function getAdResource() {
        return this._safeGetterAdsAdapter("getResource", "ad.resource");
    },
    /**
   * Returns ad's campaign
   *
   * @memberof youbora.Plugin.prototype
   */ getAdCampaign: function getAdCampaign() {
        return this._safeGetterAdsAdapter("getCampaign", "ad.campaign");
    },
    /**
  * Returns ad's campaign
  *
  * @memberof youbora.Plugin.prototype
  */ getAdCreativeId: function getAdCreativeId() {
        return this._safeGetterAdsAdapter("getCreativeId", "ad.creativeId");
    },
    /**
  * Returns ad's provider
  *
  * @memberof youbora.Plugin.prototype
  */ getAdProvider: function getAdProvider() {
        return this._safeGetterAdsAdapter("getProvider", "ad.provider");
    },
    /**
   * Returns ads adapter getVersion or null
   *
   * @memberof youbora.Plugin.prototype
   */ getAdAdapterVersion: function getAdAdapterVersion() {
        return this._safeGetterAdsAdapter("getVersion");
    },
    /**
   * Returns ad's AdMetadata
   *
   * @memberof youbora.Plugin.prototype
   */ getAdMetadata: function getAdMetadata() {
        return this.options["ad.metadata"];
    },
    /**
   * Returns the type of ad insertion (clientside, serverside)
   * @returns {string} ad insertion type
   */ getAdInsertionType: function getAdInsertionType() {
        return this._safeGetterAdsAdapter("getAdInsertionType");
    },
    getGivenBreaks: function getGivenBreaks() {
        return this._safeGetterAdsAdapter("getGivenBreaks", "ad.givenBreaks");
    },
    getExpectedBreaks: function getExpectedBreaks() {
        var ret = null;
        var expBreaks = this.options["ad.expectedBreaks"];
        var expPattern = this.options["ad.expectedPattern"];
        if (expBreaks) {
            ret = expBreaks;
        } else if (expPattern) {
            ret = 0;
            ret = expPattern.pre ? expPattern.pre.length : 0;
            ret += expPattern.mid ? expPattern.mid.length : 0;
            ret += expPattern.post ? expPattern.post.length : 0;
        } else if (this._adsAdapter) {
            try {
                ret = this._adsAdapter.getExpectedBreaks();
            } catch (err) {
                Log.warn("An error occured while calling expectedBreaks", err);
            }
        }
        return ret;
    },
    getExpectedPattern: function getExpectedPattern() {
        return this._safeGetterAdsAdapter("getExpectedPattern", "ad.expectedPattern");
    },
    getBreaksTime: function getBreaksTime() {
        return this._safeGetterAdsAdapter("getBreaksTime", "ad.breaksTime");
    },
    getGivenAds: function getGivenAds() {
        return this._safeGetterAdsAdapter("getGivenAds", "ad.givenAds");
    },
    getExpectedAds: function getExpectedAds() {
        var ret = null;
        try {
            if (this._adsAdapter) {
                var pattern = this.options["ad.expectedPattern"];
                if (pattern && this.getAdPosition()) {
                    var list = [];
                    if (pattern.pre) list = list.concat(pattern.pre);
                    if (pattern.mid) list = list.concat(pattern.mid);
                    if (pattern.post) list = list.concat(pattern.post);
                    if (list.length > 0) {
                        var position = this.requestBuilder.lastSent.breakNumber;
                        if (position > list.length) position = list.length;
                        ret = list[position - 1];
                    }
                } else {
                    ret = this._adsAdapter.getExpectedAds();
                }
            }
        } catch (err) {
            Log.warn("An error occured while calling expectedAds", err);
        }
        return ret;
    },
    getAdsExpected: function getAdsExpected() {
        var ret = null;
        try {
            ret = this.getExpectedPattern() || this.getGivenAds() || false;
        } catch (err) {
            Log.warn("An error occured while calling givenAds or expectedPattern", err);
        }
        return ret;
    },
    // ----------------------------------------- CHRONOS ------------------------------------------
    /**
   * Returns AdJoinDuration chrono delta time
   *
   * @memberof youbora.Plugin.prototype
   */ getAdJoinDuration: function getAdJoinDuration() {
        return this._adsAdapter ? this._adsAdapter.chronos.join.getDeltaTime(false) : -1;
    },
    /**
   * Returns AdBufferDuration chrono delta time
   *
   * @memberof youbora.Plugin.prototype
   */ getAdBufferDuration: function getAdBufferDuration() {
        return this._adsAdapter ? this._adsAdapter.chronos.buffer.getDeltaTime(false) : -1;
    },
    /**
   * Returns AdPauseDuration chrono delta time
   *
   * @memberof youbora.Plugin.prototype
   */ getAdPauseDuration: function getAdPauseDuration() {
        return this._adsAdapter ? this._adsAdapter.chronos.pause.getDeltaTime(false) : 0;
    },
    /**
   * Returns total totalAdDuration chrono delta time
   *
   * @memberof youbora.Plugin.prototype
   */ getAdTotalDuration: function getAdTotalDuration() {
        return this._adsAdapter ? this._adsAdapter.chronos.total.getDeltaTime(false) : -1;
    },
    getAdViewedDuration: function getAdViewedDuration() {
        return this._getTimeMaxOrAcum(true);
    },
    getAdViewability: function getAdViewability() {
        return this._getTimeMaxOrAcum();
    },
    _getTimeMaxOrAcum: function _getTimeMaxOrAcum(acum) {
        var maxTime = 0;
        if (this._adsAdapter) {
            this._adsAdapter.chronos.viewedMax.forEach(function(chrono) {
                if (acum) {
                    maxTime += chrono.getDeltaTime(false);
                } else {
                    maxTime = Math.max(chrono.getDeltaTime(false), maxTime);
                }
            });
        }
        return maxTime;
    },
    getAudioEnabled: function getAudioEnabled() {
        return this._safeGetterAdsAdapter("getAudioEnabled");
    },
    getIsSkippable: function getIsSkippable() {
        return this._safeGetterAdsAdapter("getIsSkippable");
    },
    getIsFullscreen: function getIsFullscreen() {
        return this._safeGetterAdsAdapter("getIsFullscreen");
    },
    _safeGetterAdsAdapter: function _safeGetterAdsAdapter(func, option) {
        var ret = null;
        if (option && this.options[option]) {
            ret = this.options[option];
        } else {
            try {
                if (this._adsAdapter && typeof this._adsAdapter[func] === "function") {
                    ret = this._adsAdapter[func]();
                }
            } catch (err) {
                Log.warn("An error occured while calling " + func, err);
            }
        }
        return ret;
    }
};
module.exports = PluginAdsGettersMixin;


/***/ }),

/***/ 69780:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var Log = __webpack_require__(39610);
var Constants = __webpack_require__(56230);
var Adapter = __webpack_require__(28077);
var Util = __webpack_require__(37280);
// This file is designed to add extra functionalities to Plugin class
var PluginAdsMixin = {
    /**
     * Returns current adapter or null.
     *
     * @returns {Adapter}
     *
     * @memberof youbora.Plugin.prototype
     */ getAdsAdapter: function getAdsAdapter() {
        return this._adsAdapter;
    },
    /**
     * Sets an adapter for ads.
     *
     * @param {Adapter} adsAdapter
     *
     * @memberof youbora.Plugin.prototype
     */ setAdsAdapter: function setAdsAdapter(adsAdapter) {
        if (adsAdapter.plugin) {
            Log.warn("Adapters can only be added to a single plugin");
        } else {
            this.removeAdsAdapter();
            adsAdapter.plugin = this;
            this._adsAdapter = adsAdapter;
            adsAdapter.setIsAds(true);
            this.adsAdapterListeners = {};
            this.adsAdapterListeners[Adapter.Event.START] = this._adStartListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.JOIN] = this._adJoinListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.PAUSE] = this._adPauseListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.RESUME] = this._adResumeListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.BUFFER_BEGIN] = this._adBufferBeginListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.BUFFER_END] = this._adBufferEndListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.STOP] = this._adStopListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.ERROR] = this._adErrorListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.CLICK] = this._adClickListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.MANIFEST] = this._adManifestListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.PODSTART] = this._adBreakStartListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.PODSTOP] = this._adBreakStopListener.bind(this);
            this.adsAdapterListeners[Adapter.Event.QUARTILE] = this._adQuartileListener.bind(this);
            for(var key in this.adsAdapterListeners){
                this._adsAdapter.on(key, this.adsAdapterListeners[key]);
            }
        }
    },
    /**
     * Removes the current adapter. Fires stop if needed. Calls adapter.dispose()
     *
     * @memberof youbora.Plugin.prototype
     */ removeAdsAdapter: function removeAdsAdapter() {
        if (this._adsAdapter) {
            this._adsAdapter.dispose();
            this._adsAdapter.plugin = null;
            if (this.adsAdapterListeners) {
                for(var key in this.adsAdapterListeners){
                    this._adsAdapter.off(key, this.adsAdapterListeners[key]);
                }
                delete this.adsAdapterListeners;
            }
            this.resizeScrollDetector.stopDetection();
            this._adsAdapter = null;
        }
    },
    // ---------------------------------------- LISTENERS -----------------------------------------
    _adStartListener: function _adStartListener(e) {
        if (this._adapter) {
            this._adapter.fireBufferEnd(null, "adStartListener");
            this._adapter.fireSeekEnd(null, "adStartListener");
            if (!this.isInitiated && !this._adapter.flags.isStarted) this._adapter.fireStart();
            if (this._adapter.flags.isPaused) this._adapter.chronos.pause.reset();
        } else {
            this.fireInit();
        }
        if (this._adsAdapter) {
            this._adsAdapter.chronos.viewedMax = [];
        }
        var params = e.data.params || {};
        params.adNumber = this.requestBuilder.getNewAdNumber();
        var allParamsReady = (this.getAdResource() || this.getAdTitle()) && typeof this.getAdDuration() === "number";
        if (allParamsReady) {
            this.adStartSent = true;
            this._adsAdapter.fireManifest();
            this._adsAdapter.fireBreakStart();
            params.adNumberInBreak = this.requestBuilder.getNewAdNumberInBreak();
            this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_START, Constants.Service.AD_START, params);
        } else {
            this.adInitSent = true;
            params.adNumberInBreak = this.requestBuilder.getNewAdNumberInBreak();
            this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_INIT, Constants.Service.AD_INIT, params);
        }
    },
    _adJoinListener: function _adJoinListener(e) {
        var params = {};
        Util.assign(params, e.data.params || {});
        if (this.adInitSent && !this.adStartSent) {
            this._adsAdapter.fireManifest();
            this._adsAdapter.fireBreakStart();
            this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_START, Constants.Service.AD_START, params);
        }
        this._adsAdapter.startChronoView();
        if (this.adConnected) {
            this._adsAdapter.chronos.join.startTime = this.adConnectedTime;
            this._adsAdapter.chronos.total.startTime = this.adConnectedTime;
            this.adConnectedTime = 0;
            this.adConnected = false;
        }
        params = e.data.params || {};
        this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_JOIN, Constants.Service.AD_JOIN, params);
        this.adInitSent = false;
        this.adStartSent = false;
    },
    _adPauseListener: function _adPauseListener(e) {
        var params = e.data.params || {};
        this._adsAdapter.stopChronoView();
        this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_PAUSE, Constants.Service.AD_PAUSE, params);
    },
    _adResumeListener: function _adResumeListener(e) {
        var params = e.data.params || {};
        this._adsAdapter.startChronoView();
        this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_RESUME, Constants.Service.AD_RESUME, params);
    },
    _adBufferBeginListener: function _adBufferBeginListener(e) {
        Log.notice("Ad Buffer Begin");
        this._adsAdapter.stopChronoView();
        if (this._adsAdapter && this._adsAdapter.flags.isPaused) {
            this._adsAdapter.chronos.pause.reset();
        }
    },
    _adBufferEndListener: function _adBufferEndListener(e) {
        var params = e.data.params || {};
        this._adsAdapter.startChronoView();
        this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_BUFFER, Constants.Service.AD_BUFFER, params);
    },
    _adStopListener: function _adStopListener(e) {
        this._adsAdapter.stopChronoView();
        this._adsAdapter.flags.reset();
        this._totalPrerollsTime = (this._totalPrerollsTime || 0) + this._adsAdapter.chronos.total.getDeltaTime();
        var params = e.data.params || {};
        params.position = this.requestBuilder.lastSent.position;
        this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_STOP, Constants.Service.AD_STOP, params);
        // If its a stop for a postroll we check if we can detect if its the last one to call view stop
        if (this.requestBuilder.lastSent.position === Constants.AdPosition.Postroll) {
            var pat = this.options["ad.expectedPattern"];
            this.playedPostrolls++;
            // If we know the amount of postrolls and this was the last one
            if (this.requestBuilder.lastSent.givenAds && this.requestBuilder.lastSent.givenAds <= this.playedPostrolls || // Or if we have expected (and not given!) and this was the last expected one
            !this.requestBuilder.lastSent.givenAds && pat && pat.post && pat.post[0] && pat.post[0] <= this.playedPostrolls) {
                this.fireStop();
            }
        }
        this.adConnected = true;
        this.adConnectedTime = new Date().getTime();
    },
    _adErrorListener: function _adErrorListener(e) {
        var params = e.data.params || {};
        if (this._adapter && !this._adapter.flags.isStarted && !this.isInitiated) {
            this._savedAdError = e;
            return null // Ignore ad errors before content
            ;
        }
        if (this._blockAdError(e.data.params)) return null;
        if (this._adsAdapter) {
            this._adsAdapter.fireManifest();
            this._adsAdapter.fireBreakStart();
        }
        if (!this._adsAdapter || !this._adsAdapter.flags.isStarted) {
            params.adNumber = this.requestBuilder.getNewAdNumber();
            params.adNumberInBreak = this.requestBuilder.getNewAdNumberInBreak();
        }
        if (!this.isBreakStarted) {
            params.breakNumber = this.requestBuilder.getNewBreakNumber();
        }
        this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_ERROR, Constants.Service.AD_ERROR, params);
    },
    _adSavedError: function _adSavedError() {
        if (this._savedAdError) {
            this._adErrorListener(this._savedAdError);
            this._savedAdError = null;
        }
    },
    _adSavedManifest: function _adSavedManifest() {
        if (this._savedAdManifest) {
            this._adManifestListener(this._savedAdManifest);
            this._savedAdManifest = null;
        }
    },
    _blockAdError: function _blockAdError(errorParams) {
        var now = Date.now();
        var sameError = this._lastAdErrorParams && this._lastAdErrorParams.errorCode === errorParams.errorCode && this._lastAdErrorParams.msg === errorParams.msg && this._lastAdErrorParams.adCreativeId === this.getAdCreativeId();
        if (sameError && this._lastAdErrorTime + 5000 > now) {
            this._lastAdErrorTime = now;
            return true;
        }
        this._lastAdErrorTime = now;
        this._lastAdErrorParams = errorParams;
        return false;
    },
    _adClickListener: function _adClickListener(e) {
        var params = e.data.params || {};
        this._adsAdapter.stopChronoView();
        this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_CLICK, Constants.Service.AD_CLICK, params);
    },
    _adManifestListener: function _adManifestListener(e) {
        if (!this.isAdsManifestSent) {
            if (this._adapter && !this._adapter.flags.isStarted && !this.isInitiated) {
                this._savedAdManifest = e;
                return null // Ignore ad manifest before content
                ;
            }
            var params = e.data.params || {};
            this.isAdsManifestSent = true;
            this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_MANIFEST, Constants.Service.AD_MANIFEST, params);
        }
    },
    _adBreakStartListener: function _adBreakStartListener(e) {
        if (!this.isBreakStarted) {
            this.isBreakStarted = true;
            if (this._adapter) this._adapter.firePause();
            var params = e.data.params || {};
            params.breakNumber = this.requestBuilder.getNewBreakNumber();
            this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_POD_START, Constants.Service.AD_POD_START, params);
            this.adConnected = false;
        }
    },
    _adBreakStopListener: function _adBreakStopListener(e) {
        if (this.isBreakStarted) {
            this.isBreakStarted = false;
            var params = e.data.params || {};
            params.position = this.requestBuilder.lastSent.position;
            this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_POD_STOP, Constants.Service.AD_POD_STOP, params);
            this.adConnected = false;
            if (this._adapter) this._adapter.fireResume();
        }
    },
    _adQuartileListener: function _adQuartileListener(e) {
        var params = e.data.params || {};
        if (params.quartile) {
            this._sendAdEventIfAllowed(Constants.WillSendEvent.WILL_SEND_AD_QUARTILE, Constants.Service.AD_QUARTILE, params);
        }
    },
    _sendAdEventIfAllowed: function _sendAdEventIfAllowed(willSend, service, params) {
        if (!this.options["ad.ignore"]) this._send(willSend, service, params);
        Log.notice(service);
    }
};
module.exports = PluginAdsMixin;


/***/ }),

/***/ 11117:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
var Log = __webpack_require__(39610);
var Util = __webpack_require__(37280);
var version = __webpack_require__(29379);
var TransportFormat = __webpack_require__(60124);
var StreamingProtocol = __webpack_require__(48679);
// This file is designed to add extra functionalities to Plugin class
var PluginContentGetterMixin = {
    /**
       * Returns content's playhead
       *
       * @memberof youbora.Plugin.prototype
       */ getPlayhead: function getPlayhead() {
        var ret = this._safeGetterAdapter("getPlayhead");
        return Util.parseNumber(ret, 0);
    },
    /**
       * Returns content's PlayRate
       *
       * @memberof youbora.Plugin.prototype
       */ getPlayrate: function getPlayrate() {
        var ret = 0;
        if (this._adapter && this._adapter.flags && !this._adapter.flags.isPaused) {
            try {
                ret = this._adapter.getPlayrate();
            } catch (err) {
                Log.warn("An error occured while calling getPlayrate", err);
            }
        }
        return ret;
    },
    /**
       * Returns content's FramesPerSecond
       *
       * @memberof youbora.Plugin.prototype
       */ getFramesPerSecond: function getFramesPerSecond() {
        return this._safeGetterAdapter("getFramesPerSecond", "content.fps");
    },
    /**
   * Returns content's segment duration
   *
   * @memberof youbora.Plugin.prototype
   */ getSegmentDuration: function getSegmentDuration() {
        return this.hybridNetwork.getSegmentDuration() || this._safeGetterAdapter("getSegmentDuration", "content.segmentDuration");
    },
    /**
       * Returns content's DroppedFrames
       *
       * @memberof youbora.Plugin.prototype
       */ getDroppedFrames: function getDroppedFrames() {
        var ret = this._safeGetterAdapter("getDroppedFrames");
        if (!ret) {
            ret = this.getWebkitDroppedFrames();
        }
        return Util.parseNumber(ret, 0);
    },
    /**
       * Returns dropped frames as per webkitDroppedFrameCount
       *
       * @returns {number}
       *
       * @memberof youbora.Plugin.prototype
       */ getWebkitDroppedFrames: function getWebkitDroppedFrames() {
        if (this._adapter && this._adapter.tag && this._adapter.tag.webkitDroppedFrameCount) {
            return this._adapter.tag.webkitDroppedFrameCount;
        }
        return null;
    },
    /**
       * Returns content's Duration
       *
       * @memberof youbora.Plugin.prototype
       */ getDuration: function getDuration() {
        var ret = this._safeGetterAdapter("getDuration", "content.duration") || null;
        return Util.parseNumber(Math.round(ret), null);
    },
    /**
       * Returns content's Bitrate
       *
       * @memberof youbora.Plugin.prototype
       */ getBitrate: function getBitrate() {
        var ret = this._safeGetterAdapter("getBitrate", "content.bitrate");
        if (!ret || ret === -1) {
            ret = this.getWebkitBitrate();
        }
        return Util.parseNumber(ret, -1);
    },
    /**
       * Returns content's total bytes downloaded
       *
       * @memberof youbora.Plugin.prototype
       */ getTotalBytes: function getTotalBytes() {
        return this.options["content.sendTotalBytes"] ? this._safeGetterAdapter("getTotalBytes", "content.totalBytes") : null;
    },
    /**
       * Returns bitrate as per webkitVideoDecodedByteCount
       *
       * @param {Object} tag Video tag DOM reference.
       * @returns {number}
       *
       * @memberof youbora.Plugin.prototype
       */ getWebkitBitrate: function getWebkitBitrate() {
        if (this._adapter && this._adapter.tag && this._adapter.tag.webkitVideoDecodedByteCount) {
            var bitrate = this._adapter.tag.webkitVideoDecodedByteCount;
            if (this._lastWebkitBitrate) {
                var delta = this._adapter.tag.webkitVideoDecodedByteCount - this._lastWebkitBitrate;
                bitrate = Math.round(delta / this.viewTransform.response.pingTime * 8);
            }
            this._lastWebkitBitrate = this._adapter.tag.webkitVideoDecodedByteCount;
            return bitrate !== 0 ? bitrate : -1;
        }
    },
    /**
       * Returns content's Throughput
       *
       * @memberof youbora.Plugin.prototype
       */ getThroughput: function getThroughput() {
        var ret = this._safeGetterAdapter("getThroughput", "content.throughput");
        return Util.parseNumber(ret, -1);
    },
    /**
       * Returns content's Rendition
       *
       * @memberof youbora.Plugin.prototype
       */ getRendition: function getRendition() {
        return this._safeGetterAdapter("getRendition", "content.rendition");
    },
    /**
       * Returns content's Title
       *
       * @memberof youbora.Plugin.prototype
       */ getTitle: function getTitle() {
        return this._safeGetterAdapter("getTitle", "content.title");
    },
    /**
       * Returns content's Title2
       *
       * @memberof youbora.Plugin.prototype
       */ getTitle2: function getTitle2() {
        return this._safeGetterAdapter("getTitle2", "content.program");
    },
    /**
       * Returns content's IsLive
       *
       * @memberof youbora.Plugin.prototype
       */ getIsLive: function getIsLive() {
        var ret = this.options["content.isLive"];
        ret = this._convertStringToBoolean(ret);
        if (!ret && ret !== false) {
            ret = this._safeGetterAdapter("getIsLive") || false;
        }
        return ret;
    },
    /**
       * Returns content's Resource after being parsed by the resourceTransform
       *
       * @memberof youbora.Plugin.prototype
       */ getResource: function getResource() {
        return this._safeGetterAdapter("getResource", "content.resource");
    },
    getParsedResource: function getParsedResource() {
        var ret = null;
        if (!this.resourceTransform.isBlocking()) {
            ret = this.resourceTransform.getResource();
        }
        ret = ret || this._safeGetterAdapter("getURLToParse");
        return ret === this.getResource() ? null : ret;
    },
    /**
       * Returns content's TransactionCode
       *
       * @memberof youbora.Plugin.prototype
       */ getTransactionCode: function getTransactionCode() {
        return this.options["content.transactionCode"];
    },
    /**
       * Returns content's Metadata
       *
       * @memberof youbora.Plugin.prototype
       */ getMetadata: function getMetadata() {
        return this.options["content.metadata"];
    },
    /**
       * Returns content's PlayerVersion
       *
       * @memberof youbora.Plugin.prototype
       */ getPlayerVersion: function getPlayerVersion() {
        return this._safeGetterAdapter("getPlayerVersion") || "";
    },
    /**
       * Returns content's PlayerName
       *
       * @memberof youbora.Plugin.prototype
       */ getPlayerName: function getPlayerName() {
        return this._safeGetterAdapter("getPlayerName") || "";
    },
    /**
       * Returns content's Cdn
       *
       * @memberof youbora.Plugin.prototype
       */ getCdn: function getCdn() {
        var ret = null;
        if (!this.resourceTransform.isBlocking()) {
            ret = this.resourceTransform.getCdnName();
        }
        return ret || this.options["content.cdn"];
    },
    /**
       * Returns content's PluginVersion
       *
       * @memberof youbora.Plugin.prototype
       */ getPluginVersion: function getPluginVersion() {
        var ret = this.getAdapterVersion();
        if (!ret) ret = version + "-adapterless-js";
        return ret;
    },
    /**
       * Returns content's PluginVersion
       *
       * @memberof youbora.Plugin.prototype
       */ getLibVersion: function getLibVersion() {
        return version;
    },
    /**
       * Returns ads adapter getVersion or null
       *
       * @memberof youbora.Plugin.prototype
       */ getAdapterVersion: function getAdapterVersion() {
        return this._safeGetterAdapter("getVersion");
    },
    /**
       * Returns cdn traffic received in bytes or null
       *
       * @memberof youbora.Plugin.prototype
       */ getCdnTraffic: function getCdnTraffic() {
        return this._safeGetterAdapter("getCdnTraffic") || this.hybridNetwork.getCdnTraffic();
    },
    /**
   * Returns multi cdn traffic received in bytes or null
   *
   * @memberof youbora.Plugin.prototype
   */ getMultiCdnInfo: function getMultiCdnInfo() {
        return this.hybridNetwork.getMultiCdnInfo();
    },
    /**
   * Returns cdn balancer response id
   *
   * @memberof youbora.Plugin.prototype
   */ getBalancerResponseId: function getBalancerResponseId() {
        var ret = this.hybridNetwork.getBalancerResponseId();
        if (!ret && this.options["cdnbalancer.uuid"]) {
            return this.options["cdnbalancer.uuid"];
        }
        return ret;
    },
    /**
       * Returns p2p traffic received in bytes or null
       *
       * @memberof youbora.Plugin.prototype
       */ getP2PTraffic: function getP2PTraffic() {
        return this._safeGetterAdapter("getP2PTraffic") || this.hybridNetwork.getP2PTraffic();
    },
    /**
       * Returns p2p traffic sent in bytes or null
       *
       * @memberof youbora.Plugin.prototype
       */ getUploadTraffic: function getUploadTraffic() {
        return this._safeGetterAdapter("getUploadTraffic") || this.hybridNetwork.getUploadTraffic();
    },
    /**
       * Returns if p2p plugin is enabled or null
       *
       * @memberof youbora.Plugin.prototype
       */ getIsP2PEnabled: function getIsP2PEnabled() {
        return this._safeGetterAdapter("getIsP2PEnabled") || this.hybridNetwork.getIsP2PEnabled();
    },
    /** Returns streaming protocol (DASH, HLS, HDS...) */ getStreamingProtocol: function getStreamingProtocol() {
        var ret = this.options["content.streamingProtocol"];
        // if ret is not in the list of possible options, ret = null
        if (ret) {
            for(var i in StreamingProtocol){
                if (StreamingProtocol[i] === ret) {
                    return ret;
                }
            }
        }
        return null;
    },
    /** Returns transport format (TS, MP4) */ getTransportFormat: function getTransportFormat() {
        var ret = this.options["content.transportFormat"];
        if (!ret && this.options["parse.manifest"] && !this.resourceTransform.isBlocking()) {
            ret = this.resourceTransform.getTransportFormat();
        }
        // if ret is not in the list of possible options, ret = null
        if (ret) {
            for(var i in TransportFormat){
                if (TransportFormat[i] === ret) {
                    return ret;
                }
            }
        }
        return null;
    },
    /** Returns household id */ getHouseholdId: function getHouseholdId() {
        return this._safeGetterAdapter("getHouseholdId");
    },
    /**
       * Returns latency of a live video, or null
       *
       * @memberof youbora.Plugin.prototype
       */ getLatency: function getLatency() {
        return this.getIsLive() ? this._safeGetterAdapter("getLatency") : null;
    },
    /**
       * Returns the amount of packets lost, or null
       *
       * @memberof youbora.Plugin.prototype
       */ getPacketLoss: function getPacketLoss() {
        return this._safeGetterAdapter("getPacketLoss");
    },
    /**
       * Returns the amount of packets sent, or null
       *
       * @memberof youbora.Plugin.prototype
       */ getPacketSent: function getPacketSent() {
        return this._safeGetterAdapter("getPacketSent");
    },
    /**
       * Returns a json with the metrics to be reported in pings when changed
       *
       * @memberof youbora.Plugin.prototype
       */ getVideoMetrics: function getVideoMetrics() {
        return Util.getMetricsFrom(this._adapter ? this._adapter.getMetrics() : null, this.options["content.metrics"]);
    },
    getPlayerStartupTime: function getPlayerStartupTime() {
        return this.browserLoadTimes.getPlayerStartupTime();
    },
    // ----------------------------------------- CHRONOS ------------------------------------------
    /**
       * Returns JoinDuration chrono delta time
       *
       * @memberof youbora.Plugin.prototype
       */ getJoinDuration: function getJoinDuration() {
        return this._adapter ? this._adapter.chronos.join.getDeltaTime(false) : -1;
    },
    /**
       * Returns BufferDuration chrono delta time
       *
       * @memberof youbora.Plugin.prototype
       */ getBufferDuration: function getBufferDuration() {
        return this._adapter ? this._adapter.chronos.buffer.getDeltaTime(false) : -1;
    },
    /**
       * Returns SeekDuration chrono delta time
       *
       * @memberof youbora.Plugin.prototype
       */ getSeekDuration: function getSeekDuration() {
        return this._adapter ? this._adapter.chronos.seek.getDeltaTime(false) : -1;
    },
    /**
       * Returns pauseDuration chrono delta time
       *
       * @memberof youbora.Plugin.prototype
       */ getPauseDuration: function getPauseDuration() {
        return this._adapter ? this._adapter.chronos.pause.getDeltaTime(false) : 0;
    },
    /**
       * Returns content's package
       *
       * @memberof youbora.Plugin.prototype
       */ getPackage: function getPackage() {
        return this.options["content.package"];
    },
    /**
       * Returns content's saga
       *
       * @memberof youbora.Plugin.prototype
       */ getSaga: function getSaga() {
        return this.options["content.saga"];
    },
    /**
       * Returns content's tv show
       *
       * @memberof youbora.Plugin.prototype
       */ getTvShow: function getTvShow() {
        return this.options["content.tvShow"];
    },
    /**
       * Returns content's season
       *
       * @memberof youbora.Plugin.prototype
       */ getSeason: function getSeason() {
        return this.options["content.season"];
    },
    /**
       * Returns content's episode title
       *
       * @memberof youbora.Plugin.prototype
       */ getEpisodeTitle: function getEpisodeTitle() {
        return this.options["content.episodeTitle"];
    },
    /**
       * Returns content's channel
       *
       * @memberof youbora.Plugin.prototype
       */ getChannel: function getChannel() {
        return this.options["content.channel"];
    },
    /**
       * Returns content's id
       *
       * @memberof youbora.Plugin.prototype
       */ getID: function getID() {
        return this.options["content.id"];
    },
    /**
       * Returns content's IMDB id
       *
       * @memberof youbora.Plugin.prototype
       */ getImdbId: function getImdbId() {
        return this.options["content.imdbId"];
    },
    /**
       * Returns content's gracenote id
       *
       * @memberof youbora.Plugin.prototype
       */ getGracenoteID: function getGracenoteID() {
        return this.options["content.gracenoteId"];
    },
    /**
       * Returns content's type
       *
       * @memberof youbora.Plugin.prototype
       */ getType: function getType() {
        return this.options["content.type"];
    },
    /**
       * Returns content's genre
       *
       * @memberof youbora.Plugin.prototype
       */ getGenre: function getGenre() {
        return this.options["content.genre"];
    },
    /**
       * Returns content's language
       *
       * @memberof youbora.Plugin.prototype
       */ getVideoLanguage: function getVideoLanguage() {
        return this.options["content.language"];
    },
    /**
       * Returns content's subtitles
       *
       * @memberof youbora.Plugin.prototype
       */ getSubtitles: function getSubtitles() {
        return this.options["content.subtitles"];
    },
    /**
       * Returns content's contracted resolution
       *
       * @memberof youbora.Plugin.prototype
       */ getContractedResolution: function getContractedResolution() {
        return this.options["content.contractedResolution"];
    },
    /**
       * Returns content's cost
       *
       * @memberof youbora.Plugin.prototype
       */ getCost: function getCost() {
        return this.options["content.cost"];
    },
    /**
       * Returns content's price
       *
       * @memberof youbora.Plugin.prototype
       */ getPrice: function getPrice() {
        return this.options["content.price"];
    },
    /**
       * Returns content's playback type
       *
       * @memberof youbora.Plugin.prototype
       */ getPlaybackType: function getPlaybackType() {
        var ret = this.options["content.playbackType"];
        if (!ret) {
            var isLive = this.options["content.isLive"];
            if (typeof isLive !== "boolean") {
                isLive = this._safeGetterAdapter("getIsLive");
            }
            if (typeof isLive === "boolean") {
                ret = isLive ? "Live" : "VoD";
            }
        }
        return ret;
    },
    /**
       * Returns content's DRM
       *
       * @memberof youbora.Plugin.prototype
       */ getDRM: function getDRM() {
        return this.options["content.drm"];
    },
    /**
       * Returns content's video codec
       *
       * @memberof youbora.Plugin.prototype
       */ getVideoCodec: function getVideoCodec() {
        return this._safeGetterAdapter("getVideoCodec", "content.encoding.videoCodec");
    },
    /**
       * Returns content's audio codec
       *
       * @memberof youbora.Plugin.prototype
       */ getAudioCodec: function getAudioCodec() {
        return this._safeGetterAdapter("getAudioCodec", "content.encoding.audioCodec");
    },
    /**
       * Returns content's codec settings
       *
       * @memberof youbora.Plugin.prototype
       */ getCodecSettings: function getCodecSettings() {
        return this.options["content.encoding.codecSettings"];
    },
    /**
       * Returns content's codec profile
       *
       * @memberof youbora.Plugin.prototype
       */ getCodecProfile: function getCodecProfile() {
        return this.options["content.encoding.codecProfile"];
    },
    /**
       * Returns content's container format
       *
       * @memberof youbora.Plugin.prototype
       */ getContainerFormat: function getContainerFormat() {
        return this.options["content.encoding.containerFormat"];
    },
    /**
     * Returns linked view id string
     *
     * @memberof youbora.Plugin.prototype
     */ getLinkedViewId: function getLinkedViewId() {
        return this.options.linkedViewId;
    },
    _safeGetterAdapter: function _safeGetterAdapter(functionName, optionName) {
        var ret = null;
        if (optionName && this.options[optionName]) {
            ret = this.options[optionName];
        } else {
            try {
                if (this._adapter && typeof this._adapter[functionName] === "function") {
                    ret = this._adapter[functionName]();
                }
            } catch (err) {
                Log.warn("An error occured while calling " + functionName, err);
            }
        }
        return ret;
    },
    _convertStringToBoolean: function _convertStringToBoolean(value) {
        if (value === "true") {
            return true;
        }
        if (value === "false" || typeof value === "string") {
            return false;
        }
        return value;
    }
};
module.exports = PluginContentGetterMixin;


/***/ }),

/***/ 22145:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var Log = __webpack_require__(39610);
var Constants = __webpack_require__(56230);
var Util = __webpack_require__(37280);
var Adapter = __webpack_require__(28077);
// This file is designed to add extra functionalities to Plugin class
/** @lends youbora.Plugin.prototype */ var PluginContentMixin = {
    /**
   * Sets an adapter for video content.
   *
   * @param {Adapter} adapter
   *
   * @memberof youbora.Plugin.prototype
   */ setAdapter: function setAdapter(adapter) {
        if (this.browserLoadTimes) this.browserLoadTimes.setPlayerSetupTime();
        if (adapter.plugin) {
            Log.warn("Adapters can only be added to a single plugin");
        } else {
            this.removeAdapter();
            this._adapter = adapter;
            adapter.plugin = this;
            adapter.setIsAds(false);
            // Register listeners
            this.contentAdapterListeners = {};
            this.contentAdapterListeners[Adapter.Event.START] = this._startListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.JOIN] = this._joinListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.PAUSE] = this._pauseListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.RESUME] = this._resumeListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.SEEK_BEGIN] = this._seekBufferBeginListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.SEEK_END] = this._seekEndListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.BUFFER_BEGIN] = this._seekBufferBeginListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.BUFFER_END] = this._bufferEndListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.ERROR] = this._errorListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.STOP] = this._stopListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.VIDEO_EVENT] = this._videoEventListener.bind(this);
            this.contentAdapterListeners[Adapter.Event.VIDEO_EVENT_END] = this._videoEventEndListener.bind(this);
            for(var key in this.contentAdapterListeners){
                this._adapter.on(key, this.contentAdapterListeners[key]);
            }
            // We have to trigger an ('adapterSet') event in here so that ProductAnalytics can listen to it and call the appropriate methods
            if (this.productAnalytics) {
                this.productAnalytics.adapterAfterSet();
            }
        }
    },
    /**
   * Returns current adapter or null.
   *
   * @returns {Adapter}
   *
   * @memberof youbora.Plugin.prototype
   */ getAdapter: function getAdapter() {
        return this._adapter;
    },
    /**
   * Removes the current adapter. Fires stop if needed. Calls adapter.dispose().
   *
   * @memberof youbora.Plugin.prototype
   * */ removeAdapter: function removeAdapter() {
        if (this._adapter) {
            // We have to trigger an ('adapterBeforeRemove') event in here so that ProductAnalytics can listen to it and call the appropriate methods
            if (this.productAnalytics) {
                this.productAnalytics.adapterBeforeRemove();
            }
            this._adapter.dispose();
            this._adapter.plugin = null;
            if (this.contentAdapterListeners) {
                for(var key in this.contentAdapterListeners){
                    this._adapter.off(key, this.contentAdapterListeners[key]);
                }
                delete this.contentAdapterListeners;
            }
            this._adapter = null;
        }
    },
    // ---------------------------------------- LISTENERS -----------------------------------------
    _startListener: function _startListener(e) {
        if (!this.isInitiated) {
            this.viewTransform.nextView();
            if (this.options && this.options["session.splitViews"]) {
                e.data.params.viewIndex = this.viewTransform._viewIndex;
            }
            this._initComm();
            this._startPings();
        } else if (this.initChrono.startTime !== 0) {
            this._adapter.chronos.join.startTime = this.initChrono.startTime;
        }
        try {
            // If exists resourceTransform, init with the resource
            if (this._adapter && this.resourceTransform) {
                var resource = this._getResourceForTransform();
                this.resourceTransform.init(resource);
            }
        } catch (e) {}
        var params = e.data.params || {};
        var allParamsReady = this.getResource() && typeof this.getIsLive() === "boolean" && (this.getIsLive() || typeof this.getDuration() === "number" && this.getDuration() > 0) && this.getTitle();
        allParamsReady = this.options.forceInit ? false : allParamsReady && this._isExtraMetadataReady();
        if (allParamsReady && !this.isInitiated) {
            this._send(Constants.WillSendEvent.WILL_SEND_START, Constants.Service.START, params);
            this._adSavedError();
            this._adSavedManifest();
            Log.notice(Constants.Service.START + " " + (params.title || params.mediaResource));
            this.isStarted = true;
        // chrono if had no adapter when inited
        } else if (!this.isInitiated) {
            this.isInitiated = true;
            this._adapter.chronos.join.start();
            this._send(Constants.WillSendEvent.WILL_SEND_INIT, Constants.Service.INIT, params);
            this._adSavedError();
            this._adSavedManifest();
            Log.notice(Constants.Service.INIT + " " + (params.title || params.mediaResource));
        }
    },
    _retryStart: function _retryStart(e) {
        if (this._isExtraMetadataReady()) {
            this._send(Constants.WillSendEvent.WILL_SEND_START, Constants.Service.START, {});
            this.startDelayed = false;
        }
    },
    _joinListener: function _joinListener(e) {
        var params = {};
        Util.assign(params, e.data.params || {});
        if (!this._adsAdapter || !this._adsAdapter.flags.isStarted) {
            if (this._adapter) {
                this._adapter.chronos.join.startTime = Math.min(this._adapter.chronos.join.startTime + (this._totalPrerollsTime || 0), new Date().getTime());
                this._totalPrerollsTime = 0;
            }
            if (this.isInitiated && !this.isStarted) {
                if (this._isExtraMetadataReady()) {
                    this._send(Constants.WillSendEvent.WILL_SEND_START, Constants.Service.START, params);
                } else {
                    this.startDelayed = true;
                }
                this._adSavedError();
                this._adSavedManifest();
                Log.notice(Constants.Service.START + " " + (params.title || params.mediaResource));
                this.isStarted = true;
            }
            params = e.data.params || {};
            if (this._adsAdapter && this.isBreakStarted) {
                this._adsAdapter.fireBreakStop();
            }
            this._send(Constants.WillSendEvent.WILL_SEND_JOIN, Constants.Service.JOIN, params);
            Log.notice(Constants.Service.JOIN + " " + params.joinDuration + "ms");
        } else {
            if (this._adapter.monitor) this._adapter.monitor.stop();
            this._adapter.flags.isJoined = false;
            this._adapter.chronos.join.stopTime = 0;
        }
    },
    _pauseListener: function _pauseListener(e) {
        if (this._adapter) {
            if (this._adapter.flags.isBuffering || this._adapter.flags.isSeeking || this._adsAdapter && this._adsAdapter.flags.isStarted) {
                this._adapter.chronos.pause.reset();
            }
        }
        var params = e.data.params || {};
        this._send(Constants.WillSendEvent.WILL_SEND_PAUSE, Constants.Service.PAUSE, params);
        Log.notice(Constants.Service.PAUSE + " at " + params.playhead + "s");
    },
    _resumeListener: function _resumeListener(e) {
        if (this._adsAdapter && this.isBreakStarted && !this._adsAdapter.flags.isStarted) {
            this._adsAdapter.fireBreakStop();
        }
        var params = e.data.params || {};
        this._send(Constants.WillSendEvent.WILL_SEND_RESUME, Constants.Service.RESUME, params);
        Log.notice(Constants.Service.RESUME + " " + params.pauseDuration + "ms");
        this._adapter.chronos.pause.reset();
    },
    _seekBufferBeginListener: function _seekBufferBeginListener(e) {
        if (this._adapter && this._adapter.flags.isPaused) this._adapter.chronos.pause.reset();
        if (e.type && e.type.includes("buffer")) {
            Log.notice(e.type + ", eventsTriggered: " + this._adapter.fireEventsStruct.buffer);
        } else {
            Log.notice(e.type + ", eventsTriggered: " + this._adapter.fireEventsStruct.seek);
        }
    },
    _seekEndListener: function _seekEndListener(e) {
        var params = e.data.params || {};
        this._send(Constants.WillSendEvent.WILL_SEND_SEEK, Constants.Service.SEEK, params);
        Log.notice(Constants.Service.SEEK + " to " + params.playhead + " in " + params.seekDuration + "ms" + (params.triggeredEvents ? ", eventsTriggered: " + params.triggeredEvents : ""));
    },
    _bufferEndListener: function _bufferEndListener(e) {
        var params = e.data.params || {};
        this._send(Constants.WillSendEvent.WILL_SEND_BUFFER, Constants.Service.BUFFER, params);
        Log.notice(Constants.Service.BUFFER + " to " + params.playhead + " in " + params.bufferDuration + "ms" + (params.triggeredEvents ? ", eventsTriggered: " + params.triggeredEvents : ""));
    },
    _errorListener: function _errorListener(e) {
        if (!this._blockError(e.data.params)) {
            this.fireError(e.data.params || {});
            this._adSavedError();
            this._adSavedManifest();
        }
    },
    _blockError: function _blockError(errorParams) {
        var now = Date.now();
        var sameError = this._lastErrorParams ? this._lastErrorParams.errorCode === errorParams.errorCode && this._lastErrorParams.msg === errorParams.msg : false;
        if (sameError && this._lastErrorTime + 5000 > now) {
            this._lastErrorTime = now;
            return true;
        }
        this._lastErrorTime = now;
        this._lastErrorParams = errorParams;
        return false;
    },
    _stopListener: function _stopListener(e) {
        this.fireStop(e.data.params || {});
    },
    _isStopReady: function _isStopReady(e) {
        var ret = false;
        // this solution is only for the case of:
        if (!this.requestBuilder.lastSent.live && // VOD, live have no postrolls
        this._adsAdapter && // having ads adapter connected
        this._adapter && // playhead close to the end of the content (or 0 because is already restarted)
        (!this._adapter.getPlayhead() || this._adapter.getPlayhead() >= this.requestBuilder.lastSent.mediaDuration - 1)) {
            var expectedPostrolls = 0;
            var pat = this.options["ad.expectedPattern"];
            // We can get the expectedPostrolls from the expected pattern if it has postrolls defined
            if (pat && pat.post && pat.post[0]) {
                expectedPostrolls = pat.post[0];
            // If not, while playing postrolls after adbreakstart we can get the givenAds
            } else if (this.requestBuilder.lastSent.breaksTime) {
                if (this.requestBuilder.lastSent.position === Constants.AdPosition.Postroll) {
                    expectedPostrolls = this.requestBuilder.lastSent.givenAds;
                }
                // Or before playing postrolls, at least, we can check using breaksTime (from adManifest event) if we expect at least 1 postroll
                if (!expectedPostrolls && this.requestBuilder.lastSent.breaksTime) {
                    var breaks = this.requestBuilder.lastSent.breaksTime;
                    if (breaks.length > 0 && this.requestBuilder.lastSent.mediaDuration) {
                        var lastTimePosition = Math.round(breaks[breaks.length - 1]);
                        if (lastTimePosition + 1 >= this.requestBuilder.lastSent.mediaDuration) {
                            expectedPostrolls = 1;
                        }
                    }
                }
            // If none of the previous solutions found anything, we assume we have no postrolls
            } else {
                ret = true;
            }
            // Finally, if the number of played postrolls is the same (or more) than the expected, we can close the view
            if (expectedPostrolls <= this.playedPostrolls) {
                ret = true;
            }
        } else {
            ret = true;
        }
        return ret;
    },
    _videoEventListener: function _videoEventListener(e) {
        this._send(Constants.WillSendEvent.WILL_SEND_VIDEO_EVENT, Constants.Service.VIDEO_EVENT, e.data.params);
    },
    _videoEventEndListener: function _videoEventEndListener(e) {
        this._send(Constants.WillSendEvent.WILL_SEND_VIDEO_EVENT_END, Constants.Service.VIDEO_EVENT_END, e.data.params);
    },
    _isExtraMetadataReady: function _isExtraMetadataReady(e) {
        // If the option is disabled, always is ready
        if (!this.options.waitForMetadata || this.options.pendingMetadata.length < 1) return true;
        // If for existing parameters, one of them is false (no value for it), return false
        var getters = this.requestBuilder.getGetters();
        return this.options.pendingMetadata.map((function(element) {
            if (getters.hasOwnProperty(element)) {
                return !!this[getters[element]]();
            }
        }).bind(this)).indexOf(false) < 0;
    }
};
module.exports = PluginContentMixin;


/***/ }),

/***/ 99305:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var Log = __webpack_require__(39610);
var Util = __webpack_require__(37280);
var Constants = __webpack_require__(56230);
var Transform = __webpack_require__(51293);
// This file is designed to add extra functionalities to Plugin class
/** @lends youbora.Plugin.prototype */ var PluginFireMixin = {
    /**
   * Sends /init. Should be called once the user has requested the content. Does not need
   * a working adapter or player to work. it won't sent start if isInitiated is true.
   *
   * @param {Object} [params] Object of key:value params.
   * @param {string} [triggeredEvent]
   *
   * @memberof youbora.Plugin.prototype
   */ fireInit: function fireInit(params, triggeredEvent) {
        if (!this.isInitiated) {
            if (!this.getAdapter() || this.getAdapter() && !this.getAdapter().flags.isStarted) {
                this.viewTransform.nextView();
                this._initComm();
                this._startPings();
                this.initChrono.start();
                this.isInitiated = true;
                params = params || {};
                if (triggeredEvent) {
                    params.triggeredEvents = [
                        triggeredEvent
                    ];
                }
                if (this.options && this.options["session.splitViews"]) {
                    params.viewIndex = this.plugin.viewTransform._viewIndex;
                }
                this._send(Constants.WillSendEvent.WILL_SEND_INIT, Constants.Service.INIT, params);
                this._adSavedError();
                this._adSavedManifest();
                Log.notice(Constants.Service.INIT + " " + (params.title || params.mediaResource));
            }
        }
    },
    /**
   * Sends /error. Should be used when the error is related to out-of-player errors: like async
   * resource load or player loading errors.
   *
   * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
   * @param {String} [msg] Error Message
   * @param {Object} [metadata] Object defining error metadata
   * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
   *
   * @memberof youbora.Plugin.prototype
   */ fireError: function fireError(object, msg, metadata, level) {
        this.fireInit();
        var params = Util.buildErrorParams(object, msg, metadata, level);
        if (params.code) {
            delete params.code;
        }
        this._send(Constants.WillSendEvent.WILL_SEND_ERROR, Constants.Service.ERROR, params);
        this._adSavedError();
        this._adSavedManifest();
        Log.notice(Constants.Service.ERROR + " " + params.errorLevel + " " + params.errorCode);
        if (params.errorLevel === "fatal") {
            this.fireStop();
        }
    },
    /**
   * Calls fireErrors and then stops pings.
   *
   * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
   * @param {String} [msg] Error Message
   * @param {Object} [metadata] Object defining error metadata
   *
   * @memberof youbora.Plugin.prototype
   */ fireFatalError: function fireFatalError(object, msg, metadata, level) {
        this.fireError(object, msg, metadata, level);
        this.fireStop();
    },
    /**
   * Fires /stop. Should be used to terminate sessions once the player is gone or if
   * plugin.fireError() is called.
   *
   * @param {Object} [params] Object of key:value params.
   *
   * @memberof youbora.Plugin.prototype
   */ fireStop: function fireStop(params) {
        if (this.isInitiated || this.isStarted) {
            if (this._adapter) {
                this._adapter.flags.isStopped = true;
                if (this._adapter.monitor) this._adapter.monitor.stop();
            }
            if (this._adsAdapter && this.isBreakStarted) {
                this._adsAdapter.fireStop();
                this._adsAdapter.fireBreakStop();
            }
            params = params || {};
            this._send(Constants.WillSendEvent.WILL_SEND_STOP, Constants.Service.STOP, params);
            var chronos = this._adapter ? this._adapter.chronos : null;
            if (chronos) {
                chronos.total.stop();
                chronos.join.reset();
                chronos.pause.reset();
                chronos.buffer.reset();
                chronos.seek.reset();
            }
            Log.notice(Constants.Service.STOP + " at " + params.playhead + "s");
            this._reset();
        }
    },
    /**
   * Fires /offlineEvents. If offline is disabled, will try to send all the views stored.
   *
   * @param {Object} [params] Object of key:value params.
   *
   * @memberof youbora.Plugin.prototype
   */ fireOfflineEvents: function fireOfflineEvents(params) {
        if (this.options && !this.options.offline) {
            if (!this.isInitiated && (!this._adapter || !this._adapter.flags.isStarted) && (!this._adsAdapter || !this._adsAdapter.flags.isStarted)) {
                this._offlineParams = params;
                if (this.viewTransform.response.code && this.viewTransform.response.host) {
                    this._generateAndSendOffline();
                } else {
                    this.offlineReference = this._generateAndSendOffline.bind(this);
                    this.viewTransform.on(Transform.Event.DONE, this.offlineReference);
                }
            } else {
                Log.error("Adapters have to be stopped");
            }
        } else {
            Log.error("To send offline events, offline option must be disabled");
        }
    },
    _generateAndSendOffline: function _generateAndSendOffline() {
        if (this.options.disableStorage) return null;
        var params = this._offlineParams;
        this._initComm();
        while(true){
            var bodyAndId = this.requestBuilder.buildBody(Constants.Service.OFFLINE_EVENTS).viewJson;
            if (bodyAndId[0] === null) break;
            var newViewCode = this.viewTransform.nextView();
            var body = bodyAndId[0].replace(/CODE_PLACEHOLDER/g, newViewCode.toString()).replace(/,"sessionId":"SESSION_PLACEHOLDER"/g, "") // this.viewTransform.getSession()
            .replace(/,"sessionRoot":"ROOT_PLACEHOLDER"/g, "") // this.viewTransform.getSession()
            ;
            // modify to support offline+infinity
            this._send(Constants.WillSendEvent.WILL_SEND_OFFLINE_EVENTS, Constants.Service.OFFLINE_EVENTS, params, body, "POST", (function(a, callbackParams) {
                this.offlineStorage.removeView(callbackParams.offlineId);
            }).bind(this), {
                offlineId: bodyAndId[1]
            });
        }
        this.offlineStorage.sent();
        this._offlineParams = null;
    }
};
module.exports = PluginFireMixin;


/***/ }),

/***/ 38738:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
var Util = __webpack_require__(37280);
var version = __webpack_require__(29379);
var RequestMethod = __webpack_require__(84586);
// This file is designed to add extra functionalities to Plugin class
var PluginGetterMixin = {
    /**
     * Returns service host
     *
     * @memberof youbora.Plugin.prototype
     */ getHost: function getHost() {
        var host = this.options.host;
        if (this.viewTransform && this.viewTransform.response && this.viewTransform.response.host) {
            host = this.viewTransform.response.host;
        }
        return Util.addProtocol(Util.stripProtocol(host), this.options["app.https"]);
    },
    getUserType: function getUserType() {
        return this.options["user.type"];
    },
    /**
     * Returns parse Manifest Flag
     *
     * @memberof youbora.Plugin.prototype
     */ isParseManifest: function isParseManifest() {
        return this.options["parse.manifest"];
    },
    /**
     * Returns parse locationHeader get request Flag
     *
     * @memberof youbora.Plugin.prototype
     */ isParseLocationHeaderGetRequest: function isParseLocationHeaderGetRequest() {
        return this.options["parse.locationHeader.get"];
    },
    /**
   * Returns parse cdnParser get request Flag
   *
   * @memberof youbora.Plugin.prototype
   */ isCDNParserHeaderGetRequest: function isCDNParserHeaderGetRequest() {
        return this.options["parse.cdnParser.get"];
    },
    /**
     * Returns parse CdnNode Flag
     *
     * @memberof youbora.Plugin.prototype
     */ isParseCdnNode: function isParseCdnNode() {
        return this.options["parse.cdnNode"];
    },
    /**
     * Returns parse cdn switch Flag
     *
     * @memberof youbora.Plugin.prototype
     */ isCdnSwitch: function isCdnSwitch() {
        return this.options["parse.cdnSwitchHeader"];
    },
    /**
     * Returns Cdn list
     *
     * @memberof youbora.Plugin.prototype
     */ getParseCdnNodeList: function getParseCdnNodeList() {
        return this.options["parse.cdnNode.list"];
    },
    /**
     * Returns Cdn header name
     *
     * @memberof youbora.Plugin.prototype
     */ getParseCdnNodeNameHeader: function getParseCdnNodeNameHeader() {
        return this.options["parse.cdnNameHeader"];
    },
    /**
   * Returns header node name
   *
   * @memberof youbora.Plugin.prototype
   */ getParseNodeHeader: function getParseNodeHeader() {
        return this.options["parse.cdnNodeHeader"];
    },
    /**
     * Returns obfuscateIp option
     *
     * @memberof youbora.Plugin.prototype
     */ getObfuscateIp: function getObfuscateIp() {
        return this.options["user.obfuscateIp"];
    },
    /**
   * Returns privacy protocol option
   *
   * @memberof youbora.Plugin.prototype
   */ getPrivacyProtocol: function getPrivacyProtocol() {
        var ret = this.options["user.privacyProtocol"];
        if (typeof ret === "string") {
            ret = ret.toLowerCase();
        }
        return ret === "optin" || ret === "optout" ? ret : null;
    },
    /**
   * Returns content's custom dimensions
   *
   * @memberof youbora.Plugin.prototype
   */ getCustomDimensions: function getCustomDimensions() {
        var dim = this.options["content.customDimensions"];
        return typeof dim === "object" ? dim : null;
    },
    /**
     * Returns content's Extraparam1
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam1: function getExtraparam1() {
        return this.options["content.customDimension.1"];
    },
    /**
     * Returns content's Extraparam2
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam2: function getExtraparam2() {
        return this.options["content.customDimension.2"];
    },
    /**
     * Returns content's Extraparam3
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam3: function getExtraparam3() {
        return this.options["content.customDimension.3"];
    },
    /**
     * Returns content's Extraparam4
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam4: function getExtraparam4() {
        return this.options["content.customDimension.4"];
    },
    /**
     * Returns content's Extraparam5
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam5: function getExtraparam5() {
        return this.options["content.customDimension.5"];
    },
    /**
     * Returns content's Extraparam6
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam6: function getExtraparam6() {
        return this.options["content.customDimension.6"];
    },
    /**
     * Returns content's Extraparam7
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam7: function getExtraparam7() {
        return this.options["content.customDimension.7"];
    },
    /**
     * Returns content's Extraparam8
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam8: function getExtraparam8() {
        return this.options["content.customDimension.8"];
    },
    /**
     * Returns content's Extraparam9
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam9: function getExtraparam9() {
        return this.options["content.customDimension.9"];
    },
    /**
     * Returns content's Extraparam10
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam10: function getExtraparam10() {
        return this.options["content.customDimension.10"];
    },
    /**
     * Returns content's Extraparam11
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam11: function getExtraparam11() {
        return this.options["content.customDimension.11"];
    },
    /**
     * Returns content's Extraparam12
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam12: function getExtraparam12() {
        return this.options["content.customDimension.12"];
    },
    /**
     * Returns content's Extraparam13
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam13: function getExtraparam13() {
        return this.options["content.customDimension.13"];
    },
    /**
     * Returns content's Extraparam14
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam14: function getExtraparam14() {
        return this.options["content.customDimension.14"];
    },
    /**
     * Returns content's Extraparam15
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam15: function getExtraparam15() {
        return this.options["content.customDimension.15"];
    },
    /**
     * Returns content's Extraparam16
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam16: function getExtraparam16() {
        return this.options["content.customDimension.16"];
    },
    /**
     * Returns content's Extraparam17
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam17: function getExtraparam17() {
        return this.options["content.customDimension.17"];
    },
    /**
     * Returns content's Extraparam18
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam18: function getExtraparam18() {
        return this.options["content.customDimension.18"];
    },
    /**
     * Returns content's Extraparam19
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam19: function getExtraparam19() {
        return this.options["content.customDimension.19"];
    },
    /**
     * Returns content's Extraparam20
     *
     * @memberof youbora.Plugin.prototype
     */ getExtraparam20: function getExtraparam20() {
        return this.options["content.customDimension.20"];
    },
    /**
     * Returns ad's Extraparam1
     *
     * @memberof youbora.Plugin.prototype
     */ getAdExtraparam1: function getAdExtraparam1() {
        return this.options["ad.customDimension.1"];
    },
    /**
     * Returns ad's Extraparam2
     *
     * @memberof youbora.Plugin.prototype
     */ getAdExtraparam2: function getAdExtraparam2() {
        return this.options["ad.customDimension.2"];
    },
    /**
     * Returns ad's Extraparam3
     *
     * @memberof youbora.Plugin.prototype
     */ getAdExtraparam3: function getAdExtraparam3() {
        return this.options["ad.customDimension.3"];
    },
    /**
     * Returns ad's Extraparam4
     *
     * @memberof youbora.Plugin.prototype
     */ getAdExtraparam4: function getAdExtraparam4() {
        return this.options["ad.customDimension.4"];
    },
    /**
     * Returns ad's Extraparam5
     *
     * @memberof youbora.Plugin.prototype
     */ getAdExtraparam5: function getAdExtraparam5() {
        return this.options["ad.customDimension.5"];
    },
    /**
     * Returns ad's Extraparam6
     *
     * @memberof youbora.Plugin.prototype
     */ getAdExtraparam6: function getAdExtraparam6() {
        return this.options["ad.customDimension.6"];
    },
    /**
     * Returns ad's Extraparam7
     *
     * @memberof youbora.Plugin.prototype
     */ getAdExtraparam7: function getAdExtraparam7() {
        return this.options["ad.customDimension.7"];
    },
    /**
     * Returns ad's Extraparam8
     *
     * @memberof youbora.Plugin.prototype
     */ getAdExtraparam8: function getAdExtraparam8() {
        return this.options["ad.customDimension.8"];
    },
    /**
     * Returns ad's Extraparam9
     *
     * @memberof youbora.Plugin.prototype
     */ getAdExtraparam9: function getAdExtraparam9() {
        return this.options["ad.customDimension.9"];
    },
    /**
     * Returns ad's Extraparam10
     *
     * @memberof youbora.Plugin.prototype
     */ getAdExtraparam10: function getAdExtraparam10() {
        return this.options["ad.customDimension.10"];
    },
    /**
     * Returns PluginInfo
     *
     * @memberof youbora.Plugin.prototype
     */ getPluginInfo: function getPluginInfo() {
        var ret = {
            lib: version,
            adapter: this.getAdapterVersion(),
            adAdapter: this.getAdAdapterVersion()
        };
        return ret;
    },
    /**
     * Returns Ip
     *
     * @memberof youbora.Plugin.prototype
     */ getIp: function getIp() {
        return this.options["network.ip"];
    },
    /**
     * Returns Isp
     *
     * @memberof youbora.Plugin.prototype
     */ getIsp: function getIsp() {
        return this.options["network.isp"];
    },
    /**
     * Returns ConnectionType
     *
     * @memberof youbora.Plugin.prototype
     */ getConnectionType: function getConnectionType() {
        return this.options["network.connectionType"];
    },
    /** Returns deviceInfo json
     *
     * @memberof youbora.Plugin.prototype
     */ getDeviceInfo: function getDeviceInfo() {
        var info = {};
        if (this.getDeviceCode()) info.deviceCode = this.getDeviceCode();
        if (this.getModel()) info.model = this.getModel();
        if (this.getBrand()) info.brand = this.getBrand();
        if (this.getDeviceType()) info.deviceType = this.getDeviceType();
        if (this.getDeviceName()) info.deviceName = this.getDeviceName();
        if (this.getOsName()) info.osName = this.getOsName();
        if (this.getOsVersion()) info.osVersion = this.getOsVersion();
        if (this.getBrowserName()) info.browserName = this.getBrowserName();
        if (this.getBrowserVersion()) info.browserVersion = this.getBrowserVersion();
        if (this.getBrowserType()) info.browserType = this.getBrowserType();
        if (this.getBrowserEngine()) info.browserEngine = this.getBrowserEngine();
        return info !== {} ? info : null;
    },
    /** Returns EDID object
   *
   * @memberof youbora.Plugin.prototype
   */ getEDID: function getEDID() {
        var edid = this.options["device.EDID"];
        return edid ? edid.toString() : null;
    },
    /**
     * Returns DeviceCode
     *
     * @memberof youbora.Plugin.prototype
     */ getDeviceCode: function getDeviceCode() {
        return this.options["device.code"];
    },
    /**
     * Returns Device model
     *
     * @memberof youbora.Plugin.prototype
     */ getModel: function getModel() {
        return this.options["device.model"];
    },
    /**
     * Returns Device brand
     *
     * @memberof youbora.Plugin.prototype
     */ getBrand: function getBrand() {
        return this.options["device.brand"];
    },
    /**
     * Returns Device type
     *
     * @memberof youbora.Plugin.prototype
     */ getDeviceType: function getDeviceType() {
        return this.options["device.type"];
    },
    /**
     * Returns Device name
     *
     * @memberof youbora.Plugin.prototype
     */ getDeviceName: function getDeviceName() {
        return this.options["device.name"];
    },
    /**
     * Returns Device OS name
     *
     * @memberof youbora.Plugin.prototype
     */ getOsName: function getOsName() {
        return this.options["device.osName"];
    },
    /**
     * Returns Device OS Version
     *
     * @memberof youbora.Plugin.prototype
     */ getOsVersion: function getOsVersion() {
        return this.options["device.osVersion"];
    },
    /**
     * Returns Device browser name
     *
     * @memberof youbora.Plugin.prototype
     */ getBrowserName: function getBrowserName() {
        return this.options["device.browserName"];
    },
    /**
     * Returns Device browser version
     *
     * @memberof youbora.Plugin.prototype
     */ getBrowserVersion: function getBrowserVersion() {
        return this.options["device.browserVersion"];
    },
    /**
     * Returns Device browser type
     *
     * @memberof youbora.Plugin.prototype
     */ getBrowserType: function getBrowserType() {
        return this.options["device.browserType"];
    },
    /**
     * Returns DeviceCode
     *
     * @memberof youbora.Plugin.prototype
     */ getBrowserEngine: function getBrowserEngine() {
        return this.options["device.browserEngine"];
    },
    /**
     * Returns AccountCode
     *
     * @memberof youbora.Plugin.prototype
     */ getAccountCode: function getAccountCode() {
        return this.options.accountCode;
    },
    /**
     * Returns Username
     *
     * @memberof youbora.Plugin.prototype
     */ getUsername: function getUsername() {
        return this.options["user.name"];
    },
    /**
     * Returns AnonymousUser
     *
     * @memberof youbora.Plugin.prototype
     */ getAnonymousUser: function getAnonymousUser() {
        return this.options["user.anonymousId"];
    },
    /**
     * Returns user email
     *
     * @memberof youbora.Plugin.prototype
     */ getEmail: function getEmail() {
        return this.options["user.email"];
    },
    /**
     * Returns Profile Id
     *
     * @memberof youbora.Plugin.prototype
     */ getProfileId: function getProfileId() {
        return this.options["user.profileId"];
    },
    /**
     * Get URL referer.
     *
     * @memberof youbora.Plugin.prototype
     */ getReferer: function getReferer() {
        var ret = this.options.referer || "";
        if (!ret && typeof window !== "undefined" && window.location) {
            ret = window.location.href;
        }
        return ret;
    },
    /**
     * Get URL referral.
     * Previous page url.
     * @memberof youbora.Plugin.prototype
     */ getReferral: function getReferral() {
        var ret = this.options.referral || "";
        if (!ret && typeof document !== "undefined") {
            ret = document.referrer;
        }
        return ret;
    },
    /**
     * Get Browser language
     *
     * @memberof youbora.Plugin.prototype
     */ getLanguage: function getLanguage() {
        var ret = null;
        if (typeof navigator !== "undefined") {
            ret = navigator.language;
        }
        return ret;
    },
    /**
   * Get Screen resolution
   *
   * @memberof npaw.Plugin.prototype
   */ getScreenResolution: function getScreenResolution() {
        var ret = null;
        try {
            if (window && window.screen) {
                var devicePixelRatio = window.devicePixelRatio || 1;
                ret = window.screen.width * devicePixelRatio + "x" + window.screen.height * devicePixelRatio;
            }
        } catch (e) {}
        return ret;
    },
    /**
     * Returns the nodehost
     *
     * @memberof youbora.Plugin.prototype
     */ getNodeHost: function getNodeHost() {
        return this.options["content.cdnNode"] || this.resourceTransform.getNodeHost();
    },
    /**
     * Returns the node type id
     *
     * @memberof youbora.Plugin.prototype
     */ getNodeType: function getNodeType() {
        return this.options["content.cdnType"] || this.resourceTransform.getNodeType();
    },
    /**
     * Returns the node type string
     *
     * @memberof youbora.Plugin.prototype
     */ getNodeTypeString: function getNodeTypeString() {
        return this.resourceTransform.getNodeTypeString();
    },
    /**
     * Returns requestNumber value, to prevent /data calls being cached
     *
     * @memberof youbora.Plugin.prototype
     */ getRequestNumber: function getRequestNumber() {
        return Math.random();
    },
    /**
     * Returns a whole offline view and its id.
     *
     * @memberof youbora.Plugin.prototype
     */ getOfflineView: function getOfflineView() {
        var ret = null;
        if (this.offlineStorage) {
            ret = this.offlineStorage.getView();
        }
        return ret;
    },
    getDeviceUUID: function getDeviceUUID() {
        var id = null;
        if (!this.options["device.isAnonymous"]) {
            id = this.options["device.id"] || this.uuidGenerator.getKey();
        }
        return id;
    },
    getAppName: function getAppName() {
        return this.options["app.name"];
    },
    getAppReleaseVersion: function getAppReleaseVersion() {
        return this.options["app.releaseVersion"];
    },
    getIsBlocked: function getIsBlocked() {
        return this.options["ad.blockerDetected"];
    },
    isMethodPostEnabled: function isMethodPostEnabled() {
        return this.options.method && this.options.method.toLowerCase() === RequestMethod.POST;
    },
    getPlayheadMonitorEnabled: function getPlayheadMonitorEnabled() {
        return this.options["playhead.monitor"];
    },
    getReadyStateMonitorEnabled: function getReadyStateMonitorEnabled() {
        return this.options["readyState.monitor"];
    }
};
module.exports = PluginGetterMixin;


/***/ }),

/***/ 8051:
/***/ ((module, exports, __webpack_require__) => {

// This file is designed to add extra functionalities to Plugin class

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
var Util = __webpack_require__(37280);
var PluginInfinityGettersMixin = {
    getContext: function getContext() {
        return "Default";
    },
    getScrollDepth: function getScrollDepth() {
        var ret = this.storage.getSession("pageScrollDepth");
        this.storage.removeSession("pageScrollDepth");
        return ret;
    },
    getSession: function getSession() {
        var ret = this.storage.getStorages("session");
        // Some tvs set the value as 'undefined' as string when deleting the value
        if (ret === "undefined") {
            ret = undefined;
        }
        if (!ret) {
            var data = this.getStoredData();
            if (data) {
                try {
                    ret = JSON.parse(data).q.c;
                } catch (err) {
                // nothing
                }
            }
        }
        return ret;
    },
    getStorageHost: function getStorageHost() {
        var ret = null;
        var data = this.getStoredData();
        if (data) {
            try {
                ret = JSON.parse(data).q.h;
            } catch (err) {
            // nothing
            }
        }
        return ret ? Util.addProtocol(ret, this.options["app.https"]) : ret;
    },
    getStoredData: function getStoredData() {
        return this.storage.getStorages("data");
    },
    getDataTime: function getDataTime() {
        return this.storage.getStorages("dataTime");
    },
    getLastActive: function getLastActive() {
        return this.storage.getStorages("lastactive");
    },
    setStoredData: function setStoredData(data) {
        this.storage.setStorages("data", data);
    },
    setSession: function setSession(session) {
        this.storage.setStorages("session", session);
    },
    setDataTime: function setDataTime(time) {
        this.storage.setStorages("dataTime", time);
    },
    setLastActive: function setLastActive(last) {
        this.storage.setStorages("lastactive", last);
    },
    getPageName: function getPageName() {
        if (typeof document !== "undefined" && document.title) {
            return document.title;
        }
    },
    getPageLoadTime: function getPageLoadTime() {
        return this.browserLoadTimes.getPageLoadTime();
    },
    getIsSessionExpired: function getIsSessionExpired() {
        var now = new Date().getTime();
        return !this.getSession() || this.infinity.getFirstActive() < now - this.sessionExpire;
    },
    getIsDataExpired: function getIsDataExpired() {
        var now = new Date().getTime();
        return !this.storage.isEnabled() || !this.getStoredData() || this.infinity.getFirstActive() < now - this.sessionExpire;
    }
};
module.exports = PluginInfinityGettersMixin;


/***/ }),

/***/ 11548:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
var Constants = __webpack_require__(56230);
var Log = __webpack_require__(39610);
var YBRequest = __webpack_require__(57195);
var Util = __webpack_require__(37280);
var YouboraInfinity = __webpack_require__(11308);
// This file is designed to add extra functionalities to Plugin class
var PluginInfinityMixin = {
    _initInfinity: function _initInfinity() {
        this.infinity.on(YouboraInfinity.Event.NAV, this._navListener.bind(this));
        this.infinity.on(YouboraInfinity.Event.SESSION_START, this._sessionStartListener.bind(this));
        this.infinity.on(YouboraInfinity.Event.SESSION_STOP, this._sessionStopListener.bind(this));
        this.infinity.on(YouboraInfinity.Event.EVENT, this._eventListener.bind(this));
        this.infinity.on(YouboraInfinity.Event.EVENT_END, this._eventEndListener.bind(this));
    },
    _sendInfinity: function _sendInfinity(willSendEvent, service, params) {
        params = this.requestBuilder.buildParams(params, service);
        var data = {
            params: params,
            plugin: this,
            adapter: this.getAdapter(),
            adsAdapter: this.getAdsAdapter()
        };
        this.emit(willSendEvent, data);
        if (this.infinity._comm && params !== null && this.options.enabled) {
            this.lastServeiceSent = service;
            var request = new YBRequest(null, service, params);
            if (this.isMethodPostEnabled()) {
                request.setPostRequest(true);
            }
            this.infinity._comm.sendRequest(request);
        }
    },
    // ---------------------------------------- LISTENERS -----------------------------------------
    _navListener: function _navListener(e) {
        var params = e.data.params || {};
        this._sendInfinity(Constants.WillSendEvent.WILL_SEND_NAV, Constants.Service.NAV, params);
        // start beats
        if (!this._beat.isRunning) this._beat.start();
        Log.notice(Constants.Service.NAV + " " + params.route);
    },
    _sessionStartListener: function _sessionStartListener(e) {
        var params = e.data.params || {};
        this._sendInfinity(Constants.WillSendEvent.WILL_SEND_SESSION_START, Constants.Service.SESSION_START, params);
        // start beats
        if (!this._beat.isRunning) this._beat.start();
        Log.notice(Constants.Service.SESSION_START + " " + params.route);
    },
    _sessionStopListener: function _sessionStopListener(e) {
        var params = e.data.params || {};
        this._sendInfinity(Constants.WillSendEvent.WILL_SEND_SESSION_STOP, Constants.Service.SESSION_STOP, params);
        // stop beats
        if (this._beat.isRunning) this._beat.stop();
        Log.notice(Constants.Service.SESSION_STOP + " " + params.route);
    },
    _eventListener: function _eventListener(e) {
        var params = e.data.params || {};
        this._sendInfinity(Constants.WillSendEvent.WILL_SEND_EVENT, Constants.Service.EVENT, params);
        Log.notice(Constants.Service.EVENT + " " + params.name);
    },
    _eventEndListener: function _eventEndListener(e) {
        var params = e.data.params || {};
        this._sendInfinity(Constants.WillSendEvent.WILL_SEND_EVENT_END, Constants.Service.EVENT_END, params);
        Log.notice(Constants.Service.EVENT_END + " " + params.name);
    },
    /**
   * Sends beat request
   *
   * @param {number} diffTime Time since the last ping
   *
   * @private
   * @memberof youbora.Plugin.prototype
   */ _sendBeat: function _sendBeat(diffTime) {
        var params = {
            diffTime: diffTime
        };
        this._sendInfinity(Constants.WillSendEvent.WILL_SEND_BEAT, Constants.Service.BEAT, params);
        if (this.infinity) {
            this.infinity._setLastActive();
        }
        Log.verbose(Constants.Service.BEAT);
    },
    // ---------------------------------------- GETTERS -----------------------------------------
    /**
* Returns a json with the metrics to be reported in beats when changed
*
* @memberof youbora.Plugin.prototype
*/ getSessionMetrics: function getSessionMetrics() {
        return Util.getMetricsFrom(this.options["session.metrics"]);
    }
};
module.exports = PluginInfinityMixin;


/***/ }),

/***/ 45228:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
var Log = __webpack_require__(39610);
var Constants = __webpack_require__(56230);
// This file is designed to add extra functionalities to Plugin class
var PluginPingMixin = {
    /**
   * Starts sending pings.
   *
   * @private
   * @memberof youbora.Plugin.prototype
   */ _startPings: function _startPings() {
        if (!this._ping.isRunning) this._ping.start();
    },
    /**
   * Stops sending pings.
   *
   * @private
   * @memberof youbora.Plugin.prototype
   */ _stopPings: function _stopPings() {
        this._ping.stop();
    },
    /**
   * Sends ping request
   *
   * @param {number} diffTime Time since the last ping
   *
   * @private
   * @memberof youbora.Plugin.prototype
   */ _sendPing: function _sendPing(diffTime) {
        var params = {
            diffTime: diffTime,
            entities: this.requestBuilder.getChangedEntities()
        };
        if (this._adapter) {
            if (this._adapter.flags.isPaused) {
                params = this.requestBuilder.fetchParams(params, [
                    "pauseDuration"
                ]);
            } else {
                params = this.requestBuilder.fetchParams(params, [
                    "bitrate",
                    "throughput",
                    "fps"
                ]);
            }
            if (this._adapter.flags.isJoined) {
                params = this.requestBuilder.fetchParams(params, [
                    "playhead"
                ]);
            }
            if (this._adapter.flags.isBuffering) {
                params = this.requestBuilder.fetchParams(params, [
                    "bufferDuration"
                ]);
            }
            if (this._adapter.flags.isSeeking) {
                params = this.requestBuilder.fetchParams(params, [
                    "seekDuration"
                ]);
            }
        }
        if (this._adsAdapter && !this.options["ad.ignore"]) {
            if (this._adsAdapter.flags.isStarted) {
                params = this.requestBuilder.fetchParams(params, [
                    "adPlayhead",
                    "adViewedDuration",
                    "adViewability"
                ]);
                if (this._adsAdapter.flags.isPaused) {
                    params = this.requestBuilder.fetchParams(params, [
                        "adPauseDuration"
                    ]);
                } else {
                    params = this.requestBuilder.fetchParams(params, [
                        "adBitrate"
                    ]);
                }
            }
            if (this._adsAdapter.flags.isBuffering) {
                params = this.requestBuilder.fetchParams(params, [
                    "adBufferDuration"
                ]);
            }
        }
        this._send(Constants.WillSendEvent.WILL_SEND_PING, Constants.Service.PING, params);
        if (this.startDelayed) {
            this._retryStart();
        }
        Log.verbose(Constants.Service.PING);
    }
};
module.exports = PluginPingMixin;


/***/ }),

/***/ 82241:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
var Emitter = __webpack_require__(15885);
var Timer = __webpack_require__(45193);
var Chrono = __webpack_require__(92747);
var Constants = __webpack_require__(56230);
var Util = __webpack_require__(37280);
var YBRequest = __webpack_require__(57195);
var Communication = __webpack_require__(30495);
var FlowTransform = __webpack_require__(57009);
var ViewTransform = __webpack_require__(96726);
var ResourceTransform = __webpack_require__(88584);
var OfflineTransform = __webpack_require__(14219);
var Options = __webpack_require__(50489);
var YouboraStorage = __webpack_require__(91305);
var OfflineStorage = __webpack_require__(5203);
var RequestBuilder = __webpack_require__(36582);
var YouboraInfinity = __webpack_require__(11308);
var ProductAnalytics = __webpack_require__(68658);
var HybridNetwork = __webpack_require__(86940);
var BrowserLoadTimes = __webpack_require__(25758);
var BackgroundDetector = __webpack_require__(64413);
var DeviceDetector = __webpack_require__(1329);
var ResizeScrollDetector = __webpack_require__(49855);
var UUIDGenerator = __webpack_require__(1879);
var Plugin = Emitter.extend(/** @lends youbora.Plugin.prototype */ {
    /**
     * This is the main class of video analytics. You may want to have one instance for each video
     * you want to track. Will need {@link Adapter}s for both content and ads.
     *
     * @constructs Plugin
     * @extends youbora.Emitter
     * @memberof youbora
     *
     * @param {Options} [options] An object complying with {@link Options} constructor.
     * @param {Adapter} [adapter] If an adapter is provided, setAdapter will be immediately called.
     * @param {object} [dataReq] If a data response is given, it wont request to /data anything and will use this one instead.
     */ constructor: function constructor(options, adapter, dataReq) {
        if (typeof adapter === "string" && !dataReq) {
            dataReq = adapter;
            adapter = null;
        }
        /** Reference to {@link youbora.YouboraStorage} */ this.storage = new YouboraStorage();
        /** UUIDGenerator manager */ this.uuidGenerator = new UUIDGenerator(this);
        /** Instance of youbora infinity. */ this.infinity = new YouboraInfinity(this);
        /** Instance of youbora Product Analytics. */ this.productAnalytics = new ProductAnalytics(this);
        /** This flags indicates that /init has been called. */ this.isInitiated = false;
        /** This flags indicates that /adManifest has been called. */ this.isAdsManifestSent = false;
        /** Postroll counter to fix plugins reporting stop before postrolls */ this.playedPostrolls = 0;
        /** This flags indicates if an ad break is started */ this.isBreakStarted = false;
        /** Chrono for init times. */ this.initChrono = new Chrono();
        /** Stored {@link Options} of the session. */ this.options = new Options(options);
        /** Reference to {@link youbora.YouboraStorage} */ this.storage = new YouboraStorage(null, this.options.disableCookies, this.options.forceCookies, this.options.disableStorage);
        /** Reference to {@link youbora.OfflineStorage} */ if (!this.options.disableStorage) {
            this.offlineStorage = new OfflineStorage();
        }
        this._adapter = null;
        this._adsAdapter = null;
        this._ping = new Timer(this._sendPing.bind(this), 5000);
        this._beat = new Timer(this._sendBeat.bind(this), 30000);
        this._refreshData = new Timer(this._checkOldData.bind(this), 3600000) // 1h
        ;
        this._refreshData.start();
        this.sessionExpire = Number(this.storage.getLocal("sessionExpire")) * 1000 || 180000;
        this.requestBuilder = new RequestBuilder(this);
        this.resourceTransform = new ResourceTransform(this);
        this.lastEventTime = null;
        this.restartViewTransform(dataReq);
        this._initInfinity();
        this.hybridNetwork = new HybridNetwork();
        this.browserLoadTimes = new BrowserLoadTimes(this);
        this.deviceDetector = new DeviceDetector();
        this.backgroundDetector = new BackgroundDetector(this);
        this.resizeScrollDetector = new ResizeScrollDetector(this);
        if (this.options["background.enabled"]) this.backgroundDetector.startDetection();
        if (adapter) this.setAdapter(adapter);
    },
    _checkOldData: function _checkOldData() {
        if (this._adapter && this._adapter.flags.isStarted) return;
        if (this.infinity.infinityStarted) return;
        this.restartViewTransform();
    },
    restartViewTransform: function restartViewTransform(response) {
        // FastData
        this.viewTransform = new ViewTransform(this);
        this.viewTransform.on(ViewTransform.Event.DONE, this._receiveData.bind(this));
        // External response
        if (response) {
            this.viewTransform.setData(response);
            return;
        }
        if (this.getIsDataExpired() || !this.getStorageHost() || this.storage.getLocal("accCode") !== this.options.accountCode && this.storage.getSession("accCode") !== this.options.accountCode) {
            this.storage.removeStorages("data");
            this.storage.removeStorages("session");
            this.storage.removeLocal("infinityStarted");
            this.viewTransform.init() // request a new data
            ;
        } else {
            this.viewTransform.setData(this.getStoredData()) // use stored data
            ;
        }
    },
    /**
    * This callback is called when a correct data response is received.
    *
    * @param {any} e Response from fastdata
    */ _receiveData: function _receiveData(e) {
        this._ping.interval = e.target.response.pingTime * 1000;
        this._beat.interval = e.target.response.beatTime * 1000;
        this.sessionExpire = e.target.response.sessionExpire * 1000;
        this.storage.setStorages("data", e.target.response.msg);
        this.storage.setStorages("dataTime", new Date().getTime());
        this.storage.setStorages("accCode", this.options.accountCode);
        if (this.getIsSessionExpired()) {
            this.viewTransform.setSession(this.viewTransform.response.code);
            this.storage.setStorages("session", this.viewTransform.response.code);
            this.storage.setStorages("host", this.viewTransform.response.host);
        } else {
            this.viewTransform.setSession(this.getSession());
            this.viewTransform.setHost(this.getStorageHost());
        }
    },
    /**
    * Reset all variables and stop all timers
    * @private
    */ _reset: function _reset() {
        this._stopPings();
        this.resourceTransform = new ResourceTransform(this);
        if (this._adapter) {
            this._adapter.flags.reset();
        }
        this.isInitiated = false;
        this.isStarted = false;
        this.startDelayed = false;
        this.isAdsManifestSent = false;
        this.initChrono.reset();
        this._totalPrerollsTime = 0;
        this.requestBuilder.lastSent.breakNumber = 0;
        this.requestBuilder.lastSent.adNumber = 0;
        this._savedAdManifest = null;
        this._savedAdError = null;
        this.playedPostrolls = 0;
        this.isBreakStarted = false;
    },
    /**
    * Creates and enqueues related request using {@link Communication#sendRequest}.
    * It will fire will-send-events.
    *
    * @param {string} willSendEvent Name of the will-send event. Use {@link Plugin.Event} enum.
    * @param {string} service Name of the service. Use {@link Constants.Service} enum.
    * @param {Object} params Params of the request
    * @param {Object} body Body of the request, if it is a POST request
    * @param {string} method Request method. GET by default
    * @param {function} callback Callback method for successful request
    * @param {Object} callbackParams Json with params for callback call
    * @private
    */ _send: function _send(willSendEvent, service, params, body, method, callback, callbackParams) {
        var now = new Date().getTime();
        if (this.options.preventZombieViews && this.lastEventTime && now > this.lastEventTime + 600 * 1000) {
            // if last event was sent more than 10 minutes ago, it will use new view code
            this.viewTransform.nextView();
        }
        this.lastEventTime = service === Constants.Service.STOP ? null : now;
        params = this.requestBuilder.buildParams(params, service);
        if (this.getIsLive()) {
            params.mediaDuration = this.options["content.duration"];
            params.playhead = undefined;
        }
        var data = {
            params: params,
            plugin: this,
            adapter: this.getAdapter(),
            adsAdapter: this.getAdsAdapter()
        };
        this.emit(willSendEvent, data);
        if (this._comm && (params !== null || typeof method !== "undefined") && this.options.enabled) {
            this.lastServeiceSent = service;
            var options = {};
            if (typeof method !== "undefined" && method !== "GET") {
                options.method = method;
            }
            var request = new YBRequest(null, service, params, options);
            if (body) request.setBody(body);
            if (this.isMethodPostEnabled()) {
                request.setPostRequest(true);
            }
            this._comm.sendRequest(request, callback, callbackParams);
        }
    },
    /**
    * Initializes comm and its transforms.
    * @private
    */ _initComm: function _initComm() {
        var resource = this._getResourceForTransform();
        this.resourceTransform.init(resource);
        this._comm = new Communication();
        this._comm.addTransform(new FlowTransform());
        this._comm.addTransform(this.viewTransform);
        if (this.options && this.options.offline) {
            this._comm.addTransform(new OfflineTransform(this));
        } else {
            this._comm.addTransform(this.resourceTransform);
        }
    },
    _getResourceForTransform: function _getResourceForTransform() {
        var resource = this.getResource();
        if (this._adapter && this._adapter.getURLToParse()) {
            resource = this._adapter.getURLToParse();
        }
        return resource;
    },
    /**
    * Returns the current {@link youbora.Communication} instance.
    *
    * @returns {youbora.Communication} communication instance
    */ getComm: function getComm() {
        return this._comm;
    },
    /**
    * Modifies current options. See {@link Options.setOptions}.
    *
    * @param {any} options
    */ setOptions: function setOptions(options) {
        if (options) {
            this.options.setOptions(options);
            if (typeof options["background.enabled"] === "boolean") {
                if (options["background.enabled"]) {
                    this.backgroundDetector.startDetection();
                } else {
                    this.backgroundDetector.stopDetection();
                }
            }
        }
    },
    /**
    * Get fastdata response to set it in another plugin instance
    */ getFastDataConfig: function getFastDataConfig() {
        return this.viewTransform.response.msg;
    },
    /**
    * Disable request sending.
    */ disable: function disable() {
        this.setOptions({
            enabled: false
        });
    },
    /**
    * Re-enable request sending.
    */ enable: function enable() {
        this.setOptions({
            enabled: true
        });
    }
}, /** @lends youbora.Plugin */ {
    // Static Memebers //
    /**
    * List of events that could be fired
    * @enum
    * @event
    */ Event: Constants.WillSendEvent
});
// Apply Mixins
// Plugin is actually a big class, I decided to separate the logic into
// different mixin files to ease the maintainability of each file.
// Filename convention will be plugin+xxxxx.js where xxxxx is the added functionality.
Util.assign(Plugin.prototype, __webpack_require__(22145));
Util.assign(Plugin.prototype, __webpack_require__(38738));
Util.assign(Plugin.prototype, __webpack_require__(11117));
Util.assign(Plugin.prototype, __webpack_require__(69780));
Util.assign(Plugin.prototype, __webpack_require__(97429));
Util.assign(Plugin.prototype, __webpack_require__(45228));
Util.assign(Plugin.prototype, __webpack_require__(99305));
Util.assign(Plugin.prototype, __webpack_require__(11548));
Util.assign(Plugin.prototype, __webpack_require__(8051));
module.exports = Plugin;


/***/ }),

/***/ 36582:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var YouboraObject = __webpack_require__(831);
var Log = __webpack_require__(39610);
var startParams = [
    "accountCode",
    "username",
    "anonymousUser",
    "profileId",
    "rendition",
    "deviceInfo",
    "player",
    "title",
    "title2",
    "live",
    "segmentDuration",
    "mediaDuration",
    "mediaResource",
    "parsedResource",
    "transactionCode",
    "properties",
    "cdn",
    "playerVersion",
    "param1",
    "param2",
    "param3",
    "param4",
    "param5",
    "param6",
    "param7",
    "param8",
    "param9",
    "param10",
    "param11",
    "param12",
    "param13",
    "param14",
    "param15",
    "param16",
    "param17",
    "param18",
    "param19",
    "param20",
    "dimensions",
    "playerStartupTime",
    "obfuscateIp",
    "privacyProtocol",
    "p2pEnabled",
    "pluginVersion",
    "pluginInfo",
    "isp",
    "connectionType",
    "ip",
    "referer",
    "userType",
    "streamingProtocol",
    "transportFormat",
    "householdId",
    "adsBlocked",
    "adsExpected",
    "deviceUUID",
    "libVersion",
    "nodeHost",
    "nodeType",
    "appName",
    "appReleaseVersion",
    "package",
    "saga",
    "tvshow",
    "season",
    "titleEpisode",
    "channel",
    "imdbID",
    "gracenoteID",
    "contentType",
    "genre",
    "contentLanguage",
    "subtitles",
    "cost",
    "price",
    "playbackType",
    "email",
    "drm",
    "videoCodec",
    "audioCodec",
    "codecSettings",
    "codecProfile",
    "containerFormat",
    "contentId",
    "contractedResolution",
    "linkedViewId",
    "edid",
    "cdnBalancerResponseUUID",
    "triggeredEvents"
];
var adStartParams = [
    "player",
    "playhead",
    "adTitle",
    "position",
    "adDuration",
    "adCampaign",
    "adCreativeId",
    "adProvider",
    "adResource",
    "adPlayerVersion",
    "adProperties",
    "adAdapterVersion",
    "adInsertionType",
    "extraparam1",
    "extraparam2",
    "extraparam3",
    "extraparam4",
    "extraparam5",
    "extraparam6",
    "extraparam7",
    "extraparam8",
    "extraparam9",
    "extraparam10",
    "fullscreen",
    "audio",
    "skippable",
    "adNumber",
    "adNumberInBreak",
    "breakNumber"
];
var RequestBuilder = YouboraObject.extend(/** @lends youbora.RequestBuilder.prototype */ {
    /**
     * This class helps building params associated with each event: /start, /joinTime...
     *
     * @constructs RequestBuilder
     * @extends youbora.YouboraObject
     * @memberof youbora
     *
     * @param {Plugin} plugin A Plugin instance
     */ constructor: function constructor(plugin) {
        this._plugin = plugin;
        this._adNumber = 0;
        this._adNumberInBreak = 0;
        /** Stores a list of the last params fetched */ this.lastSent = {};
    },
    /**
     * Adds to params all the entities specified in paramList, unless they are already set.
     *
     * @param {Object} params Object of params key:value.
     * @param {Array.string} paramList A list of params to fetch.
     * @param {bool} onlyDifferent If true, only fetches params that have changed
     */ fetchParams: function fetchParams(params, paramList, onlyDifferent) {
        params = params || {};
        paramList = paramList || [];
        for(var i = 0; i < paramList.length; i++){
            var param = paramList[i];
            if (params[param]) {
                continue;
            }
            var getterName = RequestBuilder.getters[param];
            if (this._plugin[getterName]) {
                var value = this._plugin[getterName]();
                if (value !== null && (!onlyDifferent || this.lastSent[param] !== value)) {
                    params[param] = value;
                    this.lastSent[param] = value;
                }
            } else {
                Log.warn("Trying to call undefined getter " + param + ":" + getterName);
            }
        }
        return params;
    },
    getGetters: function getGetters() {
        return RequestBuilder.getters;
    },
    buildBody: function buildBody(service) {
        var body = null;
        return this.fetchParams(body, RequestBuilder.bodyParams[service], false);
    },
    /**
     * Adds to params object all the entities specified in paramList, unless they are already set.
     *
     * @param {Object} params Object of params key:value.
     * @param {string} service The name of the service. Use {@link Plugin.Service} enum.
     */ buildParams: function buildParams(params, service) {
        params = params || {};
        this.fetchParams(params, RequestBuilder.params[service], false);
        this.fetchParams(params, RequestBuilder.differentParams[service], true);
        return params;
    },
    /**
     * Creates an adnumber if it does not exist and stores it in lastSent. If it already exists,
     * it is incremented by 1.
     *
     * @returns {number} adNumber
     */ getNewAdNumber: function getNewAdNumber() {
        var adNumber = this.lastSent.adNumber;
        if (adNumber && this.lastSent.position === this._plugin.getAdPosition()) {
            adNumber += 1;
        } else {
            adNumber = 1;
        }
        this.lastSent.adNumber = adNumber;
        return adNumber;
    },
    /**
     * Creates an adnumberinbreak incrementing by 1.
     *
     * @returns {number} adNumber
     */ getNewAdNumberInBreak: function getNewAdNumberInBreak() {
        this._adNumberInBreak++;
        this.lastSent.adNumberInBreak = this._adNumberInBreak;
        return this._adNumberInBreak;
    },
    /**
     * Creates an breaknumber if it does not exist and stores it in lastSent. If it already exists,
     * it is incremented by 1.
     * Also resets adnumberinbreak
     * @returns {number} breakNumber
     */ getNewBreakNumber: function getNewBreakNumber() {
        var breakNumber = 1;
        this._adNumberInBreak = 0;
        if (this.lastSent.breakNumber) {
            breakNumber = this.lastSent.breakNumber + 1;
        }
        this.lastSent.breakNumber = breakNumber;
        return breakNumber;
    },
    /**
     * Return changed entities since last check
     *
     * @returns {Object} params
     */ getChangedEntities: function getChangedEntities() {
        return this.fetchParams({}, RequestBuilder.differentParams.entities, true);
    }
}, /** @lends youbora.RequestBuilder */ {
    // Static Members
    /** List of params used by each service */ params: {
        "/data": [
            "system",
            "pluginVersion",
            "requestNumber",
            "username"
        ],
        "/init": startParams,
        "/start": startParams,
        "/joinTime": [
            "joinDuration",
            "playhead",
            "bitrate",
            "triggeredEvents"
        ],
        "/pause": [
            "playhead",
            "triggeredEvents"
        ],
        "/resume": [
            "pauseDuration",
            "playhead",
            "triggeredEvents"
        ],
        "/seek": [
            "seekDuration",
            "playhead",
            "triggeredEvents"
        ],
        "/bufferUnderrun": [
            "bufferDuration",
            "playhead",
            "triggeredEvents"
        ],
        "/error": [
            "player",
            "playhead",
            "triggeredEvents"
        ].concat(startParams),
        "/stop": [
            "bitrate",
            "totalBytes",
            "playhead",
            "pauseDuration",
            "metrics",
            "cdnDownloadedTraffic",
            "multiCdnInfo",
            "p2pDownloadedTraffic",
            "uploadTraffic",
            "triggeredEvents"
        ],
        "/infinity/video/event": [
            "playhead"
        ],
        "/infinity/video/event/stop": [
            "playhead"
        ],
        "/adInit": adStartParams,
        "/adStart": adStartParams,
        "/adJoin": [
            "playhead",
            "position",
            "adJoinDuration",
            "adPlayhead",
            "adNumber",
            "adNumberInBreak",
            "breakNumber"
        ],
        "/adPause": [
            "playhead",
            "position",
            "adPlayhead",
            "adNumber",
            "adNumberInBreak",
            "breakNumber"
        ],
        "/adResume": [
            "playhead",
            "position",
            "adPlayhead",
            "adPauseDuration",
            "adNumber",
            "adNumberInBreak",
            "breakNumber"
        ],
        "/adBufferUnderrun": [
            "playhead",
            "position",
            "adPlayhead",
            "adBufferDuration",
            "adNumber",
            "adNumberInBreak",
            "breakNumber"
        ],
        "/adStop": [
            "playhead",
            "position",
            "adPlayhead",
            "adBitrate",
            "adTotalDuration",
            "pauseDuration",
            "adViewedDuration",
            "adViewability",
            "adNumber",
            "adNumberInBreak",
            "breakNumber"
        ],
        "/adClick": [
            "playhead",
            "position",
            "adPlayhead",
            "adNumber",
            "adNumberInBreak",
            "breakNumber"
        ],
        "/adError": [
            "playhead"
        ].concat(adStartParams),
        "/adManifest": [
            "givenBreaks",
            "expectedBreaks",
            "expectedPattern",
            "breaksTime"
        ],
        "/adBreakStart": [
            "position",
            "givenAds",
            "expectedAds",
            "breakNumber",
            "adInsertionType"
        ],
        "/adBreakStop": [
            "position",
            "breakNumber"
        ],
        "/adQuartile": [
            "position",
            "adViewedDuration",
            "adViewability",
            "adNumber",
            "adNumberInBreak",
            "breakNumber"
        ],
        "/ping": [
            "droppedFrames",
            "playrate",
            "cdnDownloadedTraffic",
            "multiCdnInfo",
            "p2pDownloadedTraffic",
            "uploadTraffic",
            "latency",
            "packetLoss",
            "packetSent",
            "metrics",
            "totalBytes",
            "segmentDuration"
        ],
        "/infinity/session/start": [
            "accountCode",
            "username",
            "userType",
            "anonymousUser",
            "profileId",
            "route",
            "page",
            "referer",
            "referral",
            "screenResolution",
            "language",
            "deviceInfo",
            "adsBlocked",
            "deviceUUID",
            "libVersion",
            "appName",
            "appReleaseVersion",
            "isp",
            "connectionType",
            "ip",
            "obfuscateIp",
            "privacyProtocol",
            "dimensions",
            "param1",
            "param2",
            "param3",
            "param4",
            "param5",
            "param6",
            "param7",
            "param8",
            "param9",
            "param10",
            "param11",
            "param12",
            "param13",
            "param14",
            "param15",
            "param16",
            "param17",
            "param18",
            "param19",
            "param20",
            "edid"
        ],
        "/infinity/session/stop": [
            "sessionMetrics"
        ],
        "/infinity/session/nav": [
            "route",
            "page",
            "scrollDepth"
        ],
        "/infinity/session/beat": [
            "sessionMetrics"
        ],
        "/infinity/session/event": [
            "accountCode"
        ],
        "/infinity/session/event/stop": [
            "accountCode"
        ],
        "/offlineEvents": {}
    },
    /** Values for request body */ bodyParams: {
        "/offlineEvents": [
            "viewJson"
        ]
    },
    /** List of params used by each service (only if they are different) */ differentParams: {
        entities: [
            "rendition",
            "title",
            "title2",
            "param1",
            "param2",
            "param3",
            "param4",
            "param5",
            "param6",
            "param7",
            "param8",
            "param9",
            "param10",
            "param11",
            "param12",
            "param13",
            "param14",
            "param15",
            "param16",
            "param17",
            "param18",
            "param19",
            "param20",
            "cdn",
            "nodeHost",
            "nodeType",
            "nodeTypeString",
            "subtitles",
            "contentLanguage",
            "contentId"
        ]
    },
    /** List of params and its related getter */ getters: {
        requestNumber: "getRequestNumber",
        playhead: "getPlayhead",
        playrate: "getPlayrate",
        fps: "getFramesPerSecond",
        segmentDuration: "getSegmentDuration",
        droppedFrames: "getDroppedFrames",
        mediaDuration: "getDuration",
        bitrate: "getBitrate",
        totalBytes: "getTotalBytes",
        throughput: "getThroughput",
        rendition: "getRendition",
        title: "getTitle",
        title2: "getTitle2",
        live: "getIsLive",
        mediaResource: "getResource",
        parsedResource: "getParsedResource",
        transactionCode: "getTransactionCode",
        properties: "getMetadata",
        playerVersion: "getPlayerVersion",
        player: "getPlayerName",
        cdn: "getCdn",
        pluginVersion: "getPluginVersion",
        libVersion: "getLibVersion",
        userType: "getUserType",
        streamingProtocol: "getStreamingProtocol",
        transportFormat: "getTransportFormat",
        obfuscateIp: "getObfuscateIp",
        privacyProtocol: "getPrivacyProtocol",
        householdId: "getHouseholdId",
        latency: "getLatency",
        packetLoss: "getPacketLoss",
        packetSent: "getPacketSent",
        metrics: "getVideoMetrics",
        dimensions: "getCustomDimensions",
        param1: "getExtraparam1",
        param2: "getExtraparam2",
        param3: "getExtraparam3",
        param4: "getExtraparam4",
        param5: "getExtraparam5",
        param6: "getExtraparam6",
        param7: "getExtraparam7",
        param8: "getExtraparam8",
        param9: "getExtraparam9",
        param10: "getExtraparam10",
        param11: "getExtraparam11",
        param12: "getExtraparam12",
        param13: "getExtraparam13",
        param14: "getExtraparam14",
        param15: "getExtraparam15",
        param16: "getExtraparam16",
        param17: "getExtraparam17",
        param18: "getExtraparam18",
        param19: "getExtraparam19",
        param20: "getExtraparam20",
        extraparam1: "getAdExtraparam1",
        extraparam2: "getAdExtraparam2",
        extraparam3: "getAdExtraparam3",
        extraparam4: "getAdExtraparam4",
        extraparam5: "getAdExtraparam5",
        extraparam6: "getAdExtraparam6",
        extraparam7: "getAdExtraparam7",
        extraparam8: "getAdExtraparam8",
        extraparam9: "getAdExtraparam9",
        extraparam10: "getAdExtraparam10",
        position: "getAdPosition",
        adNumber: "getAdNumber",
        adNumberInBreak: "getAdNumberInBreak",
        breakNumber: "getBreakNumber",
        adPlayhead: "getAdPlayhead",
        adDuration: "getAdDuration",
        adCampaign: "getAdCampaign",
        adCreativeId: "getAdCreativeId",
        adBitrate: "getAdBitrate",
        adTitle: "getAdTitle",
        adResource: "getAdResource",
        adPlayerVersion: "getAdPlayerVersion",
        adProperties: "getAdMetadata",
        adAdapterVersion: "getAdAdapterVersion",
        givenBreaks: "getGivenBreaks",
        expectedBreaks: "getExpectedBreaks",
        expectedPattern: "getExpectedPattern",
        breaksTime: "getBreaksTime",
        givenAds: "getGivenAds",
        expectedAds: "getExpectedAds",
        adsExpected: "getAdsExpected",
        adViewedDuration: "getAdViewedDuration",
        adViewability: "getAdViewability",
        fullscreen: "getIsFullscreen",
        audio: "getAudioEnabled",
        skippable: "getIsSkippable",
        adProvider: "getAdProvider",
        adInsertionType: "getAdInsertionType",
        pluginInfo: "getPluginInfo",
        isp: "getIsp",
        connectionType: "getConnectionType",
        ip: "getIp",
        deviceInfo: "getDeviceInfo",
        edid: "getEDID",
        system: "getAccountCode",
        accountCode: "getAccountCode",
        username: "getUsername",
        anonymousUser: "getAnonymousUser",
        profileId: "getProfileId",
        joinDuration: "getJoinDuration",
        bufferDuration: "getBufferDuration",
        seekDuration: "getSeekDuration",
        pauseDuration: "getPauseDuration",
        adJoinDuration: "getAdJoinDuration",
        adBufferDuration: "getAdBufferDuration",
        adPauseDuration: "getAdPauseDuration",
        adTotalDuration: "getAdTotalDuration",
        referer: "getReferer",
        referral: "getReferral",
        language: "getLanguage",
        screenResolution: "getScreenResolution",
        nodeHost: "getNodeHost",
        nodeType: "getNodeType",
        nodeTypeString: "getNodeTypeString",
        route: "getReferer",
        page: "getPageName",
        playerStartupTime: "getPlayerStartupTime",
        pageLoadTime: "getPageLoadTime",
        cdnDownloadedTraffic: "getCdnTraffic",
        multiCdnInfo: "getMultiCdnInfo",
        p2pDownloadedTraffic: "getP2PTraffic",
        p2pEnabled: "getIsP2PEnabled",
        uploadTraffic: "getUploadTraffic",
        cdnBalancerResponseUUID: "getBalancerResponseId",
        viewJson: "getOfflineView",
        deviceUUID: "getDeviceUUID",
        sessionMetrics: "getSessionMetrics",
        scrollDepth: "getScrollDepth",
        adsBlocked: "getIsBlocked",
        linkedViewId: "getLinkedViewId",
        appName: "getAppName",
        appReleaseVersion: "getAppReleaseVersion",
        package: "getPackage",
        saga: "getSaga",
        tvshow: "getTvShow",
        season: "getSeason",
        titleEpisode: "getEpisodeTitle",
        channel: "getChannel",
        drm: "getDRM",
        videoCodec: "getVideoCodec",
        audioCodec: "getAudioCodec",
        codecSettings: "getCodecSettings",
        codecProfile: "getCodecProfile",
        containerFormat: "getContainerFormat",
        contentId: "getID",
        imdbID: "getImdbId",
        gracenoteID: "getGracenoteID",
        contentType: "getType",
        genre: "getGenre",
        contentLanguage: "getVideoLanguage",
        subtitles: "getSubtitles",
        contractedResolution: "getContractedResolution",
        cost: "getCost",
        price: "getPrice",
        playbackType: "getPlaybackType",
        email: "getEmail"
    }
});
module.exports = RequestBuilder;


/***/ }),

/***/ 91305:
/***/ ((module, exports, __webpack_require__) => {

/* global localStorage, sessionStorage, location */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
var YouboraObject = __webpack_require__(831);
var Log = __webpack_require__(39610);
/**
 * This class manages data sotrage in the browser memory.
 *
 * @extends youbora.Emitter
 * @memberof youbora
 */ var YouboraStorage = YouboraObject.extend(/** @lends youbora.YouboraStorage.prototype */ {
    /**
     *
     * @constructs YouboraStorage
     * @extends YouboraObject
     * @memberof youbora
     *
     * @param {String} [prefix] Optional. Sets the prefix for saved objects in storages or cookies. 'youbora' by default.
     * @param {Boolean} [disableCookies] Optional. Set to true to disable cookies fallback. True by default.
     */ constructor: function constructor(prefix, disableCookies, forceCookies, disable) {
        this.prefix = prefix || "youbora";
        this.disableCookies = disableCookies;
        this.forceCookies = forceCookies;
        this.disabled = disable;
    },
    /**
     * Returns if storages are available or not
     *
     */ isEnabled: function isEnabled() {
        if (this.disabled) return false;
        var ret = true;
        if (!this.forceCookies) {
            try {
                localStorage.setItem(this.prefix + "." + "test", "true");
                localStorage.removeItem(this.prefix + "." + "test");
            } catch (err) {
                ret = false;
            }
        }
        return ret;
    },
    /**
     * Saves in localStorage or equivalent
     *
     * @param {string} key Key of the value. Prefix will be appended.
     * @param {string} value Value.
     */ setLocal: function setLocal(key, value) {
        if (this.disabled) return null;
        var ret = null;
        try {
            if (this.forceCookies || (typeof localStorage === "undefined" || !localStorage) && !this.disableCookies) {
                ret = this._setCookie(this.prefix + ".local." + key, value);
            } else {
                ret = localStorage.setItem(this.prefix + "." + key, value);
            }
        } catch (err) {
            Log.error("Youbora Infinity needs localStorage or cookies, not supported by your browser.");
        }
        return ret;
    },
    /**
     * Reads from localStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     */ getLocal: function getLocal(key) {
        if (this.disabled) return null;
        return this._localGetRemove("getItem", "_getCookie", key);
    },
    /**
     * Removes from localStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     */ removeLocal: function removeLocal(key) {
        if (this.disabled) return null;
        return this._localGetRemove("removeItem", "_removeCookie", key);
    },
    _localGetRemove: function _localGetRemove(storageMethod, cookieMethod, key) {
        var ret = null;
        try {
            if (this.forceCookies || (typeof localStorage === "undefined" || !localStorage) && !this.disableCookies) {
                ret = this[cookieMethod](this.prefix + ".local." + key);
            } else {
                ret = localStorage[storageMethod](this.prefix + "." + key);
            }
        } catch (err) {
            Log.error("Youbora Infinity needs localStorage or cookies, not supported by your browser.");
        }
        return ret;
    },
    /**
     * Saves in sessionStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     * @param {string} value Value.
     */ setSession: function setSession(key, value) {
        if (this.disabled) return null;
        var ret = null;
        try {
            if (this.forceCookies || (typeof sessionStorage === "undefined" || !sessionStorage) && !this.disableCookies) {
                ret = this._setCookie(this.prefix + ".session." + key, value);
            } else {
                ret = sessionStorage.setItem(this.prefix + "." + key, value);
            }
        } catch (err) {
            Log.error("Youbora Infinity needs sessionStorage or cookies, not supported by your browser.");
        }
        return ret;
    },
    /**
     * Reads from sessionStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     */ getSession: function getSession(key) {
        if (this.disabled) return null;
        return this._sessionGetRemove("getItem", "_getCookie", key);
    },
    /**
   * Removes from sessionStorage or equivalent
   *
   * @param {string} key Key of the value. prefix will be appended.
   */ removeSession: function removeSession(key) {
        if (this.disabled) return null;
        return this._sessionGetRemove("removeItem", "_removeCookie", key);
    },
    _sessionGetRemove: function _sessionGetRemove(storageMethod, cookieMethod, key) {
        var ret = null;
        try {
            if (this.forceCookies || (typeof sessionStorage === "undefined" || !sessionStorage) && !this.disableCookies) {
                ret = this[cookieMethod](this.prefix + ".session." + key);
            } else {
                ret = sessionStorage[storageMethod](this.prefix + "." + key);
            }
        } catch (err) {
            Log.error("Youbora Infinity needs sessionStorage or cookies, not supported by your browser.");
        }
        return ret;
    },
    /**
     * Calls getSession and getLocal for the same key
     * @param {string} key Key of the value. prefix will be appended.
     */ getStorages: function getStorages(key) {
        return this.getSession(key) || this.getLocal(key);
    },
    /**
     * Calls getSession and getLocal with the same key and value
     * @param {string} key Key of the value. prefix will be appended.
     * @param {string} value Value.
     */ setStorages: function setStorages(key, value) {
        this.setSession(key, value);
        this.setLocal(key, value);
    },
    /**
     * Calls getSession and getLocal for the same key
     * @param {string} key Key of the value. prefix will be appended.
     */ removeStorages: function removeStorages(key) {
        this.removeSession(key);
        this.removeLocal(key);
    },
    // Private cookies methods
    /**
   * Sets a cookie value
   *
   * @param {string} cname Key of the value.
   * @param {Object} cvalue Value.
   */ _setCookie: function _setCookie(cname, cvalue) {
        if (typeof document !== "undefined") {
            var domain = ";";
            if (typeof location !== "undefined") {
                domain += "domain=" + location.host.split(".").reverse().splice(0, 2).reverse().join(".") + ";path=/;";
            }
            document.cookie = cname + "=" + cvalue + domain;
        }
    },
    /**
   * Gets a cookie value
   *
   * @param {string} cname Key of the value.
   */ _getCookie: function _getCookie(cname) {
        if (typeof document !== "undefined") {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for(var i = 0; i < ca.length; i++){
                var c = ca[i];
                while(c.charAt(0) === " "){
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
        }
        return null;
    },
    /**
   * Removes a cookie
   *
   * @param {string} cname Key of the value.
   */ _removeCookie: function _removeCookie(cname) {
        this._setCookie(cname, "");
    }
});
module.exports = YouboraStorage;


/***/ }),

/***/ 5571:
/***/ ((module, exports, __webpack_require__) => {

/* eslint no-extend-native: "off" */ /**
 * When executed, this function applies polyfills to the following functionalities:
 * Function.prototype.bind and
 * Array.prototype.forEach.
 *
 * @memberof youbora
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var applyPolyfills = function applyPolyfills() {
    // Bind, changed for compatibility
    Function.prototype.bind = Function.prototype.bind || function(context) {
        var slice = Array.prototype.slice;
        var func = this;
        var args = slice.call(arguments, 1);
        function bound() {
            var invokedAsConstructor = func.prototype && this instanceof func;
            return func.apply(!invokedAsConstructor && context || this, args.concat(slice.call(arguments)) // eslint-disable-line no-mixed-operators
            );
        }
        bound.prototype = func.prototype;
        return bound;
    };
    // Foreach
    Array.prototype.forEach = Array.prototype.forEach || function(callback, thisArg) {
        if (typeof callback !== "function") {
            throw new TypeError(callback + " is not a function!");
        }
        var len = this.length;
        for(var i = 0; i < len; i++){
            callback.call(thisArg, this[i], i, this);
        }
    };
    // Trunc
    Math.trunc = Math.trunc || function(x) {
        if (isNaN(x)) {
            return NaN;
        }
        if (x > 0) {
            return Math.floor(x);
        }
        return Math.ceil(x);
    };
};
module.exports = applyPolyfills;


/***/ }),

/***/ 68658:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(45538);
var YouboraObject = __webpack_require__(831);
var Log = __webpack_require__(39610);
var ProductAnalyticsConfig = __webpack_require__(21499);
var ProductAnalyticsUserState = __webpack_require__(7255);
var YouboraProductAnalytics = YouboraObject.extend(/** @lends youbora.ProductAnalytics.prototype */ {
    /**
     * This class is the base of productanalytics. Every plugin will have an instance.
     *
     * @param {youbora.Plugin} plugin Parent plugin.
     *
     * @constructs youbora.ProductAnalytics
     * @extends youbora.Emitter
     * @memberof youbora
     */ constructor: function constructor(plugin) {
        /** Parent {@link youbora.Plugin} reference. */ this._plugin = typeof plugin === "undefined" ? null : plugin;
        this._infinity = this._plugin && this._plugin.infinity ? this._plugin.infinity : null;
        this._initialized = false;
        // Product analytics attributes
        this._productAnalyticsSettingsDefault = {
            autoTrackNavigation: true,
            autoTrackAttribution: true,
            highlightContentAfter: 1000,
            enableStateTracking: false,
            activeStateTimeout: 30000,
            activeStateDimension: 9,
            pageRules: []
        };
        this._productAnalyticsSettings = Object.assign({}, this._productAnalyticsSettingsDefault);
        this._page = null;
        this._userState = null;
        this._config = null;
        this._searchQuery = null;
        this._url = null;
        if (typeof window !== "undefined" && typeof window.location !== "undefined") {
            try {
                this._url = new URL(window.location);
            } catch (ex) {}
        }
        this._contentHighlighted = null;
        this._contentHighlightTimeout = null;
        this._pendingVideoEvents = [];
        if (!this._plugin) {
            Log.warn("Plugin reference unset.");
        }
        if (!this._infinity) {
            Log.warn("Infinity reference unset.");
        }
        if (!this._url) {
            Log.warn("URL reference unset.");
        }
    },
    /**
      * Initializes product analytics
      * @param {Object} productAnalyticsSettings product analytics settings
      * @param {Object} [sessionDimensions] Dimensions to track in the session
      */ initialize: function initialize(productAnalyticsSettings, sessionDimensions) {
        var query;
        // Load settings
        this._productAnalyticsSettings = Object.assign({}, this._productAnalyticsSettingsDefault);
        if (typeof productAnalyticsSettings === "object") {
            Object.assign(this._productAnalyticsSettings, productAnalyticsSettings);
        }
        // Validate settings
        if (typeof this._productAnalyticsSettings.autoTrackNavigation !== "boolean") {
            this._productAnalyticsSettings.autoTrackNavigation = this._productAnalyticsSettingsDefault.autoTrackNavigation;
        }
        if (typeof this._productAnalyticsSettings.autoTrackAttribution !== "boolean") {
            this._productAnalyticsSettings.autoTrackAttribution = this._productAnalyticsSettingsDefault.autoTrackAttribution;
        }
        if (typeof this._productAnalyticsSettings.highlightContentAfter !== "number") {
            this._productAnalyticsSettings.highlightContentAfter = this._productAnalyticsSettingsDefault.highlightContentAfter;
        } else if (this._productAnalyticsSettings.highlightContentAfter < 1000) {
            Log.warn("Invalid higlightContentAfter value. Using default value instead.");
            this._productAnalyticsSettings.highlightContentAfter = this._productAnalyticsSettingsDefault.highlightContentAfter;
        }
        if (typeof this._productAnalyticsSettings.enableStateTracking !== "boolean") {
            this._productAnalyticsSettings.enableStateTracking = this._productAnalyticsSettingsDefault.enableStateTracking;
        }
        if (typeof this._productAnalyticsSettings.activeStateTimeout !== "number") {
            this._productAnalyticsSettings.activeStateTimeout = this._productAnalyticsSettingsDefault.activeStateTimeout;
        }
        if (typeof this._productAnalyticsSettings.activeStateDimension !== "number" || this._productAnalyticsSettings.activeStateDimension < 1 || this._productAnalyticsSettings.activeStateDimension > 9) {
            this._productAnalyticsSettings.activeStateDimension = this._productAnalyticsSettingsDefault.activeStateDimension;
        }
        if (typeof this._productAnalyticsSettings.pageRules === "undefined" || !Array.isArray(this._productAnalyticsSettings.pageRules)) {
            this._productAnalyticsSettings.pageRules = this._productAnalyticsSettingsDefault.pageRules;
        }
        // Identify current page
        this._config = new ProductAnalyticsConfig(this._fireEvent.bind(this));
        this._identify();
        // Set as initialized
        this._initialized = true;
        /*
        SPA: initialize will be called once at the beginning of the execution. Here we will start a brand new session.
        Non-SPA: initialize will be called on every page load. We must not close the previous session since, otherwise, we will have one-page sessions.
        This is why we are calling here `this._infinity.begin` instead of `this.newSession`.
      */ if (this._infinity) {
            var dimensions = {};
            if (sessionDimensions) {
                Object.assign(dimensions, sessionDimensions);
            }
            Object.assign(dimensions, {
                route: this._url === null ? "" : this._url.href,
                page: this._page
            });
            this._infinity.begin(dimensions);
        } else {
            Log.warn("Cannot open a new session since infinity is unavailable");
        }
        // Track navigation
        if (this._productAnalyticsSettings.autoTrackNavigation) {
            if (typeof window === "undefined") {
                Log.warn("Cannot track user state since DOM is not available.");
            } else {
                window.removeEventListener("pageshow", this._trackNavigationCached);
                window.addEventListener("pageshow", this._trackNavigationCached.bind(this));
            }
            this._trackNavigation();
        }
        // Track attribution
        if (this._productAnalyticsSettings.autoTrackAttribution) {
            query = this._url === null ? "" : this._url.search;
            this._trackAttribution(new URLSearchParams(query));
        }
    },
    /**
     * Identify current page
     * @private
     */ _identify: function _identify() {
        var regex;
        var r;
        var i;
        // Try to identify using config approach
        if (this._config === null) {
            this._page = null;
        } else {
            this._page = this._config.identify(this._url);
        }
        // Try to identify using pageRules setting
        for(i = 0; i < this._productAnalyticsSettings.pageRules.length && this._page === null && this._url !== null; i++){
            r = this._productAnalyticsSettings.pageRules[i];
            if (typeof r.rule !== "undefined" && typeof r.page !== "undefined") {
                try {
                    regex = new RegExp(r.rule);
                } catch (ex) {
                    regex = null;
                    Log.warn("Error processing rule", r.rule, r.page);
                }
                if (regex !== null && this._url.pathname.match(regex) !== null) {
                    this._page = this._url.pathname.replace(regex, r.page);
                }
            }
        }
        // If identication has failed, set pathname as page name
        if (this._page === null && this._url !== null) {
            this._page = this._url.pathname;
        }
    },
    // ---------------------------------------------------------------------------------------------
    // ADAPTER
    // ---------------------------------------------------------------------------------------------
    /**
      * Track adapter start
      * @private
      */ _adapterTrackStart: function _adapterTrackStart() {
        if (this._initialized) {
            this.trackPlayerInteraction("start", {}, {}, true);
        }
    },
    /**
      * Execute after adapter is set to plugin
      */ adapterAfterSet: function adapterAfterSet() {
        var adapter;
        if (this._initialized) {
            // Set active state
            if (this._productAnalyticsSettings.enableStateTracking) {
                if (this._userState !== null) {
                    Log.warn("userState is already initialized.");
                }
                if (!this._plugin) {
                    Log.warn("Cannot track user state since plugin is unavailable.");
                } else if (!this._plugin.setOptions) {
                    Log.warn("Cannot track user state since plugin options are unavailable.");
                } else {
                    this._userState = new ProductAnalyticsUserState(this._productAnalyticsSettings.activeStateDimension, this._productAnalyticsSettings.activeStateTimeout, this._fireAdapterEvent.bind(this), this._plugin.setOptions.bind(this._plugin));
                }
            } else {
                this._userState = null;
            }
            // Track player interaction
            adapter = this._adapterGet();
            if (adapter) {
                adapter.on("start", this._adapterTrackStart.bind(this));
            } else {
                Log.warn("Cannot bind adapter start since it is unavailable.");
            }
        }
    },
    /**
      * Execute before removing adapter from plugin
      */ adapterBeforeRemove: function adapterBeforeRemove() {
        var adapter;
        adapter = this._adapterGet();
        if (adapter) {
            adapter.off("start", this._adapterTrackStart);
        } else if (this._initialized) {
            Log.warn("Cannot unbind adapter start since it is unavailable.");
        }
        if (this._userState) {
            this._userState.dispose();
        }
        this._userState = null;
        this._pendingVideoEvents = [];
    },
    /**
      * Get adapter
      * @private
      */ _adapterGet: function _adapterGet() {
        var adapter;
        if (!this._plugin) {
            adapter = null;
        } else if (typeof this._plugin.getAdapter !== "function") {
            adapter = null;
        } else {
            adapter = this._plugin.getAdapter();
        }
        return typeof adapter === "undefined" ? null : adapter;
    },
    // ---------------------------------------------------------------------------------------------
    // SESSION
    // ------------------------------------------------------------------------------------------------------------------------------
    /**
      * New user session
      */ newSession: function newSession(dimensions) {
        var executed = false;
        if (!this._initialized) {
            Log.warn("Cannot start a new session since Product Analytics is uninitialized.");
        } else if (!this._infinity) {
            Log.warn("Cannot start a new session since infinity is unavailable.");
        } else {
            // Close previous session and open a new one
            this._infinity.newSession(undefined, dimensions);
            executed = true;
        }
        return executed;
    },
    /**
      * Ends user session
      */ endSession: function endSession(sessionDimensions) {
        var executed = false;
        if (!this._initialized) {
            Log.warn("Cannot end session since Product Analytics is uninitialized.");
        } else if (!this._infinity) {
            Log.warn("Cannot end session since infinity is unavailable.");
        } else {
            var params = null;
            if (sessionDimensions) {
                params = {
                    params: {
                        dimensions: {}
                    }
                };
                Object.assign(params.params.dimensions, sessionDimensions);
            }
            this._infinity.fireSessionStop(params);
            executed = true;
        }
        return executed;
    },
    // ---------------------------------------------------------------------------------------------
    // LOGIN / LOGOUT
    // ---------------------------------------------------------------------------------------------
    /**
      * Successful login
      * @param {string} userId The unique identifier of the user
      * @param {string} [profileId] The unique identifier of the profile
      * @param {string} [profileType] The profile type
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      * @param {Object} [sessionDimensions] Dimensions to track in the session
      */ loginSuccessful: function loginSuccessful(userId, profileId, profileType, dimensions, metrics, sessionDimensions) {
        var options;
        if (!this._checkState("log in successfully")) {
        // Product Analytics is not ready for sending events
        } else if (typeof userId !== "string" && typeof userId !== "number") {
            Log.warn("Cannot log in successfully since userId is unavailable.");
        } else if (userId === "") {
            Log.warn("Cannot log in successfully since userId is unset.");
        } else {
            // Send user login event
            this._fireEvent("User Login Successful", YouboraProductAnalytics.EventTypes.user, {
                username: userId
            }, dimensions, metrics);
            // Send profile selection event (in case it has been supplied)
            if (typeof profileId === "undefined" || profileId === "") {
                profileId = null;
            }
            if (profileId !== null) {
                this._userProfileSelectedEvent(profileId, profileType, dimensions, metrics);
            }
            // Set the userId (and profileId) options
            options = {
                username: userId
            };
            if (profileId !== null) {
                options["user.profileId"] = profileId;
            }
            this._plugin.setOptions(options);
            // Close the current session and start a new one
            this.newSession(sessionDimensions);
        }
    },
    /**
      * Login unsuccessful
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ loginUnsuccessful: function loginUnsuccessful(dimensions, metrics) {
        if (!this._checkState("log in unsuccessful")) {
        // Product Analytics is not ready for sending events
        } else {
            // Send an event informing that we are closing the session because of a profile change
            this._fireEvent("User Login Unsuccessful", YouboraProductAnalytics.EventTypes.user, {}, dimensions, metrics);
        }
    },
    /**
      * Logout
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      * @param {Object} [sessionDimensions] Dimensions to track in the session
      */ logout: function logout(dimensions, metrics, sessionDimensions) {
        var options;
        if (!this._checkState("log out")) {
        // Product Analytics is not ready for sending events
        } else {
            // Send an event informing that we are closing the session
            this._fireEvent("User Logout", YouboraProductAnalytics.EventTypes.user, {}, dimensions, metrics);
            // Set the userId (and profileId) options
            options = {
                username: null
            };
            options["user.profileId"] = null;
            this._plugin.setOptions(options);
            // Close the current session and start a new one
            this.newSession(sessionDimensions);
        }
    },
    // ---------------------------------------------------------------------------------------------
    // PROFILE
    // ---------------------------------------------------------------------------------------------
    /**
      * User profile created
      * @param {string} profileId The unique identifier of the profile
      * @param {string} [profileType] The profile type
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ userProfileCreated: function userProfileCreated(profileId, profileType, dimensions, metrics) {
        var dimensionsInternal;
        if (!this._checkState("create user profile")) {
        // Product Analytics is not ready for sending events
        } else if (typeof profileId !== "string" && typeof profileId !== "number") {
            Log.warn("Cannot create user profile since profileId is unavailable.");
        } else if (profileId === "") {
            Log.warn("Cannot create user profile since profileId is unset.");
        } else {
            dimensionsInternal = this._getUserProfileDimensions(profileId, profileType);
            this._fireEvent("User Profile Created", YouboraProductAnalytics.EventTypes.userProfile, dimensionsInternal, dimensions, metrics);
        }
    },
    /**
      * User profile selected
      * @param {string} profileId The unique identifier of the profile
      * @param {string} [profileType] The profile type
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      * @param {Object} [sessionDimensions] Dimensions to track in the session
      */ userProfileSelected: function userProfileSelected(profileId, profileType, dimensions, metrics, sessionDimensions) {
        var options;
        if (!this._checkState("select user profile")) {
        // Product Analytics is not ready for sending events
        } else if (typeof profileId !== "string" && typeof profileId !== "number") {
            Log.warn("Cannot select user profile since profileId is unavailable.");
        } else if (profileId === "") {
            Log.warn("Cannot select user profile since profileId is unset.");
        } else {
            // Send an event informing that we are closing the session because of a profile change
            this._userProfileSelectedEvent(profileId, profileType, dimensions, metrics);
            // Set the profileId option
            options = {
                "user.profileId": profileId
            };
            this._plugin.setOptions(options);
            // Close the current session and open a new one
            this.newSession(sessionDimensions);
        }
    },
    /**
      * Fire user profile selected event
      * @param {string} profileId The unique identifier of the profile
      * @param {string} [profileType] The profile type
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      * @private
      */ _userProfileSelectedEvent: function _userProfileSelectedEvent(profileId, profileType, dimensions, metrics) {
        var dimensionsInternal;
        dimensionsInternal = this._getUserProfileDimensions(profileId, profileType);
        this._fireEvent("User Profile Selected", YouboraProductAnalytics.EventTypes.userProfile, dimensionsInternal, dimensions, metrics);
    },
    /**
      * User profile deleted
      * @param {string} profileId The unique identifier of the profile
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ userProfileDeleted: function userProfileDeleted(profileId, dimensions, metrics) {
        var dimensionsInternal;
        if (!this._checkState("delete user profile")) {
        // Product Analytics is not ready for sending events
        } else if (typeof profileId !== "string" && typeof profileId !== "number") {
            Log.warn("Cannot delete user profile since profileId is unavailable.");
        } else if (profileId === "") {
            Log.warn("Cannot delete user profile since profileId is unset.");
        } else {
            dimensionsInternal = this._getUserProfileDimensions(profileId, null);
            this._fireEvent("User Profile Deleted", YouboraProductAnalytics.EventTypes.userProfile, dimensionsInternal, dimensions, metrics);
        }
    },
    /**
     * Get user profile dimensions
     * @param {string} profileId
     * @param {string} profileType
     * @returns
     * @private
     */ _getUserProfileDimensions: function _getUserProfileDimensions(profileId, profileType) {
        var dimensions;
        dimensions = {
            profileId: profileId
        };
        if (typeof profileType !== "undefined" && profileType !== null) {
            dimensions.profileType = profileType;
        }
        return dimensions;
    },
    // ---------------------------------------------------------------------------------------------
    // NAVIGATION
    // ---------------------------------------------------------------------------------------------
    /**
      * Tracks navigation by route
      * @param {string} route The URL of the current page
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackNavByRoute: function trackNavByRoute(route, dimensions, metrics) {
        if (!this._checkState("track navigation")) {
        // Product Analytics is not ready for sending events
        } else if (typeof route !== "string" || route === "") {
            Log.warn("Cannot track navigation since route has not been supplied.");
        } else {
            var url;
            try {
                url = new URL(route);
            } catch (ex) {
                url = null;
            }
            if (url === null) {
                Log.warn("Cannot track navigation since route is invalid.");
            } else {
                this._url = url;
                this._identify();
                this._trackNavigation(dimensions, metrics);
            }
        }
    },
    /**
      * Tracks navigation
      * @param {string} pageName The unique name to identify a page of the application.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackNavByName: function trackNavByName(pageName, dimensions, metrics) {
        if (!this._checkState("track navigation")) {
        // Product Analytics is not ready for sending events
        } else if (typeof pageName !== "string" || pageName === "") {
            Log.warn("Cannot track navigation since page has not been supplied.");
        } else {
            this._page = pageName;
            this._trackNavigation(dimensions, metrics);
        }
    },
    /**
      * Automatically tracks navigation when page is cached by browser
      * @param {Object} event
      * @private
      */ _trackNavigationCached: function _trackNavigationCached(event) {
        if (event.persisted) {
            this._trackNavigation();
        }
    },
    /**
      * Tracks navigation (either manually or automatically)
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      * @private
      */ _trackNavigation: function _trackNavigation(dimensions, metrics) {
        var route;
        var path;
        var host;
        // Get UTM Options
        if (this._url === null) {
            route = "";
            path = "";
            host = "";
        } else {
            route = this._url.href;
            path = this._url.pathname;
            host = this._url.hostname;
        }
        if (!this._checkState("track navigation")) {
        // Product Analytics is not ready for sending events
        } else {
            this._fireEvent("paNavigation", YouboraProductAnalytics.EventTypes.navigation, {
                paRoute: path,
                paRouteDomain: host,
                paFullRoute: route,
                paReferrer: this._plugin.getReferral() || ""
            }, dimensions, metrics, true);
        }
    },
    // ---------------------------------------------------------------------------------------------
    // ATTRIBUTION
    // ---------------------------------------------------------------------------------------------
    /**
      * Tracks attribution
      * @param {string} utmSource The UTM Source parameter. It is commonly used to identify a search engine, newsletter, or other source (i.e., Google, Facebook, etc.).
      * @param {string} utmMedium The UTM Medium parameter. It is commonly used to identify a medium such as email or cost-per-click (cpc).
      * @param {string} utmCampaign The UTM Campaign parameter. It is commonly used for campaign analysis to identify a specific product promotion or strategic campaign (i.e., spring sale).
      * @param {string} utmTerm The UTM Term parameter. It is commonly used with paid search to supply the keywords for ads (i.e., Customer, NonBuyer, etc.).
      * @param {string} utmContent The UTM Content parameter. It is commonly used for A/B testing and content-targeted ads to differentiate ads or links that point to the same URL (i.e., Banner1, Banner2, etc.)
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackAttribution: function trackAttribution(utmSource, utmMedium, utmCampaign, utmTerm, utmContent, dimensions, metrics) {
        if (!this._checkState("track attribution")) {
        // Product Analytics is not ready for sending events
        } else if (this._productAnalyticsSettings.autoTrackAttribution) {
            Log.warn("Automatic attribution tracking is enabled: this request won't be processed.");
        } else {
            var params;
            params = {};
            if (typeof utmSource !== "undefined") params.utm_source = utmSource;
            if (typeof utmMedium !== "undefined") params.utm_medium = utmMedium;
            if (typeof utmCampaign !== "undefined") params.utm_campaign = utmCampaign;
            if (typeof utmTerm !== "undefined") params.utm_term = utmTerm;
            if (typeof utmContent !== "undefined") params.utm_content = utmContent;
            this._trackAttribution(new URLSearchParams(params), dimensions, metrics);
        }
    },
    /**
      * Tracks attribution (either manually or automatically)
      * @param {URLSearchParams} params Object where to look for UTM params.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      * @private
      */ _trackAttribution: function _trackAttribution(params, dimensions, metrics) {
        // Get UTM parameters
        var utmParams = this._getUTMParams(params);
        var url = this._url === null ? "" : this._url.href;
        // Track attribution
        if (!this._checkState("track attribution")) {
        // Product Analytics is not ready for sending events
        } else if (utmParams) {
            this._fireEvent("Attribution", YouboraProductAnalytics.EventTypes.attribution, Object.assign({
                utmUrl: url
            }, utmParams), dimensions, metrics);
        }
    },
    /**
     * Retrieves UTM params from querystring (utm_source, utm_medium, utm_campaign, utm_term, utm_content) and returns an object containing them but
     * with key formatted as specified.
     * @param {URLSearchParams} params Object where to look for UTM params
     * @returns {{}}
     * @private
     */ _getUTMParams: function _getUTMParams(params) {
        var utmParams;
        var keys;
        var key;
        keys = {
            utm_source: "utmSource",
            utm_medium: "utmMedium",
            utm_campaign: "utmCampaign",
            utm_term: "utmTerm",
            utm_content: "utmContent"
        };
        utmParams = {};
        // Look for UTM params and add them to the newly constructed object converting key as specified
        params.forEach(function(paramValue, paramKey) {
            key = keys[paramKey.toLowerCase()];
            if (typeof key !== "undefined") {
                utmParams[key] = paramValue;
            }
        });
        return Object.keys(utmParams).length > 0 ? utmParams : null;
    },
    // ---------------------------------------------------------------------------------------------
    // SECTION
    // ---------------------------------------------------------------------------------------------
    /**
      * Section goes into viewport.
      * @param {string} section The section title. It is commonly used to indicate the section title presented over a grid layout (e.g. Recommended Movies, Continue Watching, etc).
      * @param {integer} sectionOrder The section order within the page.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackSectionVisible: function trackSectionVisible(section, sectionOrder, dimensions, metrics) {
        if (!this._checkState("track section visible")) {
        // Product Analytics is not ready for sending events
        } else if (typeof section !== "string" || section === "") {
            Log.warn("Cannot track section visible since no section has been supplied.");
        } else if (typeof sectionOrder !== "number" || sectionOrder < 1) {
            Log.warn("Cannot track section visible since sectionOrder is invalid.");
        } else {
            this._fireEvent("Section Visible", YouboraProductAnalytics.EventTypes.section, {
                sectionOrder: sectionOrder,
                section: section
            }, dimensions, metrics);
        }
    },
    /**
      * Section goes out of viewport.
      * @param {string} section The section title. It is commonly used to indicate the section title presented over a grid layout (e.g. Recommended Movies, Continue Watching, etc).
      * @param {integer} sectionOrder The section order within the page.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackSectionHidden: function trackSectionHidden(section, sectionOrder, dimensions, metrics) {
        if (!this._checkState("track section hidden")) {
        // Product Analytics is not ready for sending events
        } else if (typeof section !== "string" || section === "") {
            Log.warn("Cannot track section hidden since no section has been supplied.");
        } else if (typeof sectionOrder !== "number" || sectionOrder < 1) {
            Log.warn("Cannot track section hidden since sectionOrder is invalid.");
        } else {
            this._fireEvent("Section Hidden", YouboraProductAnalytics.EventTypes.section, {
                sectionOrder: sectionOrder,
                section: section
            }, dimensions, metrics);
        }
    },
    // ---------------------------------------------------------------------------------------------
    // CONTENT
    // ---------------------------------------------------------------------------------------------
    /**
      * Sends a content highlight event if content is focused during, at least, highlightContentAfter ms.
      * @param {string} section The section title. It is commonly used to indicate the section title presented over a grid layout (e.g. Recommended Movies, Continue Watching, etc).
      * @param {integer} sectionOrder The section order within the page.
      * @param {integer} column Used to indicate the column number where content is placed in a grid layout The first column is number 1.
      * @param {integer} row Used to indicate the row number where content is placed in a grid layout. The first row is number 1. In the case of a horizontal list instead of a grid, the row parameter should be set to 1.
      * @param {string} contentID The unique content identifier of the content linked.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ contentFocusIn: function contentFocusIn(section, sectionOrder, column, row, contentID, dimensions, metrics) {
        this.contentFocusOut();
        if (!this._checkState("track content highlight")) {
        // Product Analytics is not ready for sending events
        } else if (typeof section !== "string" || section === "") {
            Log.warn("Cannot track content highlight since no section has been supplied.");
        } else if (typeof sectionOrder !== "number" || sectionOrder < 1) {
            Log.warn("Cannot track content highlight since sectionOrder is invalid.");
        } else if (typeof column !== "number" || column < 1) {
            Log.warn("Cannot track content highlight since column is invalid.");
        } else if (typeof row !== "number" || row < 1) {
            Log.warn("Cannot track content highlight since row is invalid.");
        } else if (typeof contentID !== "string" || contentID === "") {
            Log.warn("Cannot track content highlight since no contentID has been supplied.");
        } else {
            this._contentHighlighted = {
                sectionOrder: sectionOrder,
                section: section,
                column: column,
                row: row,
                contentID: contentID,
                dimensions: dimensions,
                metrics: metrics
            };
            this._contentHighlightTimeout = setTimeout(this._trackContentHiglight.bind(this), this._productAnalyticsSettings.highlightContentAfter);
        }
    },
    /**
      * Content loses focus
      * @private
      */ contentFocusOut: function contentFocusOut() {
        if (this._contentHighlightTimeout !== null) {
            clearTimeout(this._contentHighlightTimeout);
        }
        this._contentHighlighted = null;
        this._contentHighlightTimeout = null;
    },
    /**
      * Sends a content highlight event using selected content info
      * @private
      */ _trackContentHiglight: function _trackContentHiglight() {
        if (this._contentHighlighted) {
            this._fireEvent("Section Content Highlight", YouboraProductAnalytics.EventTypes.section, {
                sectionOrder: this._contentHighlighted.sectionOrder,
                section: this._contentHighlighted.section,
                column: this._contentHighlighted.column,
                row: this._contentHighlighted.row,
                contentId: this._contentHighlighted.contentID
            }, this._contentHighlighted.dimensions, this._contentHighlighted.metrics);
        } else {
            Log.warn("Cannot highlight content since no content is selected");
        }
    },
    /**
      * Tracks the location of user clicks.
      * @param {string} section The section title. It is commonly used to indicate the section title presented over a grid layout (e.g. Recommended Movies, Continue Watching, etc).
      * @param {integer} sectionOrder The section order within the page.
      * @param {integer} column Used to indicate the column number where content is placed in a grid layout The first column is number 1.
      * @param {integer} row Used to indicate the row number where content is placed in a grid layout. The first row is number 1. In the case of a horizontal list instead of a grid, the row parameter should be set to 1.
      * @param {string} contentID The unique content identifier of the content linked.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackContentClick: function trackContentClick(section, sectionOrder, column, row, contentID, dimensions, metrics) {
        if (!this._checkState("track content click")) {
        // Product Analytics is not ready for sending events
        } else if (typeof section !== "string" || section === "") {
            Log.warn("Cannot track content click since no section has been supplied.");
        } else if (typeof sectionOrder !== "number" || sectionOrder < 1) {
            Log.warn("Cannot track content click since sectionOrder is invalid.");
        } else if (typeof column !== "number" || column < 1) {
            Log.warn("Cannot track content click since column is invalid.");
        } else if (typeof row !== "number" || row < 1) {
            Log.warn("Cannot track content click since row is invalid.");
        } else if (typeof contentID !== "string" || contentID === "") {
            Log.warn("Cannot track content click since no contentID has been supplied.");
        } else {
            this._fireEvent("Section Content Click", YouboraProductAnalytics.EventTypes.section, {
                sectionOrder: sectionOrder,
                section: section,
                column: column,
                row: row,
                contentId: contentID
            }, dimensions, metrics);
        }
    },
    // ---------------------------------------------------------------------------------------------
    // CONTENT PLAYBACK
    // ---------------------------------------------------------------------------------------------
    /**
      * Tracks when a content starts playing be it automatically or through a user interaction.
      * @param {string} contentID The unique content identifier of the content being played.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackPlay: function trackPlay(contentID, dimensions, metrics) {
        var eventName = "Content Play";
        if (!this._checkState("track play")) {
        // Product Analytics is not ready for sending events
        } else if (typeof contentID !== "string" || contentID === "") {
            Log.warn("Cannot track play since no contentID has been supplied.");
        } else if (!this._plugin.isStarted) {
            this._pendingVideoEvents.push({
                eventName: eventName,
                contentID: contentID,
                dimensions: dimensions,
                metrics: metrics
            });
        } else {
            this._trackPlayerEventsPending();
            this._trackPlayerEvent(eventName, contentID, dimensions, metrics);
        }
    },
    /**
      * Tracks content watching events.
      * TODO: add (2nd) argument to tell whether user state must be updated or not
      * @param {string} eventName The name of the interaction (i.e., Pause, Seek, Skip Intro, Skip Ads, Switch Language, etc.).
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      * @param {boolean} [startEvent] Internal param informing that current interaction is responsible of first player start
      */ trackPlayerInteraction: function trackPlayerInteraction(eventName, dimensions, metrics, startEvent) {
        var eventNameComplete = "Content Play " + eventName;
        var contentID = null;
        if (!this._checkState("track player interaction")) {
        // Product Analytics is not ready for sending events
        } else if (typeof eventName !== "string" || eventName === "") {
            Log.warn("Cannot track player interaction since no interaction name has been supplied.");
        } else if (!this._plugin.isStarted) {
            this._pendingVideoEvents.push({
                eventName: eventNameComplete,
                contentID: contentID,
                dimensions: dimensions,
                metrics: metrics,
                startEvent: startEvent
            });
        } else {
            this._trackPlayerEventsPending();
            this._trackPlayerEvent(eventNameComplete, contentID, dimensions, metrics, startEvent);
        }
    },
    /**
     * Track player pending events
     */ _trackPlayerEventsPending: function _trackPlayerEventsPending() {
        this._pendingVideoEvents.forEach((function(event) {
            this._trackPlayerEvent(event.eventName, event.contentID, event.dimensions, event.metrics, event.startEvent);
        }).bind(this));
        this._pendingVideoEvents = [];
    },
    /**
     * Track player event
     * @param {*} eventName
     * @param {*} contentID
     * @param {*} dimensions
     * @param {*} metrics
     * @param {*} startEvent
     */ _trackPlayerEvent: function _trackPlayerEvent(eventName, contentID, dimensions, metrics, startEvent) {
        // Prepare arguments
        if (typeof startEvent !== "boolean") {
            startEvent = false;
        }
        // Prepare dimensions
        var dimensionsInternal = {};
        if (contentID !== null) {
            dimensionsInternal.contentId = contentID;
        }
        // Fire event
        this._fireAdapterEvent(eventName, dimensionsInternal, dimensions, metrics);
        // Transition state to active
        if (this._userState !== null && !startEvent) {
            this._userState.setActive(eventName);
        }
    },
    // ---------------------------------------------------------------------------------------------
    // CONTENT SEARCH
    // ---------------------------------------------------------------------------------------------
    /**
      * Tracks search query events.
      * @param {string} searchQuery The search term entered by the user.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackSearchQuery: function trackSearchQuery(searchQuery, dimensions, metrics) {
        if (!this._checkState("track search query")) {
        // Product Analytics is not ready for sending events
        } else if (typeof searchQuery !== "string" || searchQuery === "") {
            Log.warn("Cannot track search query since no searchQuery has been supplied.");
        } else {
            this._searchQuery = searchQuery;
            this._fireEvent("Search Query", YouboraProductAnalytics.EventTypes.search, {
                query: this._searchQuery
            }, dimensions, metrics);
        }
    },
    /**
      * Tracks search result events.
      * @param {integer} resultCount The number of search results returned by a search query.
      * @param {String} [searchQuery] The search term entered by the user.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackSearchResult: function trackSearchResult(resultCount, searchQuery, dimensions, metrics) {
        if (!this._checkState("track search result")) {
        // Product Analytics is not ready for sending events
        } else if (typeof resultCount !== "number") {
            Log.warn("Cannot track search result since no resultCount has been supplied.");
        } else {
            var query = typeof searchQuery === "string" && searchQuery !== "" ? searchQuery : this._searchQuery;
            this._fireEvent("Search Results", YouboraProductAnalytics.EventTypes.search, {
                query: query,
                resultCount: resultCount
            }, dimensions, metrics);
        }
    },
    /**
      * Tracks user interactions with search results.
      * @param {string} section The section title. It is commonly used to indicate the section title presented over a grid layout (e.g. Recommended Movies, Continue Watching, etc).
      * @param {integer} sectionOrder The section order within the page.
      * @param {integer} column The content placement column. It is commonly used to indicate the column number where content is placed in a grid layout (i.e.1, 2, etc..).
      * @param {integer} row The content placement row. It is commonly used to indicate the row number where content is placed in a grid layout (i.e.1, 2, etc..).
      * @param {string} contentID The content identifier. It is used for internal content unequivocally identification (i.e., AAA000111222).
      * @param {String} [searchQuery] The search term entered by the user.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackSearchClick: function trackSearchClick(section, sectionOrder, column, row, contentID, searchQuery, dimensions, metrics) {
        if (!this._checkState("track search click")) {
        // Product Analytics is not ready for sending events
        } else if (typeof column !== "number") {
            Log.warn("Cannot track search click since no column has been supplied.");
        } else if (typeof row !== "number") {
            Log.warn("Cannot track search click since no row has been supplied.");
        } else if (typeof contentID !== "string" || contentID === "") {
            Log.warn("Cannot track search click since no contentID has been supplied.");
        } else {
            var query = typeof searchQuery === "string" && searchQuery !== "" ? searchQuery : this._searchQuery;
            if (typeof section !== "string" || section === "") {
                section = "Search";
            }
            if (typeof sectionOrder !== "number" || sectionOrder < 1) {
                sectionOrder = 1;
            }
            this._fireEvent("Search Result Click", YouboraProductAnalytics.EventTypes.search, {
                sectionOrder: sectionOrder,
                section: section,
                query: query,
                column: column,
                row: row,
                contentId: contentID
            }, dimensions, metrics);
        }
    },
    // ---------------------------------------------------------------------------------------------
    // EXTERNAL APPLICATIONS
    // ---------------------------------------------------------------------------------------------
    /**
      * Tracks external app start events.
      * @param {string} appName The name of the application being used to deliver the content to the end-user (i.e., Netflix).
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackExternalAppLaunch: function trackExternalAppLaunch(appName, dimensions, metrics) {
        if (!this._checkState("track external application launch")) {
        // Product Analytics is not ready for sending events
        } else if (typeof appName !== "string" || appName === "") {
            Log.warn("Cannot track external application launch since no appName has been supplied.");
        } else {
            this._fireEvent("External Application Launch", YouboraProductAnalytics.EventTypes.externalApplication, {
                paExtAppName: appName
            }, dimensions, metrics);
        }
    },
    /**
      * Tracks external app stop events.
      * @param {string} appName The name of the application being used to deliver the content to the end-user (i.e., Netflix).
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackExternalAppExit: function trackExternalAppExit(appName, dimensions, metrics) {
        if (!this._checkState("track external application exit")) {
        // Product Analytics is not ready for sending events
        } else if (typeof appName !== "string" || appName === "") {
            Log.warn("Cannot track external application exit since no appName has been supplied.");
        } else {
            this._fireEvent("External Application Exit", YouboraProductAnalytics.EventTypes.externalApplication, {
                paExtAppName: appName
            }, dimensions, metrics);
        }
    },
    // ---------------------------------------------------------------------------------------------
    // ENGAGEMENT
    // ---------------------------------------------------------------------------------------------
    /**
      * Tracks engagement events.
      * @param {string} eventName The name of the engagement event (i.e., Share, Save, Rate, etc.).
      * @param {string} contentID The unique content identifier of the content the user is engaging with.
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      */ trackEngagementEvent: function trackEngagementEvent(eventName, contentID, dimensions, metrics) {
        if (!this._checkState("track engagement event")) {
        // Product Analytics is not ready for sending events
        } else if (typeof eventName !== "string" || eventName === "") {
            Log.warn("Cannot track engagement event since no eventName has been supplied.");
        } else if (typeof contentID !== "string" || contentID === "") {
            Log.warn("Cannot track engagement event since no contentID has been supplied.");
        } else {
            this._fireEvent("Engagement " + eventName, YouboraProductAnalytics.EventTypes.engagement, {
                contentId: contentID
            }, dimensions, metrics);
        }
    },
    // ---------------------------------------------------------------------------------------------
    // CUSTOM EVENT
    // ---------------------------------------------------------------------------------------------
    /**
      * Track custom event
      * @param {string} eventName Name of the event to track
      * @param {Object} [dimensions] Dimensions to track
      * @param {Object} [metrics] Metrics to track
      * @param {boolean} [hasEndDatetime] Boolean to indicate if the event has stop event too (event with duration)
      */ trackEvent: function trackEvent(eventName, dimensions, metrics, hasEndDatetime) {
        if (typeof hasEndDatetime !== "boolean") {
            hasEndDatetime = false;
        }
        if (!this._checkState("track custom event")) {
        // Product Analytics is not ready for sending events
        } else if (typeof eventName !== "string" || eventName === "") {
            Log.warn("Cannot track custom event since no eventName has been supplied.");
        } else {
            this._fireEvent("Custom " + eventName, YouboraProductAnalytics.EventTypes.custom, {}, dimensions, metrics, hasEndDatetime);
        }
    },
    // ---------------------------------------------------------------------------------------------
    // INTERNAL
    // ---------------------------------------------------------------------------------------------
    /**
      * Fires an event
      * @param {string} eventName Name of the event to be fired
      * @param {EventTypes} eventType Type of the event being tracked
      * @param {Object} dimensionsInternal Dimensions supplied by user
      * @param {Object} dimensionsUser Specific event dimensions
      * @param {Object} metrics Metrics to track
      * @param {boolean} hasEndDatetime For events with duration
      * @private
      */ _fireEvent: function _fireEvent(eventName, eventType, dimensionsInternal, dimensionsUser, metrics, hasEndDatetime) {
        var dimensions;
        var fired = false;
        Log.notice(eventName);
        if (typeof hasEndDatetime !== "boolean") {
            hasEndDatetime = false;
        }
        // Extract top level dimensions from custom dimensions
        dimensions = this._buildDimensions(eventType, dimensionsInternal, dimensionsUser);
        // Track event
        if (this._infinity) {
            this._infinity.fireEvent(eventName, dimensions.custom, metrics, dimensions.top, hasEndDatetime);
            fired = true;
        } else {
            Log.warn("Cannot fire", eventName, "since infinity is unavailable.");
        }
        return fired;
    },
    /**
      * Fires an adapter event (in case it is available)
      * @param {string} eventName Event name
      * @param {Object} dimensionsInternal Dimensions supplied by user
      * @param {Object} dimensionsUser Specific event dimensions
      * @param {Object} metrics Metrics to track
      * @private
      */ _fireAdapterEvent: function _fireAdapterEvent(eventName, dimensionsInternal, dimensionsUser, metrics) {
        var dimensions;
        var adapter;
        var fired = false;
        Log.notice(eventName);
        adapter = this._adapterGet();
        if (adapter) {
            dimensions = this._buildDimensions(YouboraProductAnalytics.EventTypes.contentPlayback, dimensionsInternal, dimensionsUser);
            adapter.fireEvent(eventName, dimensions.custom, metrics, dimensions.top);
            fired = true;
        } else {
            Log.warn("Cannot fire " + eventName + " event since adapter is unavailable.");
        }
        return fired;
    },
    /**
      * Builds a list of top level and custom dimensions
      * @param {EventTypes} eventType Type of the event being tracked
      * @param {Object} dimensionsInternal Object containing list of internal dimensions
      * @param {Object} dimensionsUser Object containing list of custom dimensions
      * @private
      */ _buildDimensions: function _buildDimensions(eventType, dimensionsInternal, dimensionsUser) {
        var dimensionsTopLevelKeys;
        var dimensionsTopLevel;
        var dimensionsCustom;
        // Build custom event dimensions
        dimensionsCustom = {
            paPage: this._page
        };
        if (typeof dimensionsInternal !== "undefined") {
            dimensionsCustom = Object.assign(dimensionsCustom, dimensionsInternal);
        }
        if (typeof dimensionsUser !== "undefined") {
            dimensionsCustom = Object.assign(dimensionsCustom, dimensionsUser);
        }
        dimensionsCustom = Object.assign(dimensionsCustom, {
            eventSource: "Product Analytics",
            eventType: eventType
        });
        // List of Top Level Dimension keys
        dimensionsTopLevelKeys = [
            "contentid",
            "contentId",
            "contentID",
            "utmSource",
            "utmMedium",
            "utmCampaign",
            "utmTerm",
            "utmContent",
            "profileId",
            "profile_id",
            "username"
        ];
        // Create object with top level dimensions
        dimensionsTopLevel = {};
        for(var key in dimensionsCustom){
            if (Object.prototype.hasOwnProperty.call(dimensionsCustom, key) && dimensionsTopLevelKeys.indexOf(key) !== -1) {
                dimensionsTopLevel[key] = dimensionsCustom[key];
            }
        }
        // Remove top level dimensions from custom dimensions list
        dimensionsTopLevelKeys.forEach(function(key) {
            delete dimensionsCustom[key];
        });
        return {
            custom: dimensionsCustom,
            top: dimensionsTopLevel
        };
    },
    /**
      * Check state before sending an event
      * @param {String} message Message to show in case validation fails
      * @private
      */ _checkState: function _checkState(message) {
        var valid;
        if (!this._initialized) {
            valid = false;
            Log.warn("Cannot " + message + " since Product Analytics is uninitialized.");
        } else if (this._infinity == null) {
            valid = false;
            Log.warn("Cannot " + message + " since infinity is unavailable.");
        } else if (!this._infinity.isActive()) {
            valid = false;
            Log.warn("Cannot " + message + " since session is closed.");
        } else {
            valid = true;
        }
        return valid;
    }
}, /** @lends youbora.ProductAnalyticsUserState */ {
    // Static Members //
    /**
     * Event Type enumeration
     * @enum
     * @event
     */ EventTypes: {
        userProfile: "User Profile",
        user: "User",
        navigation: "Navigation",
        attribution: "Attribution",
        section: "Section",
        contentPlayback: "Content Playback",
        search: "Search",
        externalApplication: "External Application",
        engagement: "Engagement",
        custom: "Custom Event"
    }
});
module.exports = YouboraProductAnalytics;


/***/ }),

/***/ 21499:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
var Log = __webpack_require__(39610);
var YouboraObject = __webpack_require__(831);
var YouboraProductAnalyticsConfig = YouboraObject.extend(/** @lends youbora.ProductAnalyticsConfig.prototype */ {
    /**
     * This class handles Product Analytics configuration.
     *
     * @param {function} fireEvent Fire Event method
     *
     * @constructs youbora.ProductAnalyticsConfig
     * @extends youbora.Object
     * @memberof youbora
     */ constructor: function constructor(fireEvent) {
        this._fireEvent = typeof fireEvent === "function" ? fireEvent : null;
        // Load npawtmConfig object
        if (typeof window === "undefined" || typeof window.npawtmConfig !== "object") {
            // Load directly from AdminAPI?: this.loadTagManager()
            this._npawtmConfig = null;
        } else {
            this._npawtmConfig = window.npawtmConfig;
        }
    },
    /**
      * Identifies current page and get events to monitor when available.
      * @param {URL} URL to be identified
      * @returns {string} Identified page name / null
      */ identify: function identify(url) {
        var events;
        var page;
        page = null;
        events = [];
        if (!this._npawtmConfig) {
            Log.warn("no config descriptor available");
        } else {
            page = this._getPage(url);
            if (page === null) {
                // No page identified: set default page name
                Log.warn("no page found");
            } else {
                // Page identified: look for bound events
                events = this._getEvents(page);
            }
        }
        // Bind events
        if (typeof window === "undefined") {
            Log.warn("Product Analytics Config: cannot bind events since DOM is not available");
        } else if (events.length > 0) {
            window.addEventListener("load", (function() {
                this._bindElements(events);
            }).bind(this));
        }
        return page;
    },
    /**
      * Looks for a page matching the supplied URL (either directly or by means of a regular expression).
      * @param {URL} url URL to look for.
      * @returns {string|*} Name of the page matching the URL or null if no matches have been found.
      * @private
      */ _getPage: function _getPage(url) {
        var urlString;
        var regexInfo;
        var pageInfo;
        var regex;
        var i;
        var page = null;
        if (typeof url === "object" && url !== null && this._npawtmConfig && this._npawtmConfig.urls && this._npawtmConfig.regexes && this._npawtmConfig.domains && this._npawtmConfig.domains.includes(url.hostname.toLowerCase())) {
            // Direct URL lookup
            pageInfo = this._npawtmConfig.urls[url.pathname];
            if (typeof pageInfo !== "undefined" && typeof pageInfo.page !== "undefined") {
                page = pageInfo.page;
            }
            // If URL lookup fails, start regex lookup
            urlString = url.pathname + url.search;
            for(i = 0; i < this._npawtmConfig.regexes.length && page === null; i++){
                regexInfo = this._npawtmConfig.regexes[i];
                regex = new RegExp(regexInfo.regex);
                if (urlString.match(regex)) {
                    page = regexInfo.page;
                }
            }
        }
        return page;
    },
    /**
      * Gets events bound to the current page.
      * @param {string} page Page name to look for.
      * @private
      */ _getEvents: function _getEvents(page) {
        var events = this._npawtmConfig && this._npawtmConfig.events ? this._npawtmConfig.events[page] : null;
        if (typeof events === "undefined" || events === null) {
            events = [];
        }
        return events;
    },
    /**
      * Binding of element events pointed out by npawtmConfig.
      * @param {Array} events List of events to bind
      * @private
      */ _bindElements: function _bindElements(events) {
        var eventInfo;
        var eventType;
        var element;
        var j;
        var i;
        for(i = 0; i < events.length; i++){
            eventInfo = events[i];
            element = document.querySelector(eventInfo.selector);
            if (element === null) {
                Log.warn("element " + eventInfo.selector + " not found");
            } else if (eventInfo.events.length === 0) {
                Log.warn("element " + eventInfo.selector + " has no events to bind");
            } else {
                for(j = 0; j < eventInfo.events.length; j++){
                    eventType = eventInfo.events[j];
                    element.npawEventInfo = eventInfo;
                    element.npawEventType = eventType;
                    element.addEventListener(eventType, (function(eventData) {
                        var currentEventInfo = eventData.currentTarget.npawEventInfo;
                        var currentEventType = eventData.currentTarget.npawEventType;
                        this._elementEvent(currentEventInfo, currentEventType, eventData);
                    }).bind(this));
                }
            }
        }
    },
    /**
      * Tracks an event after a monitored element event has been triggered.
      * @param {Object} eventInfo
      * @param {string} eventType type of the triggered event (click...).
      * @param {Object} eventData additional event data supplied by the event listener.
      * @private
      */ _elementEvent: function _elementEvent(eventInfo, eventType, eventData) {
        if (this._fireEvent) {
            this._fireEvent(eventInfo.name, eventType, {
                uiElement: eventInfo.name,
                eventName: eventInfo.name
            });
        } else {
            Log.warn("Cannot trigger event since no handler has been provided");
        }
    }
});
module.exports = YouboraProductAnalyticsConfig;


/***/ }),

/***/ 7255:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var Log = __webpack_require__(39610);
var YouboraObject = __webpack_require__(831);
var YouboraProductAnalyticsUserState = YouboraObject.extend(/** @lends youbora.ProductAnalyticsUserState.prototype */ {
    // ------------------------------------------------------------------------------------------------------------------------------
    // INITIALIZATION
    // ------------------------------------------------------------------------------------------------------------------------------
    /**
     * This class handles Product Analytics user state management.
     *
     * @param {number} dimension Custom dimension where to store the user state.
     * @param {number} interval Interval (in ms) to transition from active to passive state.
     * @param {function} fireAdapterEvent Handler for firing adapter events
     * @param {function} pluginOptionsHandler Handler for setting plugin options
     *
     * @constructs youbora.ProductAnalyticsUserState
     * @extends youbora.Object
     * @memberof youbora
     */ constructor: function constructor(dimension, interval, fireAdapterEvent, pluginOptionsHandler) {
        if (typeof fireAdapterEvent !== "function") {
            Log.warn("Fire Adapter Event unset");
            fireAdapterEvent = null;
        }
        if (typeof pluginOptionsHandler !== "function") {
            Log.warn("Plugin Options Handler unset");
            pluginOptionsHandler = null;
        }
        if (typeof dimension !== "number" || dimension < 1 || dimension > 9) {
            dimension = 9;
        }
        if (typeof interval !== "number") {
            interval = 30000;
        }
        this._fireAdapterEvent = fireAdapterEvent;
        this._pluginOptionsHandler = pluginOptionsHandler;
        this._dimension = "content.customDimension." + dimension;
        this._timerId = null;
        this._timerInterval = interval;
        this._started = false;
        /*
      We must set state (customDimension) at the very beginning. Otherwise, customDimension will have "unknown" value during the time
      between page load and player first start.
      */ this._storeState(YouboraProductAnalyticsUserState.States.PASSIVE);
    },
    /**
      * Release resources
      */ dispose: function dispose() {
        this._timerStop();
        this._started = false;
    },
    // ------------------------------------------------------------------------------------------------------------------------------
    // STATE MANAGEMENT
    // ------------------------------------------------------------------------------------------------------------------------------
    /**
      * Set active state
      * @param {string} eventName
      * @param {boolean} playerStarted
      */ setActive: function setActive(eventName) {
        var state = YouboraProductAnalyticsUserState.States.ACTIVE;
        if (this._state !== state) {
            this._fireEvent(state, eventName);
            this._storeState(state);
        }
        this._timerStart();
    },
    /**
      * Fire switch state event
      * @private
      */ _fireEvent: function _fireEvent(state, eventName) {
        var dimensions;
        Log.notice("User changing from state " + this._state + " to " + state);
        dimensions = {
            newState: state,
            triggerEvent: eventName,
            stateFromTo: this._state + " to " + state
        };
        // Fire the event
        if (this._fireAdapterEvent) {
            switch(state){
                case YouboraProductAnalyticsUserState.States.ACTIVE:
                    this._fireAdapterEvent("Content Playback State Switch to Active", dimensions);
                    break;
                case YouboraProductAnalyticsUserState.States.PASSIVE:
                    this._fireAdapterEvent("Content Playback State Switch to Passive", dimensions);
                    break;
            }
        } else {
            Log.warn("Cannot fire user state event since handler is unavailable");
        }
    },
    /**
      * Store state
      * @param {string} state
      * @private
      */ _storeState: function _storeState(state) {
        var options;
        this._state = state;
        options = {};
        options[this._dimension] = this._state;
        if (this._pluginOptionsHandler) {
            this._pluginOptionsHandler(options);
        } else {
            Log.warn("Cannot store user state since handler is unavailable");
        }
    },
    // ------------------------------------------------------------------------------------------------------------------------------
    // TIMER MANAGEMENT
    // ------------------------------------------------------------------------------------------------------------------------------
    /**
      * Starts interaction monitor timer
      * @private
      */ _timerStart: function _timerStart() {
        var state = YouboraProductAnalyticsUserState.States.PASSIVE;
        this._timerStop();
        this._timerId = setTimeout((function() {
            this._fireEvent(state, "timer");
            this._storeState(state);
        }).bind(this), this._timerInterval);
    },
    /**
      * Stops interaction monitor timer
      * @private
      */ _timerStop: function _timerStop() {
        if (this._timerId) {
            clearTimeout(this._timerId);
            this._timerId = null;
        }
    }
}, /** @lends youbora.ProductAnalyticsUserState */ {
    // Static Members //
    /**
     * Interaction state enumeration
     * @enum
     * @event
     */ States: {
        ACTIVE: "active",
        PASSIVE: "passive"
    }
});
module.exports = YouboraProductAnalyticsUserState;


/***/ }),

/***/ 45193:
/***/ ((module, exports, __webpack_require__) => {

/* global atv */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
var YouboraObject = __webpack_require__(831);
var Chrono = __webpack_require__(92747);
var Timer = YouboraObject.extend(/** @lends youbora.Timer.prototype */ {
    /**
     * An Utility class that provides timed events in a defined time interval.
     *
     * @param {function} callback The callback to call every due interval.
     * Callback will receive lapsed ms between calls.
     * @param {int} [interval=5000] Milliseconds between each call.
     *
     * @constructs Timer
     * @extends youbora.YouboraObject
     * @memberof youbora
     */ constructor: function constructor(callback, interval) {
        this.callback = callback;
        this.interval = interval || 5000;
        this.isRunning = false;
        this._timer = null;
        this.chrono = new Chrono();
    },
    /**
     * Starts the timer.
     */ start: function start() {
        if (!this.isRunning) {
            this.isRunning = true;
            this._setTick();
        }
    },
    /**
     * Stops the timer.
     */ stop: function stop() {
        this.isRunning = false;
        if (this._timer) {
            try {
                clearTimeout(this._timer);
                this._timer = null;
            } catch (err) {
                if (typeof atv !== "undefined") {
                    atv.clearTimeout(this._timer);
                    this._timer = null;
                }
            }
        }
    },
    /**
     * Sets the next tick execution.
     * @private
     */ _setTick: function _setTick() {
        if (this.isRunning) {
            this.chrono.start();
            try {
                this._timer = setTimeout((function() {
                    this.callback(this.chrono.stop());
                    this._setTick();
                }).bind(this), this.interval);
            } catch (err) {
                if (typeof atv !== "undefined") {
                    this._timer = atv.setTimeout((function() {
                        this.callback(this.chrono.stop());
                        this._setTick();
                    }).bind(this), this.interval);
                }
            }
        }
    }
});
module.exports = Timer;


/***/ }),

/***/ 37280:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
var Log = __webpack_require__(39610);
/**
 * This static class provides utility methods.
 *
 * @class
 * @static
 * @memberof youbora
 */ var Util = {
    /**
     * Strip {protocol}:// and // from the begining of the string.
     *
     * @param {string} url
     * @returns {string} stripped url
     */ stripProtocol: function stripProtocol(url) {
        var strippedUrl = url;
        try {
            strippedUrl = url.replace(/^(.*?:\/\/|\/\/)/i, "");
        } catch (err) {
            Log.warn(err);
        }
        return strippedUrl;
    },
    /**
     * Adds specific protocol. ie: [http://]nqs.nice264.com
     *
     * @param {string} url Domain of the service. Without protocol. ie: 'nqs.nice264.com'.
     * @param {boolean|null} [httpSecure]
     * If true will add https, if false http.
     * Otherwise will add //
     * @return Return the complete service URL.
     */ addProtocol: function addProtocol(url, httpSecure) {
        var serviceUrl = "http://localhost/";
        try {
            serviceUrl = "http://" + url;
            if (httpSecure || typeof window !== "undefined" && window.location.protocol.indexOf("https") === 0) {
                serviceUrl = "https://" + url;
            } else if (typeof window !== "undefined" && window.location.protocol.indexOf("http") === 0) {
                serviceUrl = "//" + url;
            }
        } catch (err) {
            Log.warn(err);
        }
        return serviceUrl;
    },
    /**
     * Return n if it isn't NaN, negative, Infinity, null or undefined.
     * In any other case, return def.
     *
     * @param {mixed} n Number to be parsed.
     * @param {number} def Number to return if n is not correct.
     */ parseNumber: function parseNumber(n, def) {
        return !isNaN(n) && n >= 0 && n !== Infinity && n !== -Infinity && n !== null && typeof n !== "undefined" ? n : def;
    },
    /**
     * This utility method will add most of the HTML5 common event listeners to the player sent.
     * This common events will be listened: 'canplay', 'buffering', 'waiting', 'ended', 'play',
     * 'playing', 'pause', 'resume', 'error', 'abort', 'seek', 'seeking', 'seeked', 'stalled',
     * 'dispose', 'loadeddata', 'loadstart'.
     *
     * Events will be reported as DEBUG level messages.
     *
     * @param {object|function} o Object to attach the events.
     * @param {array} [extraEvents]
     * An array of extra events to watch. ie:  ['timeupdate', 'progress'].
     * If the first item is null, no common events will be added.
     * @param {function} [report] Callback function called to report events.
     * Default calls Log.debug()
     */ logAllEvents: function logAllEvents(o, extraEvents, report) {
        try {
            if (Log.logLevel <= Log.Level.DEBUG) {
                report = report || function(e) {
                    Log.debug("Event: " + e.type);
                };
                var playerEvents = [
                    "canplay",
                    "buffering",
                    "waiting",
                    "ended",
                    "play",
                    "playing",
                    "pause",
                    "resume",
                    "error",
                    "abort",
                    "seek",
                    "seeking",
                    "seeked",
                    "stalled",
                    "dispose",
                    "loadeddata",
                    "loadstart"
                ];
                if (extraEvents) {
                    if (extraEvents[0] === null) {
                        extraEvents.shift();
                        playerEvents = extraEvents;
                    } else {
                        playerEvents = playerEvents.concat(extraEvents);
                    }
                }
                for(var i = 0; i < playerEvents.length; i++){
                    if (typeof o === "function") {
                        o.call(window, playerEvents[i], report);
                    } else if (o.on) {
                        o.on(playerEvents[i], report);
                    } else if (o.addEventListener) {
                        o.addEventListener(playerEvents[i], report);
                    }
                }
            }
        } catch (err) {
            Log.error(err);
        }
    },
    /**
     * Builds a string that represents the rendition.
     *
     * The returned string will have the following format: <width>x<height>@bitrate<suffix?>.
     * If either the width or height are < 1, only the bitrate will be returned.
     * If bitrate is < 1, only the dimensions will be returned.
     * If bitrate is < and there is no dimensions, a null will be returned.
     * The bitrate will also have one of the following suffixes dependin on its
     * magnitude: bps, Kbps, Mbps
     *
     * @param {any} width The width of the asset. If only 1 argument is sent, it will be treated
     * as bitrate.
     * @param {any} height The height of the asset.
     * @param {any} bitrate The indicated bitrate (in the manifest) of the asset.
     * @returns {string} A string with the following format: <width>x<height>@<bitrate><suffix>
     */ buildRenditionString: function buildRenditionString(width, height, bitrate) {
        if (arguments.length === 1) {
            bitrate = width;
            width = null;
            height = null;
        }
        var ret = null;
        if (width && height) {
            ret = width + "x" + height;
        }
        if (typeof bitrate === "number" && !isNaN(bitrate) && bitrate >= 1) {
            if (ret) {
                ret += "@";
            } else {
                ret = "";
            }
            if (bitrate < 1e3) {
                ret += Math.round(bitrate) + "bps";
            } else if (bitrate < 1e6) {
                bitrate = Math.round(bitrate / 1e3);
                ret += bitrate + "Kbps";
            } else {
                bitrate = Math.round(bitrate / 1e4) / 1e2;
                ret += bitrate + "Mbps";
            }
        }
        return ret;
    },
    /**
     * Returns a params dictionary with the error values.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
     * @returns {Object} Key:value params.
     */ buildErrorParams: function buildErrorParams(code, msg, metadata, level) {
        var params = {};
        if (typeof code === "object" && code !== null) {
            params = code;
        } else {
            params.errorCode = code || "FAILURE";
            params.msg = msg || params.errorCode;
            params.errorMetadata = metadata;
            params.errorLevel = level;
        }
        return params;
    },
    /**
     * Returns a boolean indicating if more than the desired % of pixels are on screen.
     *
     * @param {Object} [player] Player object
     * @param {Number} [screenPercent] Threshold % of pixels on screen to return true.
     * @returns {Boolean} Its on screen or not.
     */ calculateAdViewability: function calculateAdViewability(player, screenPercent) {
        var isVisible = true;
        if (typeof window !== "undefined" && player && typeof player.getBoundingClientRect === "function") {
            var box = player.getBoundingClientRect();
            // 100% outside the window cases
            if (box.top >= window.innerHeight || box.bottom <= 0 || box.right <= 0 || box.left >= window.innerWidth) {
                isVisible = false;
            } else {
                var pixels = Math.trunc(box.height * box.width);
                var x1 = box.top > 0 ? box.top : 0;
                var x2 = box.bottom > window.innerHeight ? window.innerHeight : box.bottom;
                var y1 = box.left > 0 ? box.left : 0;
                var y2 = box.right > window.innerWidth ? window.innerWidth : box.right;
                var inScreenPixels = (y2 - y1) * (x2 - x1);
                // more than screenPercent of pixels (by default 50%)
                isVisible = inScreenPixels * 100 > pixels * (screenPercent || 50);
            }
        }
        return isVisible;
    },
    getMetricsFrom: function getMetricsFrom(op1, op2) {
        var metrics = op1 || op2;
        for(var metric in metrics){
            if (typeof metrics[metric] !== "object" || !metrics[metric].value) {
                var temporal = {};
                // temporal.oper = 'SUM' //default one?
                temporal.value = metrics[metric];
                metrics[metric] = temporal;
            }
        }
        return metrics;
    },
    // The following methods replace core js functionallity to ensure compatibility in old versions.
    assign: __webpack_require__(58122),
    isArray: __webpack_require__(9831)
};
module.exports = Util;


/***/ }),

/***/ 29379:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
module.exports = __webpack_require__(23610).version;


/***/ }),

/***/ 46847:
/***/ ((module, exports, __webpack_require__) => {

// No-Conflict

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
var previousYoubora = youbora // eslint-disable-line no-use-before-define
;
var youbora = {};
/**
 * This allows you to run multiple instances of YouboraLib on the same webapp.
 * After loading the new version, call `noConflict()` to get a reference to it.
 * At the same time the old version will be returned to Youbora.
 */ youbora.noConflict = function() {
    youbora = previousYoubora;
    return this;
};
// Info
youbora.VERSION = __webpack_require__(29379);
// Polyfills
youbora.polyfills = __webpack_require__(5571);
youbora.polyfills();
// Base Classes
youbora.Object = __webpack_require__(831);
youbora.Emitter = __webpack_require__(15885);
// Log
youbora.Log = __webpack_require__(39610);
youbora.Log.loadLevelFromUrl();
// General classes
youbora.Util = __webpack_require__(37280);
youbora.HybridNetwork = __webpack_require__(86940);
youbora.Chrono = __webpack_require__(92747);
youbora.Timer = __webpack_require__(45193);
youbora.Constants = __webpack_require__(56230);
// Comm classes
youbora.Request = __webpack_require__(57195);
youbora.Communication = __webpack_require__(30495);
// Resource Transform classes
youbora.Transform = __webpack_require__(51293);
youbora.ViewTransform = __webpack_require__(96726);
youbora.ResourceTransform = __webpack_require__(88584);
youbora.CdnParser = __webpack_require__(95627);
youbora.HlsParser = __webpack_require__(91513);
youbora.DashParser = __webpack_require__(41174);
youbora.OfflineParser = __webpack_require__(14219);
youbora.LocationheaderParser = __webpack_require__(74713);
// Plugin Classes
youbora.Options = __webpack_require__(50489);
youbora.Plugin = __webpack_require__(82241);
youbora.Storage = __webpack_require__(91305);
youbora.RequestBuilder = __webpack_require__(36582);
// Adapters
youbora.PlayheadMonitor = __webpack_require__(15501);
youbora.Adapter = __webpack_require__(28077);
youbora.adapters = {};
// Infinity
youbora.Infinity = __webpack_require__(11308);
// Detector classes
youbora.BackgroundDetector = __webpack_require__(64413);
youbora.DeviceDetector = __webpack_require__(1329);
youbora.UUIDGenerator = __webpack_require__(1879);
/**
 * Register the given adapter in <youbora>.adapters.
 *
 * @param {string} key Unique adapter identifier.
 * @param {youbora.Adapter} Adapter Adapter class.
 *
 * @memberof youbora
 */ youbora.registerAdapter = (function(key, Adapter) {
    this.adapters[key] = Adapter;
}).bind(youbora);
/**
 * Remove the given adapter in <youbora>.adapters.
 *
 * @param {string} key Unique adapter identifier.
 *
 * @memberof youbora
 */ youbora.unregisterAdapter = (function(key) {
    this.adapters[key] = null;
}).bind(youbora);
module.exports = youbora;


/***/ }),

/***/ 23610:
/***/ ((module) => {

module.exports = {"version":"6.8.67"};

/***/ })

}]);